<script>
    import Header from "./Header.svelte";
    import { onMount, onDestroy } from "svelte";
    import { writable } from 'svelte/store';
    import { fade } from "svelte/transition";
    import { loader } from './loader';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import Switch from './Switch.svelte';

    //import Minecraft from './universe/src/js/net/minecraft/client/Minecraft.js';
    //import * as aesjs from './universe/libraries/aes.js';

    //import maplibregl from './universe/libraries/maplibre-gl.js';
    //import maplibregl from './universe/libraries/maplibre-gl-unminified.js';
    //import maplibregl from './universe/libraries/maplibre-gl-1214.js';
    import maplibregl from './universe/libraries/maplibre-gl-mebots.js';

    import * as THREE from "./universe/libraries/three.module.js";
    //import * as THREE from "./universe/libraries/three.min.js";

    import { GLTFLoader } from "./universe/libraries/GLTFLoader.js";
    //import * as GLTFLoader from "./universe/libraries/GLTFLoader01.js";

	  import { replace, pop } from 'svelte-spa-router'
    //import * as THREE from 'three';
    import Stats from './universe/libraries/stats.module.js';
    //import MovingObjectPosition from "./universe/src/js/net/minecraft/util/MovingObjectPosition";
    //import { computeMikkTSpaceTangents } from "./universe/libraries/BufferGeometryUtils";
    //import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
    //import { World } from './world';

    //import BoundingBox from "./universe/src/js/net/minecraft/util/BoundingBox.js";

  function setCookie(cname, cvalue, exdays) {
		let d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

    let display_stats = false;
    let stats = null;

    if (display_stats) {
      stats = new Stats();
      document.body.appendChild(stats.dom);
    }

  //stats.domElement.style.position = 'absolute';
  //stats.domElement.style.right = 40;
  //stats.domElement.style.zIndex = 100;
  //stats.domElement.style.bottom = '700px';

  let content_loading = writable(true);
	let loading = writable(true);

  const power_avail = tweened(0, {
		duration: 600,
		easing: cubicOut
	});

  const me_power = tweened(0, {
		duration: 400,
		easing: cubicOut
	});
  me_power.set(1);

  const enemy_power = tweened(0, {
		duration: 400,
		easing: cubicOut
	});
  enemy_power.set(0);
  let enemy_mp = 100;

  let sceneOriginMercator = null;
  let earthCircumference = 40030228.8841;

  let touch_start_ts = 0;
  let touch_end_ts = 0;
  let throw_power_visible = false;

  let roll_stop_ts = 0;
  let roll_advance = 0;
  let rotation_advance = 0;

  //let _visited_color = 0x1bffe8;
  let _visited_color = 0x1bf9e2;
  let _visited_color_destroyed = 0x1bd9c2;
  let _selected_color = 0x15ecff;

  let game = null;
  let is_mining = 1;
  let is_jumping = 0;
  let is_building = 0;
  let is_fullsize = true;
  let is_throwing = false;
  let is_throwing_mode = false;
  let started_throwing = false;
  let draw_energy_colleted = 0;
  let draw_em_collected = '';
  let global_ener_collected = 0;
  let local_ener_collected = 0;
  let distance_bonus = 0;
  let distance_thrown = 0;
  let throw_start_x = 0;
  let throw_start_z = 0;

  let is_walking = true;
  let bounce_mebot = true;
  let is_battling = false;
  let battle_ending = false;
  let is_battle_action = false;
  let zooming_in = false;
  let zooming_out = false;
  let battle_on = false;
  let spinning_dir = 0;
  let target_orientation = 0;
  let prev_spin_dir = 0;
  let offsets = null;
  let map_bottom = 0;
  let is_centering = false;
  let setting_north = 0;
  let rgb_encoding = false;

  let show_chat = false;
  let sparkles = 0;
  let mebot_badges = '';

  let is_city = 0;
  let city_info = [];

  let show_mebots = false;
  let open_modes_menu = false;
  let open_extra_menu = false;
  let is_modal_open = false;
  let is_energy_bg = false;
  let is_artifact_bg = false;
  let modal_msg = '';
  let modal_action = null;
  let modal_action_msg = '';
  let mebots_loading = false;
  let mebots = [];
  let gltfs = [];

  let mebot_md = [];
	let is_loadings = [];
	let modes = [];

  let glb_items = [];
  let food_item = null;
  let visited_disk = null;
  let visited_disk_color = new THREE.Color()

  let auto_replenish = false;
  //  $: auto_battle, saveAutobattle();

  let spinner = 0;
  if (getCookie("map_spinner") != '') {
    spinner = getCookie("map_spinner");
    spinner = (Math.round(spinner * 100) / 100).toFixed(2);
    console.log('restoring map heading: ' + spinner)
  }

  let initial_pitch = 75;
  if (getCookie("map_pitch") != '') {
    console.log('restoring map pitch: ' + getCookie("map_pitch"))
    initial_pitch = getCookie("map_pitch");
  }

  let current_zoom = 17;
  if (getCookie("map_zoom") != '') {
    console.log('restoring map zoom: ' + getCookie("map_zoom"))
    current_zoom = getCookie("map_zoom");
  }

  let current_pitch = initial_pitch;
  let pitch_step = 0.18;
  let zoom_step = 0.004;
  let max_zoom = 18;
  let min_zoom = 16;
  let min_pitch = 0;
  let max_pitch = 80;

  let rotation_dir = 0;
  let smoothing = [];

  let is_running = 0;
  let map42 = null;
  let player_coords = [-74.0066, 40.7135];
  let player_loc = [];
  let model1 = null;
  let model2 = null;
  let forward_step = new THREE.Vector3(-0.014, 0, -0.01);
  //let forward_step = new THREE.Vector3(1, 1, 1);

  let skateboard = null;

  let is_skateboard = true;
  let is_crown = false;
  let is_zombie = true;
  let is_stats = true;
  let is_artifacts = true;
  let buildings_3d = false;
  let is_setup_spheres = true;
  let is_tunnel = false;
  let is_reverse_spinner = false;

  let prev_hover = null;

  let acceleration = 10.8;
  let bounce_distance = 12;
  let bottom_position_y = 43;
  let time_step = 0.02;
  // time_counter is calculated to be the time the ball just reached the top position
  // this is simply calculated with the s = (1/2)gt*t formula, which is the case when ball is dropped from the top position
  let time_counter = Math.sqrt(bounce_distance * 2 / acceleration);
  let initial_speed = acceleration * time_counter;

  let habitat_globe = new THREE.Object3D();
  let center_marker = null;
  let lookat_pointer = null;
  let marker = null;

  let initial_opacity = 0.2;
  let opacity_add = 1;
  let heart_scale = 0;


  let habitat_globes = [];
  let habitat_names = [];
  let habitat_globe_models = [];
  let habitat_globe_item_energy = [];
  let habitat_globe_models_existing = [];
  let habitat_globe_models_visited = [];
  let selected_disk = null;
  let selected_model = null;
  let habitat_globe_models_has_item = [];
  let mebots_here = [];
  let mebots_here_existing = [];
  let mebot_spheres = []
  let mebot_spheres_existing = [];
  let artifact_objects = [];
  let mebot_models = [];
  let mebot_n = 0;
  let me_object_n = 0;
  let mebot_pos = [];
  let frame = 0;

  let existing_models = [];
  let a_action_type = [];
  let a_weight = [];
  let a_blast = [];
  let a_blast_color  = [];
  let a_velocity = [];
  let cur_velocity = 100;
  let a_bounce = [];
  let cur_bounce = 100;

  let artifacts = [];
  let artifacts_tmp = [];
  let artifacts_n  = 0;
  let artifacts_uc = 0;
  let artifact_fetching = true;
  let show_artifacts_menu = false;
	let show_artifact_detail = -1;
	let artifact_page_size = 30;

  let aa_em = '';
  let aa_id = 0;
  let aa_name = '';
  let aa_blast_radius = 1;
  let aa_blast_color = 0x80ffff;
  let default_blast_color = 0x80ffff;
  let aa_default_instructions = 'Pick an item to throw! 🪨🎾🏈⚽🏀💣🧨💩';
  let aa_instructions = aa_default_instructions;

  let move_action = '🛑';
  let is_moving = false;

  if (is_moving == true) {
    move_action = '🛑';
  } else {
    move_action = '⬆️';
  }

  let camera = null;
  let map_scene = null;
  let map_projectile = null;
  let projectile_n = -1; //which sphere is the projectile
  let customLayer = null;
  let renderer_42 = null;

  //let globe_src = 'https://mebots.s3.amazonaws.com/a10a8377ffe80b1f915345421b07771e7e5775aeplain_500';
  let globe_src = '';

  let touchstartX = 0
  let touchendX = 0
  let touchstartY = 0
  let touchendY = 0
  let move_endY = 0;
  let tmp_move_endY = 0;
  let move_endX = 0;
  let tmp_move_endX = 0;
  let page_startY = 0;
  let page_height = 0;

  let x_playerMoveAngleSpeed = 0;
  let y_playerMoveAngleSpeed = 0;
  let steps_m = 0;
  let swipe_rotation = 0;
  let initial_swipe_rotation = 0;

  let zap_state = 0;
  let is_zapping = false;
  let obj_zapped = null;

	let journey = [];
	journey['info'] = '';
  journey['map42_info'] = '';
  journey['iup'] = 0;
	journey['info_full'] = '';
	journey['distance'] = '';
	journey['chat_cmd'] = '';
	journey['chat_cmd_id'] = '';
	journey['state_id'] = '';
	journey['mode_id'] = '';
	journey['n_items'] = '';
	journey['visited'] = '';
  journey['steps_left'] = 'no data';
  journey['can_build'] = 0;
  journey['to_hid'] = 0;
  journey['m_bearing'] = -1;
	let just_collected = false;
	let just_collected_visted = '';

  let embark = []
  embark['info'] = '';
  embark['steps_away'] = 0;

  let raycaster = new THREE.Raycaster();
  raycaster.near = -1;
  raycaster.far = 1e6;

  //const mouse = new THREE.Vector4(-1000, -1000, 1, 1);
  var mouse = new THREE.Vector2();
  let clicked_object = '';
  let mebot_clicked_url = '';
  let enemy_clicked_url = '';
  let display_clicked_object = '';
  let display_clicked_object_extra = '';
  let habitat_clicked_url = '';
  let artifact_clicked_object = '';
  let habitat_id = 0;

  let objects = [];
  let show_challenge = false;

  let l_vector = null;
  const glb_loader = new GLTFLoader;

  let enemy_old_pos = new THREE.Vector3();
  let enemy_old_rot = null;
  let my_old_pos = new THREE.Vector3();
  let my_old_rot = new THREE.Vector3();
  let enemy_object = null;
  let me_object = null;
  let mebot_bodies = []; //save body uuids, for color changing (and restoring)
  let mebot_hearts = [];
  let orig_color = '';
  let enemy_was_hit = false;
  let punched = false;
  let punched_flash = false;
  let force_of_punch = 0;
  let me_starting_rotation = 5.45;

  let claimed_habitat_id = -1;
	let claimed_habitat_error = '';
	let claimed_habitat_name = '';

  let zombie_action = [];
  let zombie_mixer = null;
  let mixer_clock = new THREE.Clock();
  let zombie_object = null;
  let heading_x = 0;
  let heading_z = 0;
  let is_zombie_walking = false;

  let prevTime = Date.now();
  let frames = 0
  let fps = 0;
  let frame_advance = 1;

  let item_found = null;
  let habitat_alert = null;

  let mebot_tile_tl = null;
  let mebot_tiles = [];
  let mebot_tile_locs = [];

  function update_frames() {
    frames++;
		var time = Date.now();
		if ( time >= prevTime + 1000 ) {
      fps =  Math.round(( frames * 1000 ) / ( time - prevTime ));
			prevTime = time;
			frames = 0;
		}
  }

  function checkDrag() {

    if (move_endY > map_bottom) {
      return;
    }

    //console.log(move_endY - touchstartY)
    if (y_playerMoveAngleSpeed < 0.1) {
      current_pitch = map42.getPitch();
      map42.setPitch(current_pitch - 0.5*(move_endY - touchstartY));
      touchstartY = move_endY
    }
  }

  function startedThrowing() {

    if (!map_projectile) {
      return;
    }

    if (mebot_md.power_avail <= 0) {
      return;
    }

    project_distance = 0;

    if (is_throwing_mode) {
      started_throwing = true;
    }
  }

  function checkProjectileDirection() {

    if (!is_throwing_mode) {
      return;
    }

    //if (started_throwing == true && move_endY > touchstartY) {
    if (started_throwing == true && project_distance > 0) {

      //Math.abs(touchstartY - move_endY)

      //const bearingRad = ( (map42.getBearing() - (move_endX-touchstartX)*(move_endY-touchstartY)/200  ) * Math.PI) / 180;
      const bearingRad = ( (map42.getBearing() - project_angle ) * Math.PI) / 180;
      let dir_vector = new THREE.Vector3(0, 0, 0);
      dir_vector.z = Math.cos(bearingRad);
      dir_vector.x = Math.sin(bearingRad);

      let throw_dist = project_distance;
      let distance_multi = 2; //stregth of throw (2-10)

      if (aa_id in a_weight && a_weight[aa_id] > 0) {
        distance_multi = distance_multi / (a_weight[aa_id]/100);

        console.log('WEIGHT (' + a_weight[aa_id] + ') ' + distance_multi)
        console.log('BLAST (' + aa_blast_radius + ') ')

      }

      if (aa_id in a_velocity && a_velocity[aa_id] > 0) {
        cur_velocity = a_velocity[aa_id]
        //console.log('Found VELOCITY: ' + cur_velocity)
      } else {
        cur_velocity = 100;
      }
      console.log('VELOCITY: ' + (cur_velocity/100))

      if (aa_id in a_bounce && a_bounce[aa_id] > 0) {
        cur_bounce = a_bounce[aa_id]
      } else {
        cur_bounce = 100;
      }
      console.log('BOUNCE: ' + (cur_bounce/100))

      // depending on artifact type

      //throw_dist = (throw_dist*throw_dist*0.1*1)/2

      console.log('THROW DISTANCE: ' + throw_dist)

      /*
      distance_bonus = Math.round(project_distance/20);
      distance_bonus--;
      distance_bonus = (distance_bonus*distance_bonus)*0.2;
      distance_bonus = Math.round(distance_bonus);
      distance_bonus -= 1;

      distance_bonus = Math.round(project_distance/100)
      console.log('BONUS: ' + distance_bonus)*/


      throw_ball(dir_vector, throw_dist, distance_multi)

      clear_touchpad_canvas();
    } else {
      clear_touchpad_canvas(true)
    }

    started_throwing = false;
  }

  function checkDirection() {

  //console.log('touchstartY: ' + touchstartY)

  if (started_throwing) {
    return;
  }

  if (touchstartY > map_bottom+200) {
    return;
  }

  if (is_battling) {
    //when battling ignore additional bottom part of the screen (where punch button is)
    if (touchstartY > map_bottom-200) {
      return;
    }
  }

  if (Math.abs(touchendY-touchstartY) > Math.abs(touchendX-touchstartX)) {
    if (touchendY > touchstartY) {

                        //move.copy(y_up);
//                        move.add( new THREE.Vector3( 0, (1) * Math.floor(Math.abs(touchendY-touchstartY)/2) / 100 * 0.03 , 0)  );

        y_playerMoveAngleSpeed = (-1) * Math.floor(Math.abs(touchendY-touchstartY)/2) / 100 * 7;
        //console.log('y move speed: ' + y_playerMoveAngleSpeed);

    } else if (touchendY < touchstartY) {

                        //move.copy(y_down);
//                        move.add( new THREE.Vector3( 0, (-1) * Math.floor(Math.abs(touchendY-touchstartY)/2) / 100 * 0.03 , 0)  );

        y_playerMoveAngleSpeed = Math.floor(Math.abs(touchendY-touchstartY)/2) / 100 * 7;
        //console.log('y move speed: ' + y_playerMoveAngleSpeed);

    }
  }
  
//  else {

    if (touchendX < touchstartX) {
        steps_m = Math.floor(Math.abs(touchendX-touchstartX));

                        //move.copy(x_right);
//                        move.add( new THREE.Vector3( (1) * Math.floor(Math.abs(touchendX-touchstartX)/2) / 100 * 0.03  , 0, 0)  );

        //x_playerMoveAngleSpeed = Math.floor(Math.abs(touchendX-touchstartX)/2) / 100 * 0.2;
        if (steps_m < 7) {
          x_playerMoveAngleSpeed = 1;
        } else {
          x_playerMoveAngleSpeed = (1) * Math.floor(Math.abs(touchendX-touchstartX)) ;
        }
        swipe_rotation = (-1) * x_playerMoveAngleSpeed * 0.5;
        //console.log('x move speed: ' + swipe_rotation);
        //o_x = playerMoveAngleSpeed;

    }
    if (touchendX > touchstartX) {
        steps_m = Math.floor(Math.abs(touchendX-touchstartX));

//                        move.add( new THREE.Vector3( (-1) * Math.floor(Math.abs(touchendX-touchstartX)/2) / 100 * 0.03  , 0, 0)  );

        //x_playerMoveAngleSpeed = (-1) * Math.floor(Math.abs(touchendX-touchstartX)/2) / 100 * 0.2;
        if (steps_m < 10) {
          x_playerMoveAngleSpeed = 1;
        } else {
          x_playerMoveAngleSpeed = (1) * Math.floor(Math.abs(touchendX-touchstartX)) ;
        }
        swipe_rotation = (1) * x_playerMoveAngleSpeed * 0.5;
        //console.log('x move speed: ' + swipe_rotation);

    }
//  }

  //rotate in opposite dir if swiping on top half of the screen

  if (is_reverse_spinner && page_startY < page_height/2 ) {
    //console.log('opposite lock!')
    swipe_rotation *= (-1)
  }

  initial_swipe_rotation = swipe_rotation
  //console.log('swipe: rotation: ' + swipe_rotation)
}

//** FOR DESKTOP */
document.addEventListener('mousedown', e => {

  touch_start_ts = new Date().getTime();
  //console.log('start trhowing: ' + touch_start_ts)
  //console.log('touch start ts: ' + touch_start_ts)

  if (!is_battling) {
    zooming_in = false;
    zooming_out = false;
  }
/*  prev_spin_dir = 0;
  swipe_rotation = 0;
  spinner = map42.getBearing()
  map42.rotateTo( (spinner) % 360, {duration: 0});
  map42.setBearing( (spinner) % 360 )
  console.log('cancelled swipe')*/

  touchstartX = e.screenX
  touchstartY = e.screenY

  page_startY = e.screenY - offsets.top; //TODO sometimes throws error
  //console.log('touch page Y: ' + page_startY + ' height: ' + page_height);

  checkTouch();
});

document.addEventListener('mousemove', e => {

  tmp_move_endX = Math.round(e.pageX)
  tmp_move_endY = Math.round(e.pageY)

  if (started_throwing && !is_throwing) {

    if (tmp_move_endY < touchpad_offset_y+touchpad_canvas.height) {
      move_endY = tmp_move_endY;
    }

    if ( tmp_move_endX > (touchpad_offset_x + touchpad_canvas.width/2 - 300) && tmp_move_endX < (touchpad_offset_x + touchpad_canvas.width/2 + 300) ) {
      move_endX = tmp_move_endX;
    }

    update_touchpad_canvas()
  }
  //console.log(move_endX + ':' + move_endY)
});

document.addEventListener('mouseup', e => {

  touch_end_ts = new Date().getTime();
  //console.log('end trhowing: ' + touch_end_ts)

  if (!is_battling) {
    zooming_in = false;
    zooming_out = false;
  }

  touchendX = e.screenX
  touchendY = e.screenY
  checkDirection()

  checkProjectileDirection();
})

//** FOR TOUCH DEVICES */
document.addEventListener('touchstart', e => {
  //closeModal();

  touch_start_ts = new Date().getTime();
  //console.log('start trhowing: ' + touch_start_ts)
  //console.log('touch start ts: ' + touch_start_ts)

  if (!is_battling) {
    zooming_in = false;
    zooming_out = false;
  }
/*  prev_spin_dir = 0;
  swipe_rotation = 0;
  spinner = map42.getBearing()
  map42.rotateTo( (spinner) % 360, {duration: 0});
  map42.setBearing( (spinner) % 360 )
  console.log('cancelled swipe')*/

  touchstartX = e.changedTouches[0].screenX
  touchstartY = e.changedTouches[0].screenY

  page_startY = e.changedTouches[0].clientY - offsets.top; //TODO sometimes throws error
  //console.log('touch page Y: ' + page_startY + ' height: ' + page_height);

  checkTouch();
})

/* TEMP disable*/
document.addEventListener('touchmove', e => {

  //console.log(touchstartY)
  //move_endX = e.changedTouches[0].screenX
  //move_endY = e.changedTouches[0].screenY

  move_endX = Math.round(e.changedTouches[0].pageX)
  tmp_move_endY = Math.round(e.changedTouches[0].pageY)

  if (tmp_move_endY < touchpad_offset_y+touchpad_canvas.height) {
    move_endY = tmp_move_endY;
  }

  if (started_throwing && !is_throwing) {
    update_touchpad_canvas()
  }
  //onsole.log(move_endX + ':' + move_endY)
})

document.addEventListener('touchend', e => {

  touch_end_ts = new Date().getTime();
  //console.log('end trhowing: ' + touch_end_ts)

  if (!is_battling) {
    zooming_in = false;
    zooming_out = false;
  }

  touchendX = e.changedTouches[0].screenX
  touchendY = e.changedTouches[0].screenY
  checkDirection()

  checkProjectileDirection();

})

function cancel_touch() {

    //TO ADD REMOVAL of events

		//clearTimeout(timeout);
		//power.set(0);
    console.log('removing touch events');
		//document.removeEventListener('touchstart');
		//document.removeEventListener('touchmove');
    //document.removeEventListener('touchend');
};

/*
function CircleLineGeometry(
  radius,
  segments,
  thetaStart,
  thetaLength
) {
  const args = {
    radius: radius || 50,
    segments: segments || 8,
    thetaStart: thetaStart || 0,
    thetaLength: thetaLength || 2 * Math.PI
  };
  const geometry = new THREE.Geometry();
  const delta =
    (args.thetaStart + args.thetaLength - args.thetaStart) / args.segments;
  for (let i = 0; i <= args.segments; i += 1) {
    const angle = args.thetaStart + delta * i;
    const x = args.radius * Math.cos(angle);
    const y = args.radius * Math.sin(angle);
    geometry.vertices.push(new THREE.Vector3(x, y, 0));
  }
  return geometry;
}

function Pulse(radius, duration = 4000, autoStart = true) {
  THREE.Object3D.call(this);

  this.duration = duration;
  const segments = 32;
  const discColor = "rgb(162, 28, 175)";
  const lineColor = discColor;

  const discGeometry = new THREE.CircleGeometry(radius, segments);
  const discMaterial = new THREE.MeshLambertMaterial({
    side: THREE.DoubleSide,
    color: discColor,
    transparent: true,
    opacity: 0.8
  });
  this.disc = new THREE.Mesh(discGeometry, discMaterial);
  this.add(this.disc);

  const lineGeometry = new CircleLineGeometry(radius, segments);
  const lineMaterial = new THREE.LineBasicMaterial({
    color: lineColor,
    linewidth: 1,
    transparent: true,
    opacity: 1
  });
  this.line = new THREE.Line(lineGeometry, lineMaterial);
  this.add(this.line);

  if (autoStart) {
    this.start();
  }
}

Pulse.prototype = Object.assign(Object.create(THREE.Object3D.prototype), {
  constructor: Pulse,

  start() {
    this.started = new Date();
  },

  stop() {
    this.started = null;
  },

  update() {
    if (!this.started) {
      return;
    }
    const now = new Date();
    const timeElapsed = now - this.started;
    let percentElapsed = timeElapsed / this.duration;
    if (percentElapsed >= 1) {
      percentElapsed -= Math.floor(percentElapsed);
    }

    const opacity = 1 - percentElapsed;

    let scale = percentElapsed;
    if (scale <= 0) {
      scale = 0.001;
    }

    this.scale.set(scale, scale, scale);
    this.line.material.opacity = opacity;
    this.disc.material.opacity = opacity * 0.35;
  }
});

//let pulse = new Pulse(400, 4000, true);
//let pulseObj = window.tb
//              .Object3D({ obj: pulse, units: "meters" })
//              .setCoords([10.232191, 56.165543, 0]);
//pulseObj.setAnchor("bottom-left");
//https://codesandbox.io/s/vue-threebox-sample-8k7mz?file=/src/components/ThreeboxExample.vue:1298-1492

*/
	export let params = {};

	let dash_token = params.t;
	if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

  let mebot_id = getCookie('m_id');
  let mebot_img_url = getCookie("mebot_img_url");
  let my_mebot_img_url = mebot_img_url;
  let news_badge_n = getCookie("news_badge_n");

  let mebot_url;
  if (!mebot_url) {
    mebot_url = getCookie('mebot_img_url');
  }

  let h_id = params.h_id;
  //globe_src = 'https://mebots.s3.amazonaws.com/' + h_id + '.png';
  globe_src = 'https://mebots.s3.amazonaws.com/' + h_id + '.png';
  let mebot_loc_id = params.m_loc_id;
  if (mebot_loc_id == '') {
    mebot_loc_id = 0;
  }

  //if (mebot_loc_id > 0) {
  //  mebot_id = mebot_loc_id;
  //}

  async function saveWorldBlocks(blocks) {

    //let block = Object.assign({}, blocks)
    let block = blocks[0]

  	const res = await fetch(
			"https://api.forever.today/?method=save_world_blocks",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					blocks: block
				}),
			}
	  );

    console.log(block)
    //console.log(Reflect.ownKeys(blocks).length);

		const json = await res.json();
	}

    /*
let stats = new Stats();
document.body.appendChild(stats.dom);

var requestId;

// Renderer setup
let renderer = new THREE.WebGLRenderer();
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setClearColor(0x80a0e0);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
let land42 = document.body.appendChild(renderer.domElement);

// Scene setup
let scene = new THREE.Scene();
scene.fog = new THREE.Fog(0x80a0e0, 50, 75);

//setupUI(world, player, physics, scene);
setupLights();
animate();

onDestroy(() => {
    console.log('world being destroyed...')
    player.cleanup();

        window.cancelAnimationFrame(requestId);
        document.body.removeChild(land42);
        world.disposeChunks();

        physics = null;
        player = null;
        world = null;
        renderer = null;
        scene = null;
        //orbitCamera = null;
        console.log(physics);

    console.log('destroyed');
});
*/

function changePov() {
  if (game != null) {
    //game.toggle3RDPsersonView();
  }
}

function attackEnemy() {

  //console.log('enemy was hit')
  enemy_was_hit = true;
  punched = true;
}

function jumpOn() {
  if (game != null) {
    game.setJumpingOn();
    is_mining = 0;
    is_building = 0;
    is_jumping = 1;
  }
}

function mineOn() {
  if (game != null) {
    game.setMiningOn();
    is_jumping = 0;
    is_mining = 1;
    is_building = 0;
  }
}

async function buildOn() {

  is_building = 1;
  console.log('building')
  await processClaimAction();
  refreshSparkles();
  is_building = 0;
}

function ZoomIn() {

//  if (!zooming_out) {
//    zooming_in = true;
//  }
  zooming_in = true;
  zooming_out = false;

  max_zoom = 18;
  pitch_step = 0.9;
  zoom_step = 0.02;
}

function ZoomOut() {

//  if (!zooming_in) {
//    zooming_out = true;
//  }
  zooming_out = true;
  zooming_in = false;

  pitch_step = 0.9;
  zoom_step = 0.02;
}

function toggleMove() {

  return;

  /*
  is_moving = !is_moving;

  map42.setCenter( player_coords );

  if (is_moving) {
    player_coords[0] += 0.002;
    player_coords[1] -= 0.004;
  } else {
    player_coords[0] -= 0.002;
    player_coords[1] += 0.004;
  }

  current_zoom = map42.getZoom();

  map42.flyTo({

    center: player_coords,
    //bearing: 0,
    zoom: current_zoom,
    speed: 0.2, // make the flying slow
    curve: 1, // change the speed at which it zooms out
    easing (t) {
      return t;
    },

    essential: true
  });
  */

  //map42.setCenter( player_coords );

  if (game != null) {

    is_moving = !is_moving;
    game.setMoving(is_moving);

    if (is_moving == true) {
      move_action = '🛑'
    } else {
      move_action = '⬆️'
    }
  }
}

async function add_habitats_to_scene(scene) {

  if (scene != null) {

  let n = 0;
  for (const globe of habitat_globes) {

      if (!(habitat_globe_models_existing.includes(globe.src))) {
        //console.log(globe.src)

        //console.log(habitat_globe_models[globe.src])
        habitat_globe_models[globe.src].position.set(parseFloat(globe.e), 0, parseFloat(globe.n));
        //console.log(globe.e + ':' + globe.n);
        /*
        const sphere_location = new maplibregl.LngLat(parseFloat(globe.lon), parseFloat(globe.lat));
        const sphere_mer = maplibregl.MercatorCoordinate.fromLngLat(sphere_location);
        const {dEastMeter: model1east, dNorthMeter: model1north} = calculateDistanceMercatorToMeters(sceneOriginMercator, sphere_mer);
        habitat_globe_models[n].position.set(model1east, 0, model1north);
        */

        scene.add(habitat_globe_models[globe.src]);
        habitat_globe_models_existing.push(habitat_globe_models[globe.src].name);
        n++;
      } else {
        //console.log('skipping')
      }
  }

  }
  //console.log(habitat_globe_models_existing)
}

async function remove_old_habitats_from_scene(scene) {

}

function visit_habitat(model_src, habitat_name) {

  if ( !(model_src in habitat_globe_models_visited) ) {

    let color = _visited_color;
    if ( objects[habitat_names[model_src]].state >= 2 ) {
      color = _visited_color_destroyed;
    }

    const disk_geo = new THREE.CylinderGeometry(70, 70, 2, 32);
    const disk_mat = new THREE.MeshBasicMaterial( {color, opacity: 1} );
    const disk = new THREE.Mesh(disk_geo, disk_mat);
    disk.name = habitat_name;
    habitat_globe_models[model_src].add(disk);

    habitat_globe_models_visited[model_src] = habitat_name;
    console.log('added visited ring!')

    objects[habitat_names[model_src]].visited_disk = disk;
  }
}

function select_habitat(model, habitat_name, planet_src) {

  const disk_geo = new THREE.CylinderGeometry(90, 90, 5, 32);
  const disk_mat = new THREE.MeshBasicMaterial( {color: _selected_color, opacity: 1} );
  selected_disk = new THREE.Mesh(disk_geo, disk_mat);
  //disk.name = habitat_name;
  selected_disk.name = 'selected_object'
  selected_model = model;

  objects['selected_object'] = {
      type: 'ring',
      name: habitat_name,
      texture: ''
  }

  if (planet_src in habitat_globe_models_has_item && habitat_globe_models_has_item[planet_src] != '') {
    display_clicked_object_extra = habitat_globe_models_has_item[planet_src];
  }

  model.add(selected_disk);
}

function unselect_habitat() {

  if (selected_model != null) {
    var selectedObject = selected_model.getObjectByName('selected_object');
    if (selectedObject != null) {
      selected_model.remove(selectedObject);
      selected_model = null;
    }
  }

  habitat_clicked_url = '';
  display_clicked_object_extra = '';

/*  var selectedObject = map_scene.getObjectByName('selected_object');
  console.log(selectedObject)
  map_scene.remove( selected_disk );

  if (selectedObject != null) {
    selected_model.remove( selectedObject );
  }*/

}

function add_habitat_item(model, habitat_name, item) {

  if (item.type in glb_items) {
    const new_item = glb_items[item.type].scene.clone()
    setName(new_item, item.model_desc);

    if (item.t_id == 10) {
      objects[habitat_name].artifact = new_item;
      console.log('added artifact flag to: ' + habitat_name)
    } else {
      //energy items
      food_item = new_item;
      objects[habitat_name].item = new_item;
      console.log('added item to: ' + habitat_name)
    }

  /*
  //deep copy materials w/in that new mebot model (if we want to change colors to the materials, etc)
  mebot_models[mebot_n].traverse(function(object) {
    if ( object.isMesh ) {
      object.material = object.material.clone();
    }
  });*/

  //mebot_models[mebot_n].position.set(parseFloat(mebot.e), model1up, parseFloat(mebot.n));
  //item.name = habitat_name;

  //objects[item_name] = {
  //  type: 'artifact',
  //  name: null,
  //}

    model.add(new_item);
  }
}

function add_habitat_artifact(model, habitat_name, item) {

  const artifact_flag = glb_items['artifact_flag'].scene.clone()
}

function has_entity_collided(projectile) {

  //console.log('testing entity col')
  let ent_col = null;
  //console.log(habitat_globe_models)

  spheres.forEach( sphere => {

    if (sphere.state == 1 && sphere.entity_type == 1) {

      if (Math.abs(projectile.x - sphere.mesh.position.x) < ( 55*aa_blast_radius + lolipop)
    && Math.abs(projectile.z - sphere.mesh.position.z) < (  55*aa_blast_radius + lolipop)) {
        console.log('entity hit ' + sphere)
        ent_col = sphere;

        sphere.mesh.visible = false;
        sphere.state = 2;
      }
    }

  });

  return ent_col;

}

async function destroy_habitat(col_habitat) {

  if (col_habitat in habitat_names) {

  let habitat_name = habitat_names[col_habitat]
  let habitat_id = objects[habitat_name].hid

  //mark habitat as completely destroyed
  const res = await fetch(
    "https://api.forever.today/?method=update_habitat_state",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        habitat_id
      }),
    }
  );

  }
}

function explode_habitat(col_habitat) {
  let habitat_name = '';

  update_habitat_texture(col_habitat, 'https://mebots.s3.amazonaws.com/broken_habitat6_500.png', 2)

  let local_ener_collected = 5;
  let empty_hab_factor = 1; //this is one becuse if there's no item -1 will be subtracted (visit_habitat: api) from bonus
  if (col_habitat in habitat_globe_item_energy && habitat_globe_item_energy[col_habitat].e > 0) {
    local_ener_collected = habitat_globe_item_energy[col_habitat].e;

    if (local_ener_collected > global_ener_collected) {
      draw_em_collected = habitat_globe_item_energy[col_habitat].em;
    }
    //clear energy from this habitat
    habitat_globe_item_energy[col_habitat].e = -1;
    empty_hab_factor = 0; //energy is accounted for by just visiting habitat
  }

  distance_bonus = distance_thrown/100
  distance_bonus = Math.round(distance_bonus);
  distance_bonus--;

  if (distance_bonus < 1) {
    distance_bonus = 1;
  }

  if (local_ener_collected > global_ener_collected) {
    global_ener_collected = local_ener_collected;
    draw_energy_colleted = distance_bonus*local_ener_collected;
  }

  habitat_name = habitat_names[col_habitat]
  console.log( objects[habitat_name].hid + ' : ' + habitat_name );

  if (local_ener_collected > 0) {
    _increase_power(local_ener_collected*(distance_bonus+empty_hab_factor-1))
  }

  visit_and_pickup(col_habitat, habitat_name, objects[habitat_name].hid, local_ener_collected, distance_bonus+empty_hab_factor, distance_thrown)
  //habitat_globe_models[col_habitat].visible = false;
}

function has_habitat_collided(projectile) {

  //console.log('testing hab col')
  let hab_col = null;
  //console.log(habitat_globe_models)

  for (const globe of Object.keys(habitat_globe_models)) {
    //console.log(habitat_globe_models[globe].position)

    //check if not destroyed already
    if (objects[habitat_names[globe]].state < 3) {

    if (Math.abs(projectile.x-habitat_globe_models[globe].position.x) < (35*aa_blast_radius + lolipop)
    && Math.abs(projectile.z-habitat_globe_models[globe].position.z) < (35*aa_blast_radius + lolipop)) {

      //console.log('HITT: ' + habitat_names[globe])

      if (objects[habitat_names[globe]].state == 1) {
        console.log('hit ' + globe)
        hab_col = globe;

        distance_thrown = Math.sqrt( ((habitat_globe_models[globe].position.x - throw_start_x)**2) + ((habitat_globe_models[globe].position.z - throw_start_z)**2) )
        distance_thrown = Math.round( distance_thrown );

        explode_habitat(globe)
      } else {
        //destroy completely
        update_habitat_texture(globe, 'https://mebots.s3.amazonaws.com/broken_habitat7_complete_500.png', 3)
        console.log('destroyed completely')
        destroy_habitat(globe);
        explodito(habitat_globe_models[globe].position, 1, default_blast_color);
      }
    }

    }

  }

  if (hab_col == null && lolipop <= 15) {
    //console.log('lolipop: ' + lolipop)
    lolipop++;
  }

  return hab_col;
}

async function load_habitats_models() {

  for (const globe of habitat_globes) {

    if (!(habitat_globe_models_existing.includes(globe.src))) {

      //console.log('loading ' + globe.hid + ' STATE ' + globe.state)
      habitat_globe = await load_habitat_globe(globe.src, globe.hid, globe.name, globe.v, globe.o, globe.item, globe.is_hit, globe.state)
      habitat_globe.scale.set(0.4, 0.4, 0.4);
      habitat_globe_models[globe.src] = habitat_globe;

    } else {

      //check if visited (and not yet visible as visited on map)
      if (globe.v == 1) {
        visit_habitat(globe.src, globe.name);
      }

      /*if (globe.item != '' && !habitat_globe_models_has_item.includes(globe.src)) {

        add_habitat_item(habitat_globe_models[globe.src], globe.name, globe.item);
        habitat_globe_models_has_item.push(globe.src);
        console.log('added habitat item')
      }*/

      //console.log('skipping')
    }
  }

  await load_habitats_items();
  add_habitats_to_scene(map_scene);
  //console.log(habitat_globe_models)
}

async function load_habitats_items() {
  for (const globe of habitat_globes) {
    if (globe.item.type != '' && !(globe.src in habitat_globe_models_has_item) ) {
      add_habitat_item(habitat_globe_models[globe.src], globe.name, globe.item);

      habitat_globe_item_energy[globe.src] = {'e': 0, 'em': ''}
      //special case for artifacts
      if (globe.item.t_id == 10) {
        habitat_globe_models_has_item[globe.src] = globe.item.model_desc;
      } else {
        //energy items
        habitat_globe_models_has_item[globe.src] = globe.item.model_desc + '&nbsp; <span style="color: green; font-size: 12px;">+'+ globe.item.e + '⚡</span>'
        habitat_globe_item_energy[globe.src].e = globe.item.e;
        habitat_globe_item_energy[globe.src].em = globe.item.em;
      }
      console.log('added habitat ' + globe.item + ' item')
    }
  }
}

async function claimHabitat() {

		claimed_habitat_error = '';

		const res = await fetch(
			"https://api.forever.today/?method=claim_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
				}),
			}
		);

		const json = await res.json();
		claimed_habitat_name = json.data.habitat.name;
		claimed_habitat_id = json.data.habitat.id;
		if (claimed_habitat_id == -1) {
			claimed_habitat_error = json.data.habitat.error;
		}
}

async function processClaimAction() {

		await claimHabitat();

		if (claimed_habitat_id > 0) {

      //refresh map
      //saveMapState()
			//replace('/go/2/map42/' + mebot_loc_id);

      await get_habitats();
      await load_habitats_models();
      load_mebot_models();

/*		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Congrats!</b><br><br>
		Habitat location successfully setup. 📍<br><br> You are the Mayor of <b>` + claimed_habitat_name + `</b> habitat now.  👑 </b><br><br>
		<br>
		</center>`, closeButton: true, action_button: 'Nice!' }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 7000);*/

		} else {

      console.log('error')
      //error
		/*modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
		<b>Uh oh!</b><br><br>
		There was a problem setting up habitat:<br><br>
		<i>` + claimed_habitat_error + `</i>
		<br><br>
		</center>`, closeButton: true, action_button: 'Ok' }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 20000);*/

		}
}

async function load_mebot_models() {

  bounce_mebot = true;
  let m_name = '';
  for (const mebot of mebots_here) {

    //let model1up = 33;
    let model1up = 43;
    if (mebot.mid >= 0 && !(mebots_here_existing.includes(mebot.mid))) {

      //console.log('!! adding mebot: ' + mebot.mid)

      if (mebot.mid == 0) {

        if (!('map_marker' in glb_items)) {
          console.log('LOADING MISSING MARKER')
          glb_items['map_marker'] = await glb_loader.loadAsync('https://mebots.s3.amazonaws.com/map_marker.glb');
          glb_items['map_marker'].scene.scale.set(10, 10, 10);
          glb_items['map_marker'].scene.position.set(0, 60, 0);
          glb_items['map_marker'].scene.rotation.y = 4;
          setName(glb_items['map_marker'].scene, 'You are here');
        }

        console.log('adding map marker')
        mebot_models = [...mebot_models, glb_items['map_marker'].scene.clone()]
        //model1up = 40;
        model1up = 43;

        bounce_mebot = false;
      } else {
        //model2.rotation.y += Math.PI*0.2*mebot_n;
        //model2.rotation.y += Math.PI*0.2;
        if (mebot.io == 1) {
          me_object_n = mebot_n; //ego mebot
          console.log('EGO n: ' + me_object_n)
          mebot_models = [...mebot_models, model1.clone()]
          //mebot_models = [...mebot_models, setMebotModel('mebot_' + mebot.mid, mebot.texture)]
          setMebotTexture('mebot_' + mebot.mid, mebot.texture)
        } else {
          mebot_models = [...mebot_models, model2.clone()]
          setMebotTexture('mebot_' + mebot.mid, mebot.texture)
        }

        mebot_models[mebot_n].rotation.y = Math.PI*0.2*mebot_n;
      }

      //deep copy materials w/in that new mebot model
      /* not needed now
      mebot_models[mebot_n].traverse(function(object) {
        if ( object.isMesh ) {
          object.material = object.material.clone();
        }
      });
      */

      //console.log(globe.n)
      mebot_models[mebot_n].position.set(parseFloat(mebot.e), model1up, parseFloat(mebot.n));

      mebot_pos[mebot_n] = [parseFloat(mebot.e), model1up, parseFloat(mebot.n)]

/*      if (mebot.mid >= 10000) {
        setOpacity(mebot_models[mebot_n], 0.3)
        //setColor(mebot_models[mebot_n], 0x4380B7)
        //setColor(mebot_models[mebot_n], 0x1bffe8);
        //setColor(mebot_models[mebot_n], 0x00d9ff);
        //setColor(mebot_models[mebot_n], 0x222222 + (375*50) );
        //setColor(mebot_models[mebot_n], 0x004eff);
        //setColor(mebot_models[mebot_n], 0x15ecff);
        setColor(mebot_models[mebot_n], 0x15acff);
        setName(mebot_models[mebot_n], 'mebot_' + mebot.mid)
        objects['mebot_' + mebot.mid] = {
          type: 'enemy',
          model: mebot_models[mebot_n],
          name: ' 👻 Mebot ',
          texture: mebot.texture,
          reverse_texture: mebot.reverse_texture
        }
      } else {*/

        if (mebot.mid >= 10000) {

          setOpacity(mebot_models[mebot_n], 0.3)
          setColor(mebot_models[mebot_n], 0x15acff);
          setName(mebot_models[mebot_n], ' 👻 Mebot ')

        } else {

          if (mebot.io == 0) {
            setInitialBodyColor('mebot_' + mebot.mid, mebot_models[mebot_n], mebot.color.body, mebot.texture, mebot.io)
          } else {
            setInitialBodyColor('mebot_' + mebot.mid, mebot_models[mebot_n], 0xFFAE05, mebot.texture, mebot.io)
          }

          setName(mebot_models[mebot_n], 'mebot_' + mebot.mid)
        }

        if (mebot.mid == 0) {
          objects['mebot_' + mebot.mid] = {
            type: 'friend',
            model: mebot_models[mebot_n],
            name: ' You are here 📍',
            texture: mebot.texture,
            reverse_texture: mebot.reverse_texture
          }
        } else {
          if (mebot.io == 0) {
            //for now set all mebots as ghost (transparent)
            setOpacity(mebot_models[mebot_n], 0.3)
            setColor(mebot_models[mebot_n], 0x15acff);
          }
          if (mebot.mid >= 10000) {
            m_name = ' 👻 Mebot ';
            if (mebot.io == 1) {
              m_name = ' Your 👻 ';
            }
          } else {
            m_name = 'Mebot #' + mebot.mid
          }
          objects['mebot_' + mebot.mid] = {
            type: (mebot.io == 0) ? 'other_mebot' : 'friend',
            model: mebot_models[mebot_n],
            name: m_name,
            texture: mebot.texture,
            reverse_texture: mebot.reverse_texture
          }
        }

      map_scene.add(mebot_models[mebot_n]);

      if (mebot.io == 1) {
        //set center position marker below the mebot
        center_marker = new THREE.Object3D();
        const disk_geo = new THREE.CylinderGeometry(20, 20, 1, 32);
        const disk_mat = new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.2, transparent: true} );
        const disk = new THREE.Mesh(disk_geo, disk_mat);
        marker = disk;
        center_marker.add(disk);
        center_marker.position.set(parseFloat(mebot.e), 2, parseFloat(mebot.n));
        map_scene.add(center_marker);

        //marker where mebot is looking at (lookAt direction)
        //const lookat_marker = new THREE.Object3D();
        const lookat_geo = new THREE.CylinderGeometry(4, 4, 1, 8);
        const lookat_mat = new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 1, transparent: false} );
        lookat_pointer = new THREE.Mesh(lookat_geo, lookat_mat);
        lookat_pointer.position.set(parseFloat(mebot.e)-0, 2, parseFloat(mebot.e)-50);
        //lookat_marker.add(lookat);
        map_scene.add(lookat_pointer);

        //add horizon globe
        var radius = 1200;
        var radialSegments = 32;
        var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
        //var hemiSphereGeom = new THREE.CylinderGeometry(50, 50, 1, 6);

        //*** three js sphere with thick wall for fog effect
        /*const sphereGeometry = new THREE.SphereGeometry(1200, 32, 32);
        const sphereMaterial = new THREE.ShaderMaterial({
  vertexShader: `
    uniform float radius;
    uniform float wallThickness;
    void main() {
      vec3 pos = position;
      pos.z += wallThickness * (1.0 - cos(acos(length(pos) / radius)));
      gl_Position = projectionMatrix * viewMatrix * vec4(pos, 1.0);
    }
  `,
  fragmentShader: `
    uniform float fogDistance;
    uniform float fogIntensity;
    void main() {
      float distance = length(gl_FragCoord.xyz);
      float fogFactor = smoothstep(fogDistance - 0.1, fogDistance + 0.1, distance);
      gl_FragColor = vec4(1.0, 1.0, 1.0, fogFactor * fogIntensity);
    }
  `,
  uniforms: {
    radius: { value: 1200 },
    wallThickness: { value: 1 },
    fogDistance: { value: 5000.0 },
    fogIntensity: { value: 0.5 }
  }
});*/

        const material = new THREE.MeshBasicMaterial( {
          //map: texture,
          opacity: 0.4,
          color: 0x999999,
          //overdraw: 0.5,
          transparent: true,
          side: THREE.DoubleSide,
        } );

        //const material = new THREE.MeshBasicMaterial( { color: 0x0000ff } );
        //const horizon_sphere = new THREE.Mesh( sphereGeometry, sphereMaterial );

        const horizon_sphere = new THREE.Mesh( hemiSphereGeom, material );
        map_scene.add(horizon_sphere);

        const hexRadius = 40;
        // Horizontal distance between hex centers = sqrt(3) * radius
        //const hexWidth_o = Math.sqrt(3) * hexRadius;
        //console.log('HEX WIDTH ' +  hexWidth_o)
        //const hexWidth = 70;

        //2076275.0377622
        ///
        //69.28203230275508417
        //29968.44879909266751

        //2076116.1054199
        ///
        //69.28203230275508417
        //29966.154808327421441


        // Vertical distance between adjacent rows of hex centers = 1.5 * radius

        //const hexWidth = 69.28203230275508417;
        const hexWidth = 69.282032302755
        //const hexWidth = 70;
        const hexHeight = 1.5 * hexRadius;
        
        const rows = 20;
        const cols = 20;
        // Calculate the top-left corner offset if we want to center the grid a bit
        // This is optional; you can adjust or remove it to place the grid differently.
        //const offsetX = (200 - (cols - 0.5) * hexWidth) / 2;
        //const offsetY = (200 - (rows * hexHeight)) / 2;
        let offsetX = mebot_tile_tl[0] //top left corner east
        //const offsetY = (-1)*mebot_tile_tl[1] //
        let offsetY = mebot_tile_tl[1] //top left corner north
        let tile_offsetX = mebot_tile_tl[2] // top left tile (from nexus)
        let tile_offsetY = mebot_tile_tl[3]

        console.log('top left tile: ' + offsetX + ' : ' + offsetY + ', e.n: ' + tile_offsetX + '.' + tile_offsetY)

/*        const nexus_lat = 40.723350109667;
        const nexus_lon = -73.988316542685;
        const nexusMercator = maplibregl.MercatorCoordinate.fromLngLat(new maplibregl.LngLat(nexus_lon, nexus_lat), 0);
        console.log('player coords: ' + player_coords[1] + ' : ' + player_coords[0] )
        const playerMercator = maplibregl.MercatorCoordinate.fromLngLat(new maplibregl.LngLat(player_coords[0], player_coords[1]), 0);
        const {dEastMeter: north_delta, dNorthMeter: east_delta} = calculateDistanceMercatorToMeters(nexusMercator, playerMercator);

        console.log(' Origin meter units: ' + sceneOriginMercator.meterInMercatorCoordinateUnits());
        console.log(' Internal meter units: ' + meterInMercatorCoordinateUnits());

        console.log(' north delta: ' + north_delta + ' east delta: ' + east_delta)
        let nexus_north_tiles = Math.floor(north_delta/hexHeight);
        let nexus_east_tiles = Math.floor(east_delta/hexWidth);
        offsetX = (nexus_east_tiles-10)*hexWidth - east_delta; // ~(-700 meters)
        offsetY = (nexus_north_tiles+10)*hexHeight - north_delta; // ~(+600 meters)
        tile_offsetX = nexus_east_tiles-10;
        tile_offsetY = nexus_north_tiles+10;

        offsetX += 15;*/

        console.log('LOCAL top left tile: ' + offsetX + ' : ' + offsetY + ', e.n: ' + tile_offsetX + '.' + tile_offsetY)
        let hexCount = 0;
        let totalHexes = 400;
        let isHexActive = false;

        // Loop through rows and columns
        for (let row = 0; row < rows; row++) {
          for (let col = 0; col < cols; col++) {
            // Stop once we’ve drawn 50 hexes
            if (hexCount >= totalHexes) break;

            // For odd rows (make sure the row num is global), shift the hex center by half a hexWidth
            const xOffset = ( (tile_offsetY-row) % 2) ? hexWidth / 2 : 0;
            const centerX = offsetX + col * hexWidth + xOffset; //going east (increment)
            const centerY = offsetY - row * hexHeight; //going south (decrement)

            isHexActive = false;
            if (Math.floor(Math.random() * 3 + 1) == 1) {
              isHexActive = true;
            }

            isHexActive = false;
            //check if there's collision with existing habitat
            //if (is_hexagon_collision(centerX, centerY)) {
            //  isHexActive = true;
            //}

            //if (row == 10 && col == 10) {
            //  console.log('** CENTER hex [' + hexCount + '] ' + centerX + ' : ' + centerY)
            //}

            //console.log('drawing hex at: ' + centerX + ' : ' + centerY)
            // Draw the individual hex
            drawHex(hexCount, centerX, centerY, hexRadius, isHexActive, tile_offsetX+col, tile_offsetY-row);
            hexCount++;
            //break;
          }
        }

        //add hexagon tiles

        /*const hex_mat_active = new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.5, transparent: true} );
        const hex_mat = new THREE.MeshBasicMaterial( {color: 0xd9d9d9, opacity: 0.5, transparent: true} );
        let hex1 = null;
        for (let i = 0; i < 6; i++) {

          var hex_geo = new THREE.CylinderGeometry(50, 50, 2, 6);
          if (i == 2) {
            hex1 = new THREE.Mesh(hex_geo, hex_mat_active);
          } else {
            hex1 = new THREE.Mesh(hex_geo, hex_mat);
          }
          hex1.position.set(parseFloat(mebot.e)-(i*64), 2, parseFloat(mebot.e)-(i*64));
          map_scene.add(hex1);

        }*/

      }

      mebots_here_existing.push(mebot.mid);
      //break;
      mebot_n++;
    } else {
      console.log('mebot already here, skipping')
    }
  }

  me_object = mebot_models[me_object_n];

  console.log('mebot bodies')
  console.log(mebot_bodies)
}

//check if there's a habitat globe here
function is_hexagon_collision(x, z) {

  //console.log('checking hex location: ' + x + ' : ' + z)
  let radius = 60;
  for (const globe of Object.keys(habitat_globe_models)) {
    //console.log(habitat_globe_models[globe].position)

    //console.log('testing globe position: ' + habitat_globe_models[globe].position.x + ' - ' + habitat_globe_models[globe].position.z)
    if (Math.abs(x-habitat_globe_models[globe].position.x) < (radius)
      && Math.abs(z-habitat_globe_models[globe].position.z) < (radius)) {
      //console.log('found!')
      return true;
    }
  }

  return false;
}

function destinationPoint(distance, bearing, radius=6371e3) {
        // sinφ2 = sinφ1⋅cosδ + cosφ1⋅sinδ⋅cosθ
        // tanΔλ = sinθ⋅sinδ⋅cosφ1 / cosδ−sinφ1⋅sinφ2
        // see mathforum.org/library/drmath/view/52049.html for derivation

        const δ = distance / radius; // angular distance in radians
        const θ = Number(bearing).toRadians();

        const φ1 = this.lat.toRadians(), λ1 = this.lon.toRadians();

        const sinφ2 = Math.sin(φ1) * Math.cos(δ) + Math.cos(φ1) * Math.sin(δ) * Math.cos(θ);
        const φ2 = Math.asin(sinφ2);
        const y = Math.sin(θ) * Math.sin(δ) * Math.cos(φ1);
        const x = Math.cos(δ) - Math.sin(φ1) * sinφ2;
        const λ2 = λ1 + Math.atan2(y, x);

        const lat = φ2.toDegrees();
        const lon = λ2.toDegrees();

        //return new LatLonSpherical(lat, lon);
}

function is_hexagon_claimed(id) {

  //console.log('testing tile: ' + id)
  //return null;

  if (id in mebot_tile_locs) {
    console.log('found tile: ' + mebot_tile_locs[id])
    return id
  }
  return null;

  let radius = 35;

  for (const tile of Object.keys(mebot_tile_locs)) {
    //console.log('testing? ' + tile.e + ' :: ' + tile.n)

    if (Math.abs(x-mebot_tile_locs[tile].e) < (radius)
      && Math.abs(z-mebot_tile_locs[tile].n) < (radius)) {
      //console.log('found!')

      return tile;
    }
  }

  return null;
}

function toggle_hexagon(hex_name) {

  console.log(objects[hex_name])
  //console.log(objects[hex_name].x)
  //console.log(objects[hex_name].z)

  //console.log(objects[hex_name].model.material.visible);
  //objects[hex_name].model.material.visible = !objects[hex_name].model.material.visible;
  //console.log(objects[hex_name].model.material.color.getHexString());
  if (objects[hex_name].model.material.color.getHexString() == '00d9ff'
   || objects[hex_name].model.material.color.getHexString() == 'd8d8d8') {
    //objects[hex_name].model.material.color.setHex( 0xd9d9d9 );
    //objects[hex_name].model.material.opacity = 0.2;
  } else {

    //make sure it's within claimable range
    //if ( Math.abs(0-objects[hex_name].x) < 105 && Math.abs(0-objects[hex_name].z) < 105 ) {
    if ( Math.sqrt( (objects[hex_name].x)**2 + (objects[hex_name].z)**2 ) < 150) {

      objects[hex_name].model.material.color.setHex( 0x00d9ff );
      //objects[hex_name].model.material.color.setHex( 0xffa500 );

      objects[hex_name].model.material.opacity = 0.9;
      //objects[hex_name].model.material.opacity = 1;
      //objects[hex_name].model.material.map = hex_texture;
      //objects[hex_name].model.material.map.needsUpdate = true;
      //objects[hex_name].model.material.side = THREE.DoubleSide;

      claim_tile(mebot_id, objects[hex_name].tile_id, objects[hex_name].x, objects[hex_name].z, objects[hex_name].tx, objects[hex_name].ty)
    }
  }
}

const hex_mat_active = new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.7, transparent: true} );
const hex_mat = new THREE.MeshBasicMaterial( {color: 0xd9d9d9, opacity: 0.2, transparent: true} );

let hex_texture_mat = null;
let hex_texture = null;
let texture_loader = new THREE.TextureLoader();

//texture_loader.load('textures/6a36854d793d2787f29c081a73593a8f93fae48a.png', function ( texture ) {
texture_loader.load('https://mebots.s3.amazonaws.com/mebot_1024_sample_2.png', function ( texture ) {
        //texture_loader.load(mebot_img_url, function ( texture ) {
          hex_texture = texture;
          hex_texture_mat = new THREE.MeshBasicMaterial( {
            map: texture,
            opacity: 1,
            color: 0xffffff,
            //overdraw: 0.5,
            transparent: true,
            side: THREE.DoubleSide,
          });
        });

function claim_tile(mebot_id, id, pos_x, pos_z, tx, ty) {

  console.log('mebot ' + mebot_id + ' claiming tile id [' + id + '] => ' + pos_x + ' : ' + pos_z + ' tile id: ' + tx + '.' + ty)
  fetch(
			"https://api.forever.today/?method=save_tile_loc",
			{
				method: "POST",
				body: JSON.stringify({
          dash_token,
          id,
          e: meterInMercatorCoordinateUnits()*pos_x,
          n: meterInMercatorCoordinateUnits()*pos_z,
          mx: sceneOriginMercator.x,
          my: sceneOriginMercator.y,
          mebot_id,
          tx,
          ty
				}),
			}
	  );
}

let is_taken_owner = 0;
let found_tile = null;
let found_tile_id = 0;
let tile_id = '';
let near_by = 0;
function drawHex(id, centerX, centerY, radius, is_active = false, tile_offsetX, tile_offsetY) {

  let hex1 = null;
  var hex_geo = new THREE.CylinderGeometry(radius-2.4, radius-2.4, 0, 6);

  //let is_taken = mebot_tile_locs['' + centerX + centerY];
  //found_tile = is_hexagon_claimed(centerX, centerY)

  tile_id = '' + tile_offsetX + '.' + tile_offsetY;
  found_tile = is_hexagon_claimed(tile_id)
  near_by = 0;

  if (found_tile != null) {
    //console.log('is taken: ' + is_taken)
    is_taken_owner = mebot_tile_locs[found_tile].io;
    found_tile_id = mebot_tile_locs[found_tile].id;
  } else {
    is_taken_owner = 0;
    found_tile_id = 0;
  }

  //if (is_active || is_taken_owner > 0) {
  if (is_taken_owner > 0) {
    near_by = 1;

    //hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.7, transparent: true} ));
    //hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0x1bffe8, opacity: 0.7, transparent: true} ));

    //console.log('drawing: ' + centerX + ' : ' + centerY)
    if (is_taken_owner == 1) {
      //blue tile
      //if ( Math.abs(0-centerX) < 105 && Math.abs(0-centerY) < 105 ) {
      if ( Math.sqrt( (centerX)**2 + (centerY)**2 ) < 150) {
        hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.9, transparent: true} ));
      } else {
        hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0x00d9ff, opacity: 0.7, transparent: true} ));
      }
    } else {
      //if (found_tile_id == 645) {
      //  console.log('marking 645')
      //}

      //orange, enemy tile
      if ( Math.sqrt( (centerX)**2 + (centerY)**2 ) < 150) {
        hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0xffa500, opacity: .95, transparent: true} ));
        near_by = 1;
      } else {
        hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0xffa500, opacity: 0.55, transparent: true} ));
      }
    }
    //hex1 = new THREE.Mesh(hex_geo, hex_texture_mat);
  } else {

    //test distance, if too far only allow claiming w/in mebots location 3 tiles away
    if ( Math.sqrt( (centerX)**2 + (centerY)**2 ) < 150) {
      //near enough
      hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0xd9d9d9, opacity: 0.8, transparent: true} ));
      near_by = 1;
    } else {
      //unclaimable
      hex1 = new THREE.Mesh(hex_geo, new THREE.MeshBasicMaterial( {color: 0xd8d8d8, opacity: 0.3, transparent: true} ));
    }

  }

  //hex1.rotation.y = Math.PI/2;
  hex1.position.set(centerX, 0, centerY);

  setName(hex1, 'hex' + id)
  objects['hex' + id] = {
      type: 'hex',
      model: hex1,
      name: 'hex' + id,
      texture: '',
      x: centerX,
      z: centerY,
      tile_id: found_tile_id,
      tx: tile_offsetX,
      ty: tile_offsetY
  }

  map_scene.add(hex1);

  //TEMP: hex center marker
  if (near_by == 1) {
  const lookat_geo = new THREE.CylinderGeometry(3, 3, 1, 8);
  const lookat_mat = new THREE.MeshBasicMaterial( {color: 0xc5c5c5, opacity: 1, transparent: false} );
  let lookat_pointer = new THREE.Mesh(lookat_geo, lookat_mat);
  lookat_pointer.position.set(centerX, 0, centerY);
  map_scene.add(lookat_pointer);
  }
}

async function setMebotLookAt(bearing = -1) {

  if (bearing == -1) {
    bearing = map42.getBearing();
  }

  console.log('current bearing: ' + (180-bearing))
  if (mebot_loc_id > 0) {
    me_object.rotation.y = ( (180-bearing)/360 * Math.PI*2 ) % (Math.PI*2);
    console.log('mebot rotation: ' + me_object.rotation.y)
  }

  const bearingRad = (bearing * Math.PI) / 180;
  vector2.z = Math.cos(bearingRad);
  vector2.x = Math.sin(bearingRad);
  playerDirection = new THREE.Vector3(vector2.x, 0, vector2.z);
  //console.log( playerDirection )
  const impulse = 50;
  vector2.copy( playerDirection ).multiplyScalar( impulse );
  //console.log(vector2)
  lookat_pointer.position.copy(new THREE.Vector3(mebot_pos[me_object_n][0], 2, mebot_pos[me_object_n][2]));
  lookat_pointer.position.addScaledVector(vector2, 1);

  if (skateboard != null) {
    skateboard.rotation.y = ( (bearing)/360 * Math.PI*2 ) % (Math.PI*2);
  }
}

//calculate bearing, BTW this wrong !!! (from google AI)
//better answer that works: https://stackoverflow.com/questions/8123049/calculate-bearing-between-two-locations-lat-long
function calculateBearing(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in kilometers

  // Convert latitude and longitude to radians
  const φ1 = toRad(lat1);
  const λ1 = toRad(lon1);
  const φ2 = toRad(lat2);
  const λ2 = toRad(lon2);

  // Calculate differences
  const Δλ = λ2 - λ1;
  const Δφ = φ2 - φ1;

  // Haversine formula
  const θ = Math.atan2(Math.sin(φ2) * Math.cos(Δλ), Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ));
  const bearing = (θ + 360) % 360;

  return bearing;
}

function toRad(deg) {
  return deg * Math.PI / 180;
}

async function CenterPlayer() {

  if (is_tunnel) {
    showTunnel();
    return;
  }

  //destroy();
	//replace('/go/2/map/0_' + mebot_id);
  //return;

  //setting_north = map42.getBearing();
  //map bearing between -180 (counter clockwise) and 180 (clockwise), true north is 0

  if (is_centering) {
    setTimeout(function(){ is_centering = false; }, 500);
    return;
  }

  setMebotLookAt();

  //redraw map
  //await destroy();
  //await draw_map();

  is_centering = true;

  await get_habitats()

  console.log(player_loc['lat'] + ',' + player_loc.lon)
  player_coords[0] = parseFloat(player_loc['lon']);
  player_coords[1] = parseFloat(player_loc['lat']);

  const model1Location = new maplibregl.LngLat(player_coords[0], player_coords[1]);
  const model1Mercator = maplibregl.MercatorCoordinate.fromLngLat(model1Location);
  const {dEastMeter: model1east, dNorthMeter: model1north} = calculateDistanceMercatorToMeters(sceneOriginMercator, model1Mercator);

  //console.log(sceneOriginMercator);

  mebot_pos[me_object_n][0] = model1east;
  mebot_pos[me_object_n][2] = model1north;

  console.log(mebot_pos)
  map42.setCenter(player_coords);

  mebot_models[me_object_n].position.x = mebot_pos[me_object_n][0];
  mebot_models[me_object_n].position.z = mebot_pos[me_object_n][2];
  center_marker.position.x = mebot_pos[me_object_n][0];
  center_marker.position.z = mebot_pos[me_object_n][2];

  //adjust lookAt direction pointer (incredibly complicated way of doing this, simplify!!)

  //console.log(mebot_pos[0][2])
  //console.log(map_projectile.collider.center.x)

  await setup_spheres();

  if (map_projectile != null) {

    console.log(map_projectile.collider.center)
    console.log( Math.abs(parseFloat(mebot_pos[me_object_n][2])-parseFloat(map_projectile.collider.center.x)) )

  if ( Math.abs(mebot_pos[me_object_n][0]-map_projectile.collider.center.x) <= 50 && Math.abs(mebot_pos[me_object_n][2]-map_projectile.collider.center.z) <= 50 ) {
    console.log('ball caught !')
    //catch the ball
    map_projectile.collider.center.copy(new THREE.Vector3(mebot_pos[me_object_n][0], 45, mebot_pos[me_object_n][2]));
    map_projectile.mesh.position.copy( map_projectile.collider.center );
  } else {
    //map_projectile.collider.center.copy( new THREE.Vector3( parseFloat(mebot_spheres[projectile_n].e), 1, parseFloat(mebot_spheres[projectile_n].n)) );
    //map_projectile.mesh.position.copy( map_projectile.collider.center );
  }

  }

  await load_habitats_models();
  load_mebot_models();

  //map42.jumpTo({ center: player_coords });

  is_centering = false;
}

let previousAction = null;
let activeAction = null;

function fadeToAction(name, duration, repeat = 0) {

  previousAction = activeAction;
  activeAction = zombie_action[name];

  if (repeat != 0) {
    activeAction.setLoop(THREE.LoopRepeat, repeat);
  } else {
    activeAction.setLoop(THREE.LoopRepeat);
  }

  if ( previousAction !== activeAction ) {
    previousAction.fadeOut(duration);
  }

  activeAction
  .reset()
  .setEffectiveTimeScale( 1 )
  .setEffectiveWeight( 1 )
  .fadeIn( duration )
  .play();
}


//from https://github.com/maplibre/maplibre-gl-js/discussions/1521
/*
map.getCameraPosition = () => {
            const pitch = map.transform._pitch;
            const altitude = Math.cos(pitch) * map.transform.cameraToCenterDistance;
            const latOffset = Math.tan(pitch) * map.transform.cameraToCenterDistance;
            const latPosPointInPixels = map.transform.centerPoint.add(new maplibregl.Point(0, latOffset));
            const latLong = map.transform.pointLocation(latPosPointInPixels);
            const verticalScaleConstant = map.transform.worldSize / (2 * Math.PI * 6378137 * Math.abs(Math.cos(latLong.lat * (Math.PI / 180))));
            const altitudeInMeters = altitude / verticalScaleConstant;
            return { lng: latLong.lng, lat: latLong.lat, altitude: altitudeInMeters, pitch: pitch * 180 / Math.PI };
}

//add 
//var heading = map.transform.angle * 180 / Math.PI
//if (heading > 0) heading = 360 - heading
//if (heading < 0) heading = -heading
map.setCameraPosition = (camPos) => {
            const { lng, lat, altitude, pitch } = camPos;
            const pitch_ = pitch * Math.PI / 180;
            const cameraToCenterDistance = 0.5 / Math.tan(map.transform._fov / 2) * map.transform.height;
            const pixelAltitude = Math.abs(Math.cos(pitch_) * cameraToCenterDistance);
            const metersInWorldAtLat = (2 * Math.PI * 6378137 * Math.abs(Math.cos(lat * (Math.PI / 180))));
            const worldsize = (pixelAltitude / altitude) * metersInWorldAtLat;
            const zoom = Math.log(worldsize / map.transform.tileSize) / Math.LN2;
            const latOffset = Math.tan(pitch_) * cameraToCenterDistance;
            const newPixelPoint = new maplibregl.Point(map.transform.width / 2, map.transform.height / 2 + latOffset);
            const newLongLat = new maplibregl.LngLat(lng, lat);
            map.transform.zoom = zoom;
            map.transform.pitch = pitch;
            map.transform.setLocationAtPoint(newLongLat, newPixelPoint);
}*/

async function clear_raycast() {

  unselect_habitat();

  mebot_clicked_url = '';
  habitat_clicked_url = '';
  artifact_clicked_object = '';
  clicked_object = '';
  display_clicked_object = '';
  display_clicked_object_extra = '';
  if (!is_battling) {
    show_challenge = false;
  }

  if ('Wave' in zombie_action) {
    //zombie_action['Wave'].stop();
  }
}

async function raycast(point) {

  //console.log('raycast')

/*
  let point_x = touchstartX
  let point_y = touchstartY

  console.log('x: ' + point_x + ', y: ' + point_y)

    var mouse = new THREE.Vector2();
     // // scale mouse pixel position to a percentage of the screen's width and height
    mouse.x = ( point_x / map42.transform.width ) * 2 - 1;
    mouse.y = 1 - ( point_y / map42.transform.height ) * 2;
*/

    //var mouse = new THREE.Vector2();
     // // scale mouse pixel position to a percentage of the screen's width and height

//    if (is_battling || is_throwing_mode) {
    if (is_battling) {
      return;
    }

    mouse.x = ( point.x / map42.transform.width ) * 2 - 1;
    mouse.y = 1 - ( point.y / map42.transform.height ) * 2;

    //console.log('x: ' + mouse.x + ', y: ' + mouse.y)

    //const camInverseProjection = new THREE.Matrix4().invert(camera.projectionMatrix);
    const camInverseProjection = camera.projectionMatrix.invert();
    let cameraPosition = new THREE.Vector3().applyMatrix4(camInverseProjection);

    //cameraPosition =  new THREE.Vector3(100, 10, -100);
    const mousePosition = new THREE.Vector3(mouse.x, mouse.y, 1).applyMatrix4(camInverseProjection);
    const viewDirection = mousePosition.clone().sub(cameraPosition).normalize();
 
    //console.log('camera position: ')
    //console.log(cameraPosition)
    //console.log('view direction: ')
    //console.log(viewDirection)
    //console.log('cam inv projection matrix')
    //console.log(camInverseProjection);

    raycaster.set(cameraPosition, viewDirection);

    // calculate objects intersecting the picking ray
    var intersects = raycaster.intersectObjects(map_scene.children, true);

    artifact_clicked_object = '';

    let found_habitat = false;
    console.log(intersects.length)
    if (intersects.length) {

      for (let i = 0; i < intersects.length; ++i) {

        //console.log(intersects[i].object)
        //console.log(intersects[i].object.name)
        clicked_object = intersects[i].object.name;
        console.log('clicked: ' + clicked_object)

        //skip anything else that's not a habitat if is_throwing_mode
        if (is_throwing_mode) {
          if (clicked_object in objects && objects[clicked_object].type != 'habitat' && objects[clicked_object].type != 'artifact') {
            console.log('skipping')
            continue;
          }
        }

        if (clicked_object in objects && objects[clicked_object].texture != '') {
          mebot_clicked_url = objects[clicked_object].texture;
          habitat_clicked_url = '';

          //setBodyTexture(clicked_object, objects[clicked_object].texture)
        } else {
          mebot_clicked_url = '';
        }

        if (clicked_object in objects && objects[clicked_object].type == 'friend') {
          unselect_habitat();
        }

        if (clicked_object in objects && objects[clicked_object].type == 'enemy') {
          unselect_habitat();

          show_challenge = true;
          zapBody(intersects[i].object)
        } else {
          show_challenge = false;
        }
        if (clicked_object in objects &&  objects[clicked_object].type == 'habitat') {
          unselect_habitat();

          habitat_clicked_url = objects[clicked_object].planet_src;
          habitat_id = objects[clicked_object].hid;
          mebot_clicked_url = '';

          found_habitat = true;

          load_habitat_texture(objects[clicked_object]);
          select_habitat(objects[clicked_object].model, clicked_object, objects[clicked_object].planet_src)

          if (habitat_clicked_url in habitat_globe_models_visited) {
            console.log('trying to pick up artifact')
            //see if there's artifact to be picked up
            pickup_artitifact(habitat_id, clicked_object)

          }


        } else {
          //unselect any selected habitat
        }

        if (clicked_object in objects && objects[clicked_object].type == 'artifact') {
          console.log('clicked artifact ! ')
          artifact_clicked_object = clicked_object;
          unselect_habitat();
        }

        if (clicked_object in objects && objects[clicked_object].name != null) {
          display_clicked_object = objects[clicked_object].name;
        } else {
          display_clicked_object = clicked_object;
        }

        if (display_clicked_object == 'Mecha Mebot 1') {
          objects[clicked_object].model.rotation.y = ( (map42.getBearing()-180)/360 * Math.PI*2 ) % (Math.PI*2) + Math.PI*2;
          heading_x = cameraPosition.x;
          heading_z = cameraPosition.y;
          if ('RobotArmature|Hello' in zombie_action) {
            if (!zombie_action['RobotArmature|Hello'].isRunning() && !zombie_action['RobotArmature|Yes'].isRunning() && !zombie_action['RobotArmature|No'].isRunning()) {
              is_zombie_walking = false;
              activeAction = zombie_action['RobotArmature|Idle'];

              if (zombie_action['RobotArmature|Walk'].isRunning()) {
                activeAction = zombie_action['RobotArmature|Walk'];
              }

              let rand_pick = Math.floor(Math.random() * 3 + 1)
              if (rand_pick == 1) {
                fadeToAction('RobotArmature|Yes', 0.5, 1)
              } else if (rand_pick == 2) {
                fadeToAction('RobotArmature|No', 0.5, 1)
              } else if (rand_pick == 3) {
                fadeToAction('RobotArmature|Hello', 0.5, 1)
              }

              setTimeout(() => {
                fadeToAction('RobotArmature|Walk', 0.5)
                is_zombie_walking = true;
              }, 1000);
            }
          }
        }

        if (display_clicked_object == 'Zombie') {
          move_zombie(clicked_object)
        }

        if (clicked_object in objects && objects[clicked_object].type == 'hex') {
          toggle_hexagon(clicked_object);
        }

        //update name
        break;
      }
    } else {

      clear_raycast()

    }

}

function move_zombie(clicked_object) {

  const camInverseProjection = camera.projectionMatrix.invert();
  let cameraPosition = new THREE.Vector3().applyMatrix4(camInverseProjection);

            //const freeCamera = map42.getFreeCameraOptions();
          //const freeCamera = camera;
          //console.log('camera pos:' + freeCamera.position.x)

          console.log('camera pos:' + map42.transform.cameraToCenterDistance);
          //map42.transform.elevation = 10;
          //projectTileWithElevation
          console.log('camera elev:' + map42.transform.elevation);

          //position Zombie towards camera
          //use zombie_object
          objects[clicked_object].model.rotation.y = ( (map42.getBearing()-180)/360 * Math.PI*2 ) % (Math.PI*2) + Math.PI*2;
          //world_cameraPosition = new THREE.Vector3().applyMatrix4(camera.projectionMatrix.invert());
          heading_x = cameraPosition.x;
          heading_z = cameraPosition.y;
          console.log('heading to x |-> ' + heading_x + ' z |-> ' + heading_z)

          if ('Wave' in zombie_action) {

            if (!zombie_action['Wave'].isRunning() && !zombie_action['Yes'].isRunning() && !zombie_action['No'].isRunning()) {
              is_zombie_walking = false;
              activeAction = zombie_action['Idle'];

              if (zombie_action['Walk'].isRunning()) {
                activeAction = zombie_action['Walk'];
              }

              let rand_pick = Math.floor(Math.random() * 3 + 1)
              if (rand_pick == 1) {
                fadeToAction('No', 0.5, 1)
              } else if (rand_pick == 2) {
                fadeToAction('Yes', 0.5, 1)
              } else if (rand_pick == 3) {
                fadeToAction('Wave', 0.5, 1)
              }

              setTimeout(() => {
                fadeToAction('Walk', 0.5)
                is_zombie_walking = true;
              }, 1000);
            }
            /* PREV simplictic implementation
            zombie_action['Wave'].stop();
            zombie_action['Wave'].setLoop(THREE.LoopRepeat, 1);
            zombie_action['Wave'].play();
            */

            /*
            zombie_action['Wave'].setLoop(THREE.LoopRepeat, 1);
            zombie_action['Wave'].crossFadeFrom(zombie_action['Walk'], .5).play()

            setTimeout(() => {
              //zombie_action['Walk'].setLoop(THREE.LoopRepeat, 10);
              //zombie_action['Walk'].crossFadeFrom(zombie_action['Wave'], .5).play()
              //zombie_mixer.stopAllAction();
              //zombie_action['Wave'].reset()
              zombie_action['Walk'].reset()
              .reset()
					.setEffectiveTimeScale( 1 )
					.setEffectiveWeight( 1 )
					.fadeIn( 1 )
					.play();
              zombie_action['Wave'].crossFadeTo(zombie_action['Walk'], 1).play()
              zombie_action['Walk'].play()
              console.log('started woalking again')
              zombie_action['Wave'].reset()
            }, 1000);

            zombie_action['Wave'].stop();
            zombie_action['Wave'].play();
            */
          }
}

function checkTouch() {

  //raycast();

/*
    //const freeCamera = map42.getFreeCameraOptions();
    const freeCamera = camera;

let l = new THREE.Matrix4();
l.copy(l_vector);

let cameraPosition = new THREE.Vector4(freeCamera.position.x, freeCamera.position.y, freeCamera.position.z, 1);
cameraPosition.applyMatrix4(l.invert());
let direction = mouse.clone().applyMatrix4(camera.projectionMatrix.clone().invert());
direction.divideScalar(direction.w);
raycaster.set(cameraPosition, direction.sub(cameraPosition).normalize());


const intersects = raycaster.intersectObjects( map_scene.children );
console.log('Intersection count:', intersects.length)

for ( let i = 0; i < intersects.length; i ++ ) {
  intersects[ i ].object.material.wireframe = true;
}

/*
var mouse = new THREE.Vector2();
  
const camInverseProjection = 
      new THREE.Matrix4().invert(camera.projectionMatrix);

console.log('camera inverse: ')
console.log(camInverseProjection)
const cameraPosition =
      new THREE.Vector3().applyMatrix4(camInverseProjection);

console.log('camera position: ')
console.log(cameraPosition)


mouse.x = ( point.x / this.map.transform.width ) * 2 - 1;
mouse.y = 1 - ( point.y / this.map.transform.height ) * 2;
  const raycaster = new THREE.Raycaster();
  raycaster.setFromCamera(mouse, this.camera);
  console.log(raycaster.intersectObjects(this.scene.children, true));

const mousePosition =
      new THREE.Vector3(mouse.x, mouse.y, 1)
      .applyMatrix4(camInverseProjection);
const viewDirection = mousePosition.clone()
      .sub(cameraPosition).normalize();
/*
const mousePosition =
      new THREE.Vector3(mouse.x, mouse.y, 1)
      .applyMatrix4(camInverseProjection);
const viewDirection = mousePosition.clone()
      .sub(cameraPosition).normalize();
*/

}

function ThrowBall() {

  console.log('ThrowBall')
  touch_start_ts = new Date().getTime();

  throw_ball();
}

async function ToggleThrow() {

  if (is_throwing) {
    return;
  }

  is_throwing_mode = !is_throwing_mode;

  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;

  if (is_throwing_mode) {

    clear_touchpad_canvas()
    touchpad_canvas_ctx = null;
    map_projectile = null;

    content_loading.update(n => true);
    await CenterPlayer();
    load_touchpad_canvas()
    clear_touchpad_canvas(true)
    clear_raycast();

    showObjects(['enemy', 'other_mebot', 'accessory'], false)

  } else {
    clear_touchpad_canvas()

    showObjects(['enemy', 'other_mebot', 'accessory'], true)
  }
}

function ThrowStart() {

  console.log('ThrowStart')
  if (!is_throwing) {
    touch_start_ts = new Date().getTime();
    throw_power_visible = true;
  }
}

function SetNorth() {

  zooming_out = false;
  zooming_in = false;
  prev_spin_dir = 0;
  spinning_dir = 0;
  swipe_rotation = 0;
  y_playerMoveAngleSpeed = 0;

  setting_north = map42.getBearing();

  console.log('current bearing: ' + setting_north)

  show_challenge = false;

  spinner = setting_north;
  map42.setBearing(setting_north);
  //map42.rotateTo(0);
}

function NewBattle() {

}

function endBattle() {

    is_walking = true;
    is_battling = false;
    bottom_position_y = 43;
    show_challenge = false;
    is_battle_action = false;
    max_pitch = 80;
    spinning_dir = 0;
    is_zombie_walking = false;

    var selectedObject = map_scene.getObjectByName('Battle Stage');
    map_scene.remove(selectedObject);


    enemy_object.position.copy(enemy_old_pos);
    me_object.position.copy(my_old_pos)
    console.log('setting rot to: ' + my_old_rot.y)
    me_object.rotation.y = my_old_rot.y;
    if (lookat_pointer != null) {
      lookat_pointer.visible = true;
    }

    //console.log('my old pos')
    //console.log(my_old_pos)
    //console.log(enemy_old_pos)

    zombie_mixer.stopAllAction();
    zombie_action['Idle'].play();

    showObjects(['enemy', 'other_mebot', 'habitat', 'accessory'])
    /*for (const name in objects) {
      //console.log(objects[name].type)
      if ((objects[name].type == 'enemy' || objects[name].type == 'other_mebot' || objects[name].type == 'habitat' || objects[name].type == 'accessory')) {
        objects[name].model.visible = true;
      }
    }*/
}

async function toggleBattle(battle = true) {

  //show_challenge = false;

  if (battle) {

    await CenterPlayer();

    //setup battle
    pitch_step = 0.18;
    zoom_step = 0.004;
    max_zoom = 17;

    current_pitch = min_pitch;
    current_zoom = min_zoom;
    map42.setPitch(current_pitch);
    map42.setZoom(current_zoom);

    setBattleStage();

    battle_on = true;
    if (battle_on) {
      max_zoom = 17.1;
      zooming_in = true;
      zooming_out = false;
      spinning_dir = 1;
      target_orientation = 320;
      //target_orientation = 40;
      max_pitch = 64;
    }

  } else {
    endBattle();
  }

}

function startEndBattle() {

  battle_ending = true;
  setTimeout(function(){ 
    
    console.log('ending battle')
    toggleBattle(false)
    battle_ending = false;

    /*
    is_walking = true;
    is_battling = false;
    bottom_position_y = 33;

    var selectedObject = map_scene.getObjectByName('Battle Stage');
    map_scene.remove(selectedObject);

    enemy_object.position.set(enemy_old_pos);
    me_object.position.copy(my_old_pos)
    //enemy_object.rotation = enemy_old_rot;

    console.log('my old pos')
    console.log(my_old_pos)

    for (const name in objects) {
      console.log(objects[name].type)
      if (objects[name].type == 'enemy' && clicked_object != name) {
        objects[name].model.visible = true;
      }
    }*/

  }, 5000);

}

function showObjects(types, show = true) {

  for (const name in objects) {
    console.log(objects[name].type)
    if (types.includes(objects[name].type) && clicked_object != name) {
      //console.log(objects[name].model)
      //objects[name].model.visible = !objects[name].model.visible;
      objects[name].model.visible = show;
    }
  }
}


function setBattleStage() {

  console.log('setting stage')

  if (clicked_object in objects && objects[clicked_object].name != null && objects[clicked_object].type == 'enemy' && mebot_clicked_url != '') {

    console.log('fighting with: ' + objects[clicked_object].name)
    //save current position of fighters, to restore later:

    enemy_object = objects[clicked_object].model;
    me_object = mebot_models[me_object_n];

    enemy_clicked_url = objects[clicked_object].reverse_texture;
    mebot_clicked_url = objects['mebot_' + mebot_id].texture;

    enemy_old_pos.copy(enemy_object.position);
    //console.log(enemy_object)
    //console.log(enemy_old_pos)
    enemy_old_rot = enemy_object.rotation;
    my_old_pos.copy(me_object.position);
    my_old_rot.copy(me_object.rotation);

    //console.log('my old pos')
    //console.log(my_old_pos)
    is_walking = false;
    is_battling = true;
    battle_ending = false;
    is_battle_action = true;
    enemy_mp = 100;

/*    prev_spin_dir = 0;
    spinning_dir = 0;
    swipe_rotation = 0;
    y_playerMoveAngleSpeed = 0;*/

    smoothing[0] = 1;
    smoothing[1] = 3;
    //find out enemy location and set stage around there:

    if (objects[clicked_object].name == 'Zombie') {
      //zombie_action['Walk'].play();
      //zombie_action['Walk'].stop();
      fadeToAction('Idle', 0.5)
    }

    //add stage to scene
    map_scene.add(glb_items['battle_stage']);
    //glb_items['battle_stage'].position.set(my_old_pos.x-26, 73, my_old_pos.z+0);
    //glb_items['battle_stage'].rotation.y = 0.8;
    glb_items['battle_stage'].position.set(my_old_pos.x, 44, my_old_pos.z);

    //hide lookat marker during battle
    if (lookat_pointer != null) {
      lookat_pointer.visible = false;
    }

    //let elevation = 58;
    let elevation = 65;
    bottom_position_y = elevation;

    if (!isNaN(objects[clicked_object].elevation)) {
      elevation = objects[clicked_object].elevation
    }
    enemy_object.position.set(my_old_pos.x-30, elevation, my_old_pos.z-30);
    me_object.position.set(my_old_pos.x+30, 60, my_old_pos.z+30);
    mebot_pos[me_object_n][0] = my_old_pos.x+30;
    mebot_pos[me_object_n][2] = my_old_pos.z+30;

    console.log("enemy rotation: " + enemy_object.rotation.y)
    //enemy_object.rotation.y = Math.PI/2 * 1 - enemy_object.rotation.y;
    //enemy_object.rotation.y = 1.7;
    enemy_object.rotation.y = 0;
    console.log("enemy rotation: " + enemy_object.rotation.y)
    enemy_object.rotation.y = 0.85;
    console.log("enemy rotation: " + enemy_object.rotation.y)

    console.log("me rotation: " + me_object.rotation.y)
    me_object.rotation.y = 0;
    console.log("me rotation: " + me_object.rotation.y)
    me_object.rotation.y = me_starting_rotation;
    console.log("me rotation: " + me_object.rotation.y)

    //console.log("NOW enemy rotation: " + enemy_object.rotation.y)
    //enemy_object.lookAt(my_old_pos.x+30, 60, my_old_pos.z+30)
    //me_object.rotation.y = Math.PI/2 *3.5;

//    let types = ;
    showObjects(['enemy', 'other_mebot', 'habitat', 'accessory'], false)

  }
}

function Battle() {

  show_challenge = false;

  //throw_ball();
  //return;

  pitch_step = 0.18;
  zoom_step = 0.004;
  max_zoom = 18;

  battle_on = !battle_on;

  if (battle_on) {
    zooming_in = true;
    zooming_out = false;
    spinning_dir = 1;
  }

  if (!battle_on) {
    zooming_in = false;
    zooming_out = true;
    spinning_dir = 2;
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
}

async function toggleFullSize() {
  is_fullsize = !is_fullsize;

  await sleep(100);

  console.log('resize')

  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
  //document.getElementById('extra_info').style.top = map_bottom-40 + 'px';

  //let rect = document.getElementById('canvas-container').getBoundingClientRect();
  //bottom = rect.top + window.scrollY + 450;
  console.log('bottom: ' + map_bottom)
  page_height = offsets.bottom - offsets.top;

  //document.getElementById('canvas-container')
  //game.window.updateWindowSize();

  load_touchpad_canvas();
}

function calculateDistanceMercatorToMeters(from, to) {
    const mercatorPerMeter = sceneOriginMercator.meterInMercatorCoordinateUnits();
    // mercator x: 0=west, 1=east
    const dEast = to.x - from.x;
    const dEastMeter = dEast / mercatorPerMeter;
    // mercator y: 0=north, 1=south
    const dNorth = from.y - to.y;
    const dNorthMeter = dNorth / mercatorPerMeter;
    return {dEastMeter, dNorthMeter};
}

/*
* Helper function used to get threejs-scene-coordinates from mercator coordinates.
* This is just a quick and dirty solution - it won't work if points are far away from each other
* because a meter near the north-pole covers more mercator-units
* than a meter near the equator.
*/

function mercatorScale(lat) {
    return 1 / Math.cos(lat * Math.PI / 180);
}

function latFromMercatorY(y) {
    const y2 = 180 - y * 360;
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
}

function meterInMercatorCoordinateUnits() {
  return 1 / earthCircumference * mercatorScale(latFromMercatorY(sceneOriginMercator.y));
}

async function get_habitats() {

  let mx = 0, my = 0;
  if (sceneOriginMercator != null) {
    mx = parseFloat(sceneOriginMercator.x);
    my = parseFloat(sceneOriginMercator.y);
  }

  //!!!! sceneOriginMercator is null at this stage
  //console.log('mercantor in get_habitats');
  //console.log(sceneOriginMercator);

  const res = await fetch(
			"https://api.forever.today/?method=get_user_loc",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          mebot_id,
          mebot_loc_id,
          mx,
          my
				})
			}
	);

  const json = await res.json();
  player_loc = json.data.mebot;
  habitat_globes = json.data.globes;
  mebots_here = json.data.mebots;
  mebot_spheres = json.data.spheres;
	journey = json.data.journey;
  is_city = json.data.ic;
  city_info = json.data.c_info;
  artifacts_n = json.data.artifacts_n;
  mebot_tiles = json.data.tiles;
  mebot_tile_tl = json.data.tile_tl; //top left corner

  for (const tile of mebot_tiles) {
    //console.log('' + tile.n + tile.e)
    //if ()
    mebot_tile_locs[tile.nid] = {
      //e: parseFloat(tile.e),
      //n: parseFloat(tile.n),
      mid: tile.mid,
      io: tile.io,
      id: tile.id
    }
  }
  console.log(mebot_tile_locs)

  console.log('SSSSSSSS')
  console.log(json.data.sel_art)

  if (json.data.sel_art.id > 0) {
    aa_id = '' + json.data.sel_art.id;
    aa_em = json.data.sel_art.em;
    aa_name = json.data.sel_art.name;
    aa_instructions = json.data.sel_art.instr;

    a_action_type[json.data.sel_art.id] = json.data.sel_art.a_type;
    a_weight[json.data.sel_art.id] = json.data.sel_art.weight;
    a_blast[json.data.sel_art.id] = json.data.sel_art.blast;
    a_blast_color[json.data.sel_art.id] = json.data.sel_art.b_color;
    a_velocity[json.data.sel_art.id] = json.data.sel_art.vel;
    a_bounce[json.data.sel_art.id] = json.data.sel_art.bounce;
  }

}

async function load_data() {

  if (mebot_loc_id >= 0) {
    console.log('mebot loc id: ' + mebot_loc_id)

    await get_habitats();

  } else {

    const res = await fetch(
			"https://api.forever.today/?method=get_hab_loc",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					mebot_id,
					file_id: h_id
				})
			}
		);

    const json = await res.json();
    player_loc = json.data.habitat.loc;
    habitat_globes = json.data.globes;
    mebots_here = json.data.mebots;
    mebot_spheres = json.data.spheres;
  }

  //console.log(player_loc)
  console.log(player_loc['lat'] + ',' + player_loc.lon)

  //requestNextFrame();
  player_coords[0] = parseFloat(player_loc['lon']);
  player_coords[1] = parseFloat(player_loc['lat']);

}

async function draw_map() {
  //await sleep(300);
/*
  // Terrain Map
  var canvas = document.getElementById('terrain_map');
  canvas.width = 40;
  canvas.height = 40;
  var ctx = canvas.getContext('2d');
  var canvasWidth = canvas.width;
  var canvasHeight = canvas.height;
  ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  var id = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
  var pixels = id.data;
  var x, y;

  for (x = 0; x < 40; x++) {
    for (y = 0; y < 40; y++) {

      //var x = Math.floor(Math.random() * canvasWidth);
      //var y = Math.floor(Math.random() * canvasHeight);
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      var off = (y * id.width + x) * 4;
      pixels[off] = r;
      pixels[off + 1] = g;
      pixels[off + 2] = b;
      pixels[off + 3] = 255;
    }
  }
  ctx.putImageData(id, 0, 0);*/

  await load_data();

  map42 = new maplibregl.Map({
    //style: `https://api.maptiler.com/maps/streets/style.json?key=${MAPTILER_KEY}`,
    style: `/map42-style.json`,
    //center: [-74.0066, 40.7135],
    center: player_coords,
    zoom: current_zoom,
    pitch: 70,
    bearing: (spinner-5),
    container: 'canvas-container',
    antialias: true,
    dragPan: false,
    touchZoomRotate: {around: 'center'},
    scrollZoom: {around: 'center'},
    maxZoom: 18.5,
    minZoom: min_zoom
  }).setMaxPitch(85);

  map42.setPitch(initial_pitch);
  map42.doubleClickZoom.disable();

  //map42.setBearing(spinner-5);

  //document.getElementById('canvas-container').appendChild(stats.dom);

  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
  console.log('bottom: ' + map_bottom)
  page_height = offsets.bottom - offsets.top;
  //document.getElementById('extra_info').style.top = map_bottom-40 + 'px';
  //console.log(document.getElementById('extra_info').style.top)

  //map42.style.stylesheet.layers.forEach(function(layer) {
  //  if (layer.type === 'symbol') {
  //    map42.removeLayer(layer.id);
  //  }
  //});

  map42.on('load', function() {
    //console.log('renderer.outputEncoding: ' + renderer_42.outputEncoding)
    load_everything();
    console.log('loaded everything')
    requestNextFrame();
  });

  map42.on('click', e => {
    raycast(e.point);
  });



  //player_coords[0] += 0.01;
  //map42.setCenter(player_coords);
}

async function load_everything() {

  await load3d(map42);

  if (buildings_3d) {

    await sleep(100);

    console.log('adding 3d');

    const MAPTILER_KEY = 'hLchnSURt41YlBmnc8k7';
    //const MAPTILER_KEY = '6glM7nnUOI2vo9Qzbaae';

    map42.addSource('openmaptiles', {
      //url: `https://api.maptiler.com/tiles/v3/tiles.json?key=${MAPTILER_KEY}`,
      url: `https://api.maptiler.com/tiles/v3-openmaptiles/tiles.json?key=${MAPTILER_KEY}`,
      type: 'vector',
      data: {
            "type": "FeatureCollection",
            "features": []
      }
    });

    /*
    map42.setFog({
            'range': [-1, 2],
            'horizon-blend': 0.3,
            'color': 'white',
            'high-color': '#add8e6',
            'space-color': '#d8f2ff',
            'star-intensity': 0.0
        });*/

    map42.addSource('currentBuildings', {
      type: 'geojson',
      data: {
            "type": "FeatureCollection",
            "features": []
      }
    });

    map42.addLayer({
              'id': '3d-buildings',
              //"source": "maplibre",
              'source': 'openmaptiles',
              'source-layer': 'building',
              'type': 'fill-extrusion',
              'minzoom': 14,
              //'filter': ['==', ['get', 'hide_3d'], true],
              //'filter': ['==', ['get', 'building_type'], 'residential'],
              'paint': {
                  //'fill-extrusion-color': [
                  //    'interpolate',
                  //    ['linear'],
                  //    ['get', 'render_height'], 0, '#ffdfbc', 50, '#ffafbc', 400, '#ffffbc'
                  //    //['get', 'render_height'], 0, 'lightgray', 200, 'royalblue', 400, 'lightblue'
                  //],
                  'fill-extrusion-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'lightblue',
                    ['interpolate',
                      ['linear'],
                      ['get', 'render_height'], 0, '#ffdfbc', 50, '#ffafbc', 400, '#ffffbc']
                  ],
                  //from: https://github.com/openmaptiles/maptiler-3d-gl-style/blob/master/style.json
                  //"fill-extrusion-color": [ "case", ["has", "colour"], ["get", "colour"], "hsl(39, 41%, 86%)"],
                  "fill-extrusion-height": {
                    "property": "render_height",
                    "type": "identity"
                  },
                  //"fill-extrusion-height": 2,
                  //'fill-extrusion-height': [
                  //      'interpolate',
                  //      ['linear'],
                  //      ['zoom'],
                  //      15,
                  //      0,
                  //      15.05,
                  //      ['render_height']
                  //],
                  //'fill-extrusion-height': [
                  //    'interpolate',
                  //    ['linear'],
                  //    ['zoom'],
                  //    15,
                  //    0,
                  //    16,
                  //    ['get', 'height']
                  //    //Math.floor(['get', 'render_height']/2)
                  //],
                  //'fill-extrusion-base': ['case',
                  //    ['>=', ['get', 'zoom'], 16],
                  //    ['get', 'render_min_height'], 0
                  //],
                  //'fill-extrusion-opacity': 0.6
              }
          },
    );

    //select 3d building
    map42.on('click', '3d-buildings', function (e) {

      return;

      //unselect
      if (prev_hover != null) {
        map42.setFeatureState({
          source: 'openmaptiles',
          sourceLayer: 'building',
          id: prev_hover},
          {hover: false}
        );
        prev_hover = null;
      }

      //console.log(e.features)
      console.log('map42 3d click')
      for ( const feat of e.features ) {
        //console.log(feat.id)
        map42.setFeatureState({
          source: 'openmaptiles',
          sourceLayer: 'building',
          id: feat.id},
          {hover: true}
        );
        prev_hover = feat.id;
        break;
      }

      /*
      let hoveredStateId = e.features[0].id;
      console.log(hoveredStateId)
      map42.setFeatureState({
        source: 'openmaptiles',
        sourceLayer: 'building',
        id: hoveredStateId},
        {hover: true}
      );*/

          //map42.getSource('openmaptiles').setData({
          //  "type": "FeatureCollection",
          //  "features": e.features
          //});

//          map.setPaintProperty(
//  'Icons', 
//  'icon-opacity', 
//  ['match', ['get', 'id'], 'example-id', 0.5 , 1]
//);

        //map42.setPaintProperty('3d-buildings', 'fill-extrusion-color', ['match', ['get', 'id'], e.features[0].id, 'lightblue' , 'lightgray']);

        //map42.setFeatureState({
        //    source: 'openmaptiles',
        //    sourceLayer: 'building',
        //    id: e.features[0].id,
        //}, {
        //    hover: true
        //});

    });


    /*map42.setSky({
            'sky-color': document.getElementById('sky-color-picker').value,
            'sky-horizon-blend': +document.getElementById('sky-horizon-blend-slider').value,
            'horizon-color': document.getElementById('horizon-color-picker').value,
            'horizon-fog-blend': +document.getElementById('horizon-fog-blend-slider').value,
            'fog-color': document.getElementById('fog-color-picker').value,
            'fog-ground-blend': +document.getElementById('fog-ground-blend-slider').value
    });*/
  }

  await sleep(100)
  //wait until assets had chance to laod
  //load_habitats_items();
  await load_habitats_models();
  load_mebot_models();
  //setMebotLookAt();

  const res = await fetch(
				"https://api.forever.today/?method=get_mebot_modes",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token: dash_token,
						mebot_id: mebot_id,
            is_abbrev: 1
					}),
				}
			);
	const json = await res.json();
	mebot_md = json.data.mebot_md;
	power_avail.set(mebot_md.dp/100);

  map_loading = false;
        
  console.log('mebot bearing: ' + journey['m_bearing'])
  if (journey['m_bearing'] >= 0) {
    setMebotLookAt(journey['m_bearing'])
  }

  content_loading.update(n => false);

  doPost();
  getMyMebots();
  //load_touchpad_canvas(); //this causes race condition and multiple of the same throw artifact showing up

  if (is_skateboard) {
    skateboard = glb_items['accessories'].scene.clone();
    setRGBEncoding(skateboard)
    skateboard.scale.set(20, 20, 20);
    skateboard.position.x = mebot_pos[me_object_n][0];
    skateboard.position.z = mebot_pos[me_object_n][2];
    skateboard.position.y = 2;
    skateboard.rotation.y = ( (map42.getBearing())/360 * Math.PI*2 ) % (Math.PI*2);
    setName(skateboard, 'Skateboard')
    map_scene.add(skateboard);

    objects['Skateboard'] = {
      type: 'accessory',
      model: skateboard,
      name: 'Skateboard  🛹',
      texture: ''
    }
  }

  await sleep(100);
  initial_swipe_rotation = 99;
  is_running = 1;

  console.log( 'Render1: ', renderer_42.info.render );

}

let touchpad_canvas;
let touchpad_canvas_ctx;
let touchpad_offset_x = 0;
let touchpad_offset_y = 0;
let touchpad_ratio = 0;
let project_distance = 0;
let project_angle = 0;
let lolipop = 0; //increase hit zone with each unsuccessful throw

async function load_touchpad_canvas() {

  if (map_projectile == null && aa_id > 0) {

    content_loading.update(n => true);
    //load 3d model
    await setup_artifact_model(aa_id, aa_em, aa_name)
    content_loading.update(n => false);

    if (aa_id in a_blast && a_blast[aa_id] > 0) {
      aa_blast_radius = (a_blast[aa_id]/100);
    }

    if (aa_id in a_blast_color && a_blast_color[aa_id] > 0) {
      aa_blast_color = a_blast_color[aa_id];
    } else {
      aa_blast_color = default_blast_color;
    }

    //console.log('SETTING blast color to: ' + aa_blast_color)
  }

  //if (map_projectile) {
  if (true) {

  //make sure it is visible
  if (map_projectile && aa_name != '') {

    console.log(aa_name)
    //console.log(artifacts[show_artifact_detail].name)
    //make sure spehere is visible again
    objects[aa_name].model.visible = true;

    //hide glow if any
    if (objects[aa_name].glow != null) {
      objects[aa_name].glow.visible = false;
    }
  }

  lolipop = 0;

  //touchpad_canvas = document.createElement('canvas');
  //touchpad_canvas.className = 'touchpad_canvas'

  touchpad_canvas = document.getElementById('touchpad_cvs');
  const offsets = touchpad_canvas.getBoundingClientRect();
  touchpad_canvas.width = offsets.right-offsets.left;
  touchpad_canvas.height = offsets.bottom-offsets.top;
  touchpad_ratio = touchpad_canvas.width / touchpad_canvas.height;

  //touchpad_canvas.height = 150;
  touchpad_canvas_ctx = touchpad_canvas.getContext('2d');
  touchpad_canvas_ctx.clearRect(0, 0, touchpad_canvas.width, touchpad_canvas.height);

  touchpad_offset_y = offsets.top;
  touchpad_offset_x = offsets.left;

  //draw_circle(touchpad_canvas_ctx, touchpad_canvas.width / 2, 40, 20, '#dfff4f')

  if (map_projectile) {
    draw_emoji(touchpad_canvas_ctx, touchpad_canvas.width / 2, 50, aa_em);

    if (mebot_md.power_avail <= 0) {
      draw_info(touchpad_canvas_ctx, touchpad_canvas.width / 2, 120, 'No power!', 12, '#dd0000');
    }
  } else {
    draw_instructions()
    content_loading.update(n => false);
  }

  console.log('offsets: ' + touchpad_offset_x + ' : ' + touchpad_offset_y)
  console.log('CANVAS SIZE: ' + touchpad_canvas.width + ' : ' + touchpad_canvas.height)

  } else {

    //close automatically
    is_throwing_mode = false
    showObjects(['enemy', 'other_mebot', 'accessory'], true)

  }

  /*
  var id = context.getImageData(0, 0, touchpad_canvas.width, touchpad_canvas.height);
  var pixels = id.data;
  var x, y;
  var r, g, b, off;
  for (x = 0; x < 40; x++) {
    for (y = 0; y < 40; y++) {

      //var x = Math.floor(Math.random() * canvasWidth);
      //var y = Math.floor(Math.random() * canvasHeight);
      r = Math.floor(Math.random() * 256);
      g = Math.floor(Math.random() * 256);
      b = Math.floor(Math.random() * 256);
      off = (y * id.width + x) * 4;
      pixels[off] = r;
      pixels[off + 1] = g;
      pixels[off + 2] = b;
      pixels[off + 3] = 255;
    }
  }
  context.putImageData(id, 0, 0);*/
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function draw_distance_thrown(ctx, x, y, distance) {

  ctx.fillStyle = '#ddd';
  ctx.font = '9pt Arial';
  ctx.fillText(project_angle + '° : ' + project_distance, x, 15);

  ctx.fillStyle = '#ffffff';
  ctx.font = '9pt Arial';
  ctx.fillText(' Distance: ' + numberWithCommas(distance) + ' m ', x, y);
}

function draw_energy_collected(ctx, x, y, val = 5, bonus = 0, distance) {

  if (bonus < 1) {
    bonus = 1;
  }

  ctx.fillStyle = '#1bffe8ee';
  ctx.font = '26pt Arial';
  ctx.fillText(' ⚡ +' + val + ' ', x, y);

  if (true) {
    ctx.font = '11pt Arial';

    if (draw_em_collected == '') {
      //draw_em_collected = '⚪'
    }
    let fill = draw_em_collected + ' ' + global_ener_collected + ' ';

    let fill_y = 33
    if (bonus > 1) {
      fill = fill + '✖️ ' + bonus;
      //fill_y = 50;
    }
    console.log(fill)
    ctx.fillText(fill, x, y + fill_y);

    if (bonus > 1) {
      ctx.fillText(' Distance bonus ', x, y + 50);
      //ctx.font = '9pt Arial';
      //ctx.fillText(distance, x, y + 75);
      //ctx.fillText(' Distance ' + distance + ' ', x, y + 70);
    }
  }

}

function draw_emoji(ctx, x, y, em, size = 30) {

  touchpad_canvas_ctx.font = size + 'pt Arial';
  touchpad_canvas_ctx.fillText(em, x, y);
}

function wrapText(context, text, x, y, maxWidth, lineHeight) {

  if (text == null) {
    return;
  }

  var words = text.split(' ');
  var line = '';

  for(var n = 0; n < words.length; n++) {
    var testLine = line + words[n] + ' ';
    var metrics = context.measureText(testLine);
    var testWidth = metrics.width;
    if (testWidth > maxWidth && n > 0) {
      context.fillText(line, x, y);
      line = words[n] + ' ';
      y += lineHeight;
    } else {
      line = testLine;
    }
  }
  context.fillText(line, x, y);
}

function draw_info(ctx, x, y, info, size = 10, color = '#1bffe8ee') {

  ctx.fillStyle = color;
  ctx.font = size + 'pt Arial';
  //ctx.fillText(info, x, y);

  wrapText(ctx, info, x, y, 200, 20)
}

function draw_circle(ctx, x, y, radius, color){

  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI*2);
  ctx.fillStyle = color;
  ctx.fill();
  ctx.closePath();
}

function draw_instructions() {

  draw_info(touchpad_canvas_ctx, touchpad_canvas.width / 3, 100, aa_instructions);
  //draw_info(touchpad_canvas_ctx, touchpad_canvas.width / 3, 120, '');

}
function clear_touchpad_canvas(reset = false) {

  //project_distance = 0;

  if (touchpad_canvas_ctx != null) {

    /*touchpad_canvas = document.getElementById('touchpad_cvs');
    const offsets = touchpad_canvas.getBoundingClientRect();
    touchpad_canvas.width = offsets.right-offsets.left;
    touchpad_canvas.height = offsets.bottom-offsets.top;
    touchpad_ratio = touchpad_canvas.width / touchpad_canvas.height;*/

    touchpad_canvas_ctx.clearRect(0, 0, touchpad_canvas.width, touchpad_canvas.height);
    if (reset && is_throwing_mode && !is_throwing && map_projectile) {
      //draw_circle(touchpad_canvas_ctx, touchpad_canvas.width / 2, 40, 20, '#dfff4f')
      draw_emoji(touchpad_canvas_ctx, touchpad_canvas.width / 2, 50, aa_em);
      if (mebot_md.power_avail <= 0) {
        draw_info(touchpad_canvas_ctx, touchpad_canvas.width / 2, 120, 'No power!', 12, '#dd0000');
      }
    }
    if (!map_projectile) {
      draw_instructions()
    }

  
    if (draw_energy_colleted > 0) {
      draw_energy_collected(touchpad_canvas_ctx, touchpad_canvas.width / 2, 115, draw_energy_colleted, distance_bonus, distance_thrown);
    }
    if (distance_thrown > 0) {
      draw_distance_thrown(touchpad_canvas_ctx, touchpad_canvas.width / 2, 195, distance_thrown)
    }

    if (is_throwing) {
      draw_info(touchpad_canvas_ctx, touchpad_canvas.width / 2, 120, aa_em + '💨', 22, '#dd0000');
    }

  }
}

function update_touchpad_canvas() {

  if (is_throwing_mode && touchpad_canvas_ctx && map_projectile) {

  //console.log('update_touchpad_canvas')
//    context.fillStyle = 'red';
//    context.fillRect(0, 0, mebot_canvas.width-400, mebot_canvas.height-400);
//    context.fillStyle = 'white';
//    context.fillRect(10, 10, mebot_canvas.width - 300, mebot_canvas.height - 300);
  touchpad_canvas_ctx.fillStyle = '#1bffe8ee';
  touchpad_canvas_ctx.textAlign = "center";
  touchpad_canvas_ctx.textBaseline = "middle";
  touchpad_canvas_ctx.clearRect(0, 0, touchpad_canvas.width, touchpad_canvas.height);

  //project_distance = Math.round(move_endY-touchpad_offset_y-40);
  //d = √((x2 - x1)² + (y2 - y1)²)
  if (move_endY-touchpad_offset_y-50 > 0) {
    project_distance = Math.sqrt( ((move_endY-touchpad_offset_y-50)**2) + ((touchpad_offset_x - move_endX)+(touchpad_canvas.width/2))**2 )
    project_distance = Math.round( project_distance );
  } else {
    project_distance = 0;
  }

  //FIX IT
  project_angle = (-1) * Math.round( (touchpad_offset_x - move_endX) + (touchpad_canvas.width/2) )
  project_angle = Math.round(project_angle/(2.5 + (project_distance/100) ));
  //project_angle = Math.round(project_angle/(2.5 + (1/project_distance) ));
  //project_angle = Math.round(project_angle / (project_distance/100) );

  //project_angle = (move_endY-touchpad_offset_y-50)  / (touchpad_offset_x - move_endX)+(touchpad_canvas.width/2)
  //*(move_endY-touchpad_offset_y)/200 );

  touchpad_canvas_ctx.strokeStyle = '#1bffe8ee';
  touchpad_canvas_ctx.beginPath()
  touchpad_canvas_ctx.moveTo(touchpad_canvas.width / 2, 40); // Move the pen to (30, 50)
  touchpad_canvas_ctx.lineTo((move_endX-touchpad_offset_x), move_endY-touchpad_offset_y); // Draw a line to (150, 100)
  touchpad_canvas_ctx.stroke();

  //draw_circle(touchpad_canvas_ctx, (move_endX-touchpad_offset_x), move_endY-touchpad_offset_y, 20, '#dfff4f')
  draw_emoji(touchpad_canvas_ctx, move_endX-touchpad_offset_x, move_endY-touchpad_offset_y, aa_em);

  touchpad_canvas_ctx.font = '9pt Arial';
  //touchpad_canvas_ctx.fillText(move_endX + ' : ' + move_endY, touchpad_canvas.width / 2, 120);
  touchpad_canvas_ctx.fillText(project_angle + '° : ' + project_distance, touchpad_canvas.width / 2, 15);

  if (draw_energy_colleted > 0) {
    draw_energy_collected(touchpad_canvas_ctx, touchpad_canvas.width / 2, 115, draw_energy_colleted, distance_bonus, distance_thrown);
  }

  if (distance_thrown > 0) {
    draw_distance_thrown(touchpad_canvas_ctx, touchpad_canvas.width / 2, 195, distance_thrown)
  }

  }
}


async function load_mebot_texture(material, texture_src) {
  var texture_loader = new THREE.TextureLoader();

  texture_loader.load(texture_src, function ( texture ) {

    console.log('loading texture: ' + texture_src)
    material.color.setHex( 0xffffff );
    material.opacity = 0.5;
    material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
    material.map = texture;
    material.map.needsUpdate = true;
  });
}

async function load_habitat_texture(planet_obj) {

  //check if this habitat loaded texture yet first
  let planet_src = planet_obj.planet_src;

  if (planet_obj.state == 2) {
    planet_src = 'https://mebots.s3.amazonaws.com/broken_habitat6_500.png';
  }
  if (planet_obj.state == 3) {
    planet_src = 'https://mebots.s3.amazonaws.com/broken_habitat7_complete_500.png';
  }

  let material = planet_obj.material;

  /*
  const video = document.getElementById("video");
  //video.onloadeddata = function () {
  video.play();
  //};
  const videoTexture = new THREE.VideoTexture(video);
  videoTexture.needsUpdate = true;
  //const videoMaterial = new THREE.MeshBasicMaterial({
  //  map: videoTexture,
  //  side: THREE.FrontSide,
  //  toneMapped: false,
  //});
  //videoMaterial.needsUpdate = true;
  */

  if (!planet_obj.texture_loaded) {

    var texture_loader = new THREE.TextureLoader();
    //texture_loader.load('textures/6a36854d793d2787f29c081a73593a8f93fae48a.png', function ( texture ) {
    texture_loader.load(planet_src, function ( texture ) {

      //material.color = 0xffffff;
      //material.color = ;

      //see: https://threejs.org/docs/#api/en/loaders/TextureLoader

      if (rgb_encoding) {
        texture.encoding = THREE.sRGBEncoding;
      }
      material.color.setHex( 0xffffff );
      material.opacity = 1;
      material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
      material.map = texture;
      //material.map = videoTexture,

      material.map.needsUpdate = true;
      planet_obj.texture_loaded = true;

      console.log('loaded planet texture')
    });

  }
}

async function log_throw(es, dist) {

  //visit habitat
  const res = await fetch(
    "https://api.forever.today/?method=throw_item",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        es, //energy spent
        dist
      }),
    }
  );

  const json = await res.json();
}

async function visit_and_pickup(planet_src, habitat_name, hid, ec, db, dist) {

  //TODO fix me: there should be distance_bonus+1 for empty habitats (since we're removing -1 on the backend when add energy)

  //visit habitat
  const res = await fetch(
    "https://api.forever.today/?method=visit_habitat",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        habitat_id: hid,
        ec, //energy_collected
        db, //distance_bonus
        dist
      }),
    }
  );

  const json = await res.json();
  console.log('visited habitat')

  visit_habitat(planet_src, habitat_name);
  pickup_artitifact(hid, habitat_name, false);

}

async function update_habitat_texture(habitat, src, state) {

//  async function load_habitat_texture(planet_obj) {

//check if this habitat loaded texture yet first
//let planet_src = planet_obj.planet_src;
console.log(habitat)

let habitat_name = habitat_names[habitat]
let material = objects[habitat_name].material;

if (objects[habitat_name].state == state) {
  //already destroyed
  console.log('already destroyed')
  return;
}

console.log('material: ')
console.log(material)

//if (!planet_obj.texture_loaded) {

  var texture_loader = new THREE.TextureLoader();
  //texture_loader.load('textures/6a36854d793d2787f29c081a73593a8f93fae48a.png', function ( texture ) {
  texture_loader.load(src, function ( texture ) {

    //material.color = 0xffffff;
    //material.color = ;

    //see: https://threejs.org/docs/#api/en/loaders/TextureLoader

    if (rgb_encoding) {
      texture.encoding = THREE.sRGBEncoding;
    }
    material.color.setHex( 0xffffff );
    material.opacity = 1;
    material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
    material.map = texture;
    material.map.needsUpdate = true;
    //planet_obj.texture_loaded = true;

    //rotate (so they look differently)
    objects[habitat_name].model.rotation.y += (Math.PI*2 * Math.random())

    console.log('updated planet texture')
    objects[habitat_name].state = state;
  });

//}
//}
//  update_habitat_texture
}

async function load_habitat_globe(planet_src, hid, planet_name, has_visited = 0, opacity = 1, item = '', is_hit = 0, state = 1) {

//if (planet_src != '') {

//destroyed habitat
//planet_src = 'https://mebots.s3.amazonaws.com/5a6229361ef155b7e8bb5154b116565a39a2990a_destroyed1.png'

//habitat globe
const habitat_globe = new THREE.Object3D();
//var texture_loader = new THREE.TextureLoader();
//texture_loader.load('textures/6a36854d793d2787f29c081a73593a8f93fae48a.png', function ( texture ) {
//texture_loader.load(planet_src, function ( texture ) {

    //console.log('adding globe')
    //var geometry = new THREE.SphereGeometry(20, 2, 2);
    //var material = new THREE.MeshBasicMaterial( { map: texture, overdraw: 0.5 } );
    //var mesh = new THREE.Mesh(geometry, material);
    //mesh.position.copy(new THREE.Vector3(0, 68, 0));
    //mesh.position.copy(new THREE.Vector3(-44.67, 75.3, -30.74));

    //const geometry = new THREE.SphereGeometry( 50, 32, 16 );
    var radius = 50;
    var radialSegments = 32;
    var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
    //var hemiSphere = new THREE.Mesh(hemiSphereGeom, material);

    var ring_color = 0xffffff;
    if (has_visited == 1) {
      ring_color = _visited_color;
    }
    const material = new THREE.MeshBasicMaterial( {
        //map: texture,
        opacity: 0.4,
        color: 0x999999,
        //overdraw: 0.5,
        transparent: true,
        side: THREE.DoubleSide,
    } );
    //const material = new THREE.MeshBasicMaterial( { color: 0x0000ff } );
    const sphere = new THREE.Mesh( hemiSphereGeom, material );

    let disk = null;
    if (has_visited == 1) {
      const disk_geo = new THREE.CylinderGeometry(70, 70, 2, 32);
      const disk_mat = new THREE.MeshBasicMaterial( {color: ring_color, opacity: 1} );
      disk = new THREE.Mesh(disk_geo, disk_mat);
      disk.name = planet_name;
      habitat_globe.add(disk);

      habitat_globe_models_visited[planet_src] = planet_name;

      //visited_disk = disk;
      //visited_disk.material.color.getHSL(visited_disk_color)
    }

    /*if (item != '' && !habitat_globe_models_has_item.includes(planet_src)) {

      add_habitat_item(habitat_globe, planet_name, item);
      habitat_globe_models_has_item.push(planet_src);
      console.log('added habitat item')
    }*/

    //mesh.scale.set(1, 1, 1);
    //console.log(sphere)
    sphere.name = planet_name;
    habitat_globe.add(sphere);

    objects[planet_name] = {
      type: 'habitat',
      model: habitat_globe,
      visited_disk: disk,
      name: null,
      texture: '',
      planet_src,
      hid,
      item: null,
      artifact: null,
      texture_loaded: false,
      material,
      orig_material: null,
      state //built state
    }

    habitat_names[planet_src] = planet_name;

    if (planet_src != '') {
      load_habitat_texture(objects[planet_name]);
    }

  //} );
  //habitat_globe.position.copy(new THREE.Vector3(-24.67, 72.3, -34.74));
  //this.scene.add(habitat_globe);

  habitat_globe.name = planet_src;
  //console.log(planet_src);

  return habitat_globe;
}

//setOpacity( myGroup, 0.5 );
function setMarkerOpacity(opacity) {
  marker.material.opacity = opacity;
}

function setOpacity(obj, opacity) {
  obj.children.forEach((child)=>{
    setOpacity(child, opacity);
  });
  if (obj.material) {
    //console.log('setting opacity ' + opacity)
    obj.material.opacity = opacity;
    obj.material.transparent = true;
    //console.log(obj.name + ' to: ' + opacity)
    //console.log('now opacity ' + obj.material.opacity)
  };
}

function zapBody(obj = null, color = 0x4380B7, zap_color = 0x00d9ff) {

  if (zap_state == 0 && !is_zapping && obj != null) {
    is_zapping = true;
    obj_zapped = obj;
    orig_color = color;
  }

  if (is_zapping && obj_zapped != null) {

    zap_state++;
    setBodyColor(obj_zapped, zap_color*(zap_state/15)  )
    //setColor(obj_zapped, 0xff*(zap_state/15)*256 + 0xd9*(zap_state/15) )

    //console.log('zapping ' + zap_state)

    if (zap_state >= 15) {

      //console.log('done zapping')
      //setColor(obj_zapped, 0xFFAE05)
      setBodyColor(obj_zapped, orig_color)
      obj_zapped = null;
      zap_state = 0;
      is_zapping = false;
    }
  }
}

function setRGBEncoding(obj) {
  obj.children.forEach((child)=>{
    setRGBEncoding(child);
  });

//  if ( obj.material && obj.material.map ) {
  if ( obj.material ) {
    //console.log(obj.material)
    //console.log('object body: ' + obj.name + ' : ' + obj.material)
    obj.material.metalness = 0.2;
    //obj.material.roughness = 0.1;
    //obj.material.color = new THREE.Color(0x7658ef);
    if (rgb_encoding) {
      obj.material.map.encoding = THREE.sRGBEncoding;
      console.log('material encoding: ' + obj.material.map.encoding)
    }
  }

  if ( obj.name == 'Zombie' && obj.material ) {
    console.log('zombie body: ' + obj.uuid)
  }
}

function setInitialBodyColor(mebot_name, obj, color, texture_src = '', is_owner = 0) {
  obj.children.forEach((child)=>{
    setInitialBodyColor(mebot_name, child, color, texture_src, is_owner);
  });

  //console.log(obj.name)
  if ( is_owner == 1 && obj.name == 'heart_lowpoly_3' && obj.material ) {
    console.log('found heart')
    //obj.material.transparent = true;
    mebot_hearts[0] = obj;
  }

  if ( obj.name == 'Sphere' && obj.material ) {
    //add to known bodies
    //console.log(obj.uuid)
    mebot_bodies[obj.uuid] = 1;
    mebot_bodies[mebot_name] = obj;

    console.log(texture_src)
    if (texture_src != '') {
      //load_mebot_texture(obj.material, texture_src)
    }

    //console.log(obj.material)
    obj.material.color.setHex( color );
    //console.log('now opacity ' + obj.material.opacity)
  };
}

function setZombieBodyColor(obj, color) {
  obj.children.forEach((child)=>{
    setZombieBodyColor(child, color);
  });

  //if ( (obj.name == 'Zombie' || obj.uuid in mebot_bodies) && obj.material ) {
  if ( (obj.name == 'Zombie') && obj.material ) {
    //console.log(obj.material)
    obj.material.color.setHex( color );
    //obj.material.map.needsUpdate = true;
    //console.log('now opacity ' + obj.material.opacity)
  };
}

function setBodyColor(obj, color) {

  obj.children.forEach((child)=>{
    setBodyColor(child, color);
  });

  if ( (obj.name == 'Sphere' || obj.uuid in mebot_bodies) && obj.material ) {
    //console.log(obj.material)
    obj.material.color.setHex( color );
    //console.log('now opacity ' + obj.material.opacity)
  };
}



//FIX
  var mebot_canvas = document.createElement('canvas');
  mebot_canvas.width = 512;
  mebot_canvas.height = 512;
  var context = mebot_canvas.getContext('2d');
  context.clearRect(0, 0, mebot_canvas.width, mebot_canvas.height);
  var id = context.getImageData(0, 0, mebot_canvas.width, mebot_canvas.height);
  var pixels = id.data;
  var x, y;
  var r, g, b, off;
/*
  for (x = 0; x < 40; x++) {
    for (y = 0; y < 40; y++) {

      //var x = Math.floor(Math.random() * canvasWidth);
      //var y = Math.floor(Math.random() * canvasHeight);
      r = Math.floor(Math.random() * 256);
      g = Math.floor(Math.random() * 256);
      b = Math.floor(Math.random() * 256);
      off = (y * id.width + x) * 4;
      pixels[off] = r;
      pixels[off + 1] = g;
      pixels[off + 2] = b;
      pixels[off + 3] = 255;
    }
  }
  context.putImageData(id, 0, 0);*/

  function changeCanvas() {
    context.font = '30pt Arial';
//    context.fillStyle = 'red';
//    context.fillRect(0, 0, mebot_canvas.width-400, mebot_canvas.height-400);
//    context.fillStyle = 'white';
//    context.fillRect(10, 10, mebot_canvas.width - 300, mebot_canvas.height - 300);
    context.fillStyle = '#1bffe8ee';
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.clearRect(0, 0, 512, 512);
    context.fillText(new Date().getTime() + '  ' + mebot_badges, mebot_canvas.width / 2, mebot_canvas.height / 2);
}
var texture_text = new THREE.Texture(mebot_canvas);
changeCanvas();
// END FIX



function setMebotTexture(mebot_name, texture_src) {

  var texture_loader = new THREE.TextureLoader();
//  texture_loader.center = new THREE.Vector2(0.5, 0.5);
//  texture_loader.rotation = Math.PI;

  //THREE.ImageUtils.crossOrigin = '';
  //texture_loader.crossOrigin = '*';
  //console.log('origin: ' + texture_loader.crossOrigin)
  texture_loader.load(texture_src, function ( texture ) {

    if (rgb_encoding) {
      texture.encoding = THREE.sRGBEncoding;
    }
    texture.center = new THREE.Vector2(0.5, 0.47);
    texture.rotation = Math.PI;
    texture.repeat.set(2.1, 1.6);

    //texture.flipY = true;
    //texture.wrapS = THREE.RepeatWrapping;
    //texture.repeat.x = - 1;
    //texture.flipY = true;
    //texture.flipY = true;
    const points = [];
    for ( let deg = 0; deg <= 180; deg += 6 ) {
          const rad = Math.PI * deg / 180;
          const point = new THREE.Vector2( ( 0.74 + .08 * Math.cos( rad ) ) * Math.sin( rad ), Math.cos( rad ) ); // the "egg equation"
          //console.log( point ); // x-coord should be greater than zero to avoid degenerate triangles; it is not in this formula.
          points.push( point );
    }
    const egg_geometry = new THREE.LatheGeometry( points, 32 );

    var radius = 2;
        var radialSegments = 32;
        //var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
        var hemiSphereGeom = new THREE.SphereGeometry(radius, 32, 16);

    // from https://tympanus.net/codrops/2021/10/27/creating-the-effect-of-transparent-glass-and-plastic-in-three-js/
    //const material = new THREE.MeshPhysicalMaterial( {
    const material = new THREE.MeshBasicMaterial( {
        map: texture,
        opacity: 1,
        color: 0xffffff,
        //overdraw: 0.5,
        transparent: true,
        side: THREE.DoubleSide,
//        thickness: 0.5,
//        roughness: 0.7,
    } );

      const mebot_soul = new THREE.Mesh( egg_geometry, material );

      //mebot_soul.material.map = texture;
      //mebot_soul.material.map.needsUpdate = true;

      //material.color.setHex( 0xffffff );
      //material.opacity = 1;
      //material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
      //material.map = texture;
      //material.map.needsUpdate = true;

      mebot_soul.rotation.y = 3.0;
      //const mebot_soul = new THREE.Mesh( box_geometry, [empty_mat, empty_mat, empty_mat, empty_mat, material, empty_mat] );
      //const mebot_soul = new THREE.Mesh( box_geometry, [empty_mat, material, empty_mat, material, material, empty_mat] );
      //const mebot_soul = new THREE.Mesh( box_geometry, material );
      //mebot_soul.scale.set(.01, .01, .01);
      //mebot_soul.scale.set(.07, .07, .07);
      //mebot_soul.position.y = 100;
      mebot_soul.scale.set(1.01, 1.01, 1.01);
      setName(mebot_soul, mebot_name)
      objects[mebot_name].model.add(mebot_soul);
      //objects[mebot_name].model.geometry = egg_geometry;
      //objects[mebot_name].model.material = material

      //mebot_bodies[mebot_name].add(mebot_soul)
      //mebot_soul.scale.set(20.1, 20.1, 20.1);
      //mebot_soul.position.y = 73;
      //objects[mebot_name].model.add(mebot_soul);
      //map_scene.add(mebot_soul);
      console.log('front added')

      var texture_loader1 = new THREE.TextureLoader();
      texture_src = 'https://mebots.s3.amazonaws.com/mebot_back_dark_semi.png'
      texture_loader1.load(texture_src, function ( texture ) {

        const points = [];
        for ( let deg = 0; deg <= 180; deg += 6 ) {
          const rad = Math.PI * deg / 180;
          const point = new THREE.Vector2( ( 0.74 + .08 * Math.cos( rad ) ) * Math.sin( rad ), Math.cos( rad ) ); // the "egg equation"
          //console.log( point ); // x-coord should be greater than zero to avoid degenerate triangles; it is not in this formula.
          points.push( point );
        }
        const egg_geometry = new THREE.LatheGeometry( points, 32 );

        if (rgb_encoding) {
          texture.encoding = THREE.sRGBEncoding;
        }
        texture.center = new THREE.Vector2(0.5, 0.48);
        texture.rotation = Math.PI;
        texture.repeat.set(3, 2);

        if (rgb_encoding) {
          texture_text.encoding = THREE.sRGBEncoding;
        }
        texture_text.center = new THREE.Vector2(0.5, 0.5);
        texture_text.rotation = Math.PI;
        texture_text.repeat.set(1.8, 1.2);

        const material_back = new THREE.MeshBasicMaterial( {
          map: texture,
          opacity: 1,
          color: 0xffffff,
          //overdraw: 0.5,
          transparent: true,
          //alphaTest: 0.5,
          side: THREE.DoubleSide,
        });

        //back texture
        const mebot_back = new THREE.Mesh( egg_geometry, material_back );
        //mebot_back.rotation.y = 3.0;
        mebot_back.scale.set(1.02, 1.02, 1.02);
        setName(mebot_back, mebot_name)
        objects[mebot_name].model.add(mebot_back);
        console.log('back added')
      });
  });

}

function setMebotModel(mebot_name, texture_src) {

  var texture_loader = new THREE.TextureLoader();
  let mebot_soul = null;

        var radius = 100;
        //var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
        var hemiSphereGeom = new THREE.SphereGeometry(radius, 32, 16);

        const points = [];
        for ( let deg = 0; deg <= 180; deg += 6 ) {
          const rad = Math.PI * deg / 180;
          const point = new THREE.Vector2( ( 0.72 + .08 * Math.cos( rad ) ) * Math.sin( rad ), - Math.cos( rad ) ); // the "egg equation"
          //console.log( point ); // x-coord should be greater than zero to avoid degenerate triangles; it is not in this formula.
          points.push( point );
        }
        const egg_geometry = new THREE.LatheGeometry( points, 32 );

  const material = new THREE.MeshBasicMaterial( {
        opacity: 1,
        color: 0xffffff,
        //overdraw: 0.5,
        transparent: true,
        side: THREE.DoubleSide,
  } );

  mebot_soul = new THREE.Mesh( egg_geometry, material );
  mebot_soul.rotation.y += Math.PI*0.9;
  mebot_soul.scale.set(20, 20, 20);
  //mebot_soul.scale.set(0.1, 0.1, 0.1);


  texture_loader.load(texture_src, function ( texture ) {
    mebot_soul.material.map = texture;
    mebot_soul.material.opacity = 1;
    mebot_soul.material.map.needsUpdate = true;
    console.log('loaded mebot body texture')
  });

  return mebot_soul;
}

const randomIntInRange = (min, max) =>  Math.floor(Math.random() * (max - min + 1)) + min;
const randomSign = () => (Math.random() < 0.5 ? -1 : 1);

class ExplosionEffect {

/*  _size = null;
  _effectDuration = 0;
  _currentDuration = 0;
  _fireMesh = null;
  _mesh = null;
  _position = null;*/

  constructor(position, size, color = 0xff4500) {

    this._size = size;
    this._effectDuration = 0.5;
    this._currentDuration = 1;
    this._fireMesh = new THREE.Mesh();
    this._mesh = new THREE.Mesh();
    this._position = position;
    this._color = color;

    this._mesh.position.set(
      position.x,
      position.y,
      position.z
    );

    this._mesh.scale.set(20, 20, 20);

    this._currentDuration = this._effectDuration;
  }

  get_mesh() {
    return this._mesh;
  }

  async load() {
    // define generic particle geometry
    const particleGeometry = new THREE.DodecahedronGeometry(this._size, 0);
    const totalParticles = randomIntInRange(7, 13);
    const fireMaterial = new THREE.MeshPhongMaterial({ color: this._color });

    for (let i = 0; i < totalParticles; i++) {
      // random angle
      const particleAngle = Math.random() * Math.PI * 2;
      const fireGeometry = particleGeometry.clone(); // need to clone to have unique particles
      const particleSize =
        0.3 * this._size + Math.random() * this._size * 0.4 * randomSign();

      fireGeometry.scale(particleSize, particleSize, particleSize);
      fireGeometry.rotateX(Math.random() * Math.PI);
      fireGeometry.rotateY(Math.random() * Math.PI);
      fireGeometry.rotateZ(Math.random() * Math.PI);

      const fireParticle = new THREE.Mesh(fireGeometry, fireMaterial);
      fireParticle.userData = {
        angle: particleAngle,
        speed: 0.5 + Math.random() * 2.5,
      };
      this._fireMesh.add(fireParticle);
      //console.log('aded particle: ')
    }
    this._mesh.add(this._fireMesh);
  };

  update(deltaT) {
    this._currentDuration -= deltaT;
    if (this._currentDuration <= 0) {
      this._shouldDispose = true;
      this.dispose()
      return 0;
    }

    //console.log('exploding')

    // reduce the particles as the effects progresses
    const scale = this._currentDuration / this._effectDuration;
    this._fireMesh.children.forEach((element) => {
      const fireParticle = element;
      const angle = fireParticle.userData["angle"];
      const speed = fireParticle.userData["speed"];
      const computedMovement = new THREE.Vector3(
        -speed * Math.sin(angle) * deltaT,
        speed * Math.cos(angle) * deltaT,
        -speed * Math.cos(angle) * deltaT,
      );
      fireParticle.scale.set(scale, scale, scale);
      fireParticle.position.add(computedMovement);
      if (fireParticle.position.y < 0) {
        fireParticle.position.y = 0;
      }
    });

    return 1;
  };

  dispose() {
    this._fireMesh.children.forEach((element) => {
      const fireParticle = element;
      (fireParticle.material).dispose();
      fireParticle.geometry.dispose();
      this._fireMesh.remove(fireParticle);
    });
    this._mesh.remove(this._fireMesh);
  };
}

function setBodyTexture(mebot_name, texture_src) {
  //obj.children.forEach((child)=>{
  //  setBodyTexture(obj, texture_src);
  //});

  //mebot_bodies[mebot_name] = obj.uuid;

  if ( (mebot_name in mebot_bodies) && mebot_bodies[mebot_name].material ) {

    var material = mebot_bodies[mebot_name].material;
    //TODO: load body texture only once per model
    if (true) {

      //texture_src = 'https://mebots.s3.amazonaws.com/mebot_1024_sample_2.png'
      var texture_loader = new THREE.TextureLoader();
      //texture_loader.load('textures/6a36854d793d2787f29c081a73593a8f93fae48a.png', function ( texture ) {
      texture_loader.load(texture_src, function ( texture ) {

        console.log('loading: ' + texture_src)
        //material.color = 0xffffff;
        //material.color = ;

        //see: https://threejs.org/docs/#api/en/loaders/TextureLoader
        //mebot_bodies[mebot_name].material = new THREE.MeshBasicMaterial( { color: 0xffffff } );

/*        mebot_bodies[mebot_name].material = new THREE.MeshBasicMaterial( {
          //map: texture,
          opacity: 0.4,
          color: 0x999999,
          //overdraw: 0.5,
          transparent: true,
          side: THREE.DoubleSide,
        } );*/

        var radius = 100;
        var radialSegments = 32;
        //var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
        var hemiSphereGeom = new THREE.SphereGeometry(radius, 32, 16);

        const points = [];
        for ( let deg = 0; deg <= 180; deg += 6 ) {
          const rad = Math.PI * deg / 180;
          const point = new THREE.Vector2( ( 0.72 + .08 * Math.cos( rad ) ) * Math.sin( rad ), Math.cos( rad ) ); // the "egg equation"
          //console.log( point ); // x-coord should be greater than zero to avoid degenerate triangles; it is not in this formula.
          points.push( point );
        }
        const egg_geometry = new THREE.LatheGeometry( points, 32 );

    const material = new THREE.MeshBasicMaterial( {
        map: texture,
        opacity: 1,
        color: 0xffffff,
        //overdraw: 0.5,
        transparent: true,
        side: THREE.DoubleSide,
    } );

    const empty_mat = new THREE.MeshBasicMaterial( {
        opacity: 0,
        color: 0xffffff,
        transparent: true,
        side: THREE.DoubleSide,
    } );
      //const material = new THREE.MeshBasicMaterial( { color: 0x0000ff } );

      //mebot_bodies[mebot_name] = new THREE.Mesh( hemiSphereGeom, material );
      //mebot_bodies[mebot_name].geometry = hemiSphereGeom;
      //mebot_bodies[mebot_name].material = material;

      //var box_geometry = new THREE.BoxGeometry( 10, 10, 10 );

      //material.map = texture;
      const mebot_soul = new THREE.Mesh( egg_geometry, material );
      mebot_soul.rotation.y = 3.0;
      //const mebot_soul = new THREE.Mesh( box_geometry, [empty_mat, empty_mat, empty_mat, empty_mat, material, empty_mat] );
      //const mebot_soul = new THREE.Mesh( box_geometry, [empty_mat, material, empty_mat, material, material, empty_mat] );
      //const mebot_soul = new THREE.Mesh( box_geometry, material );
      //mebot_soul.scale.set(.01, .01, .01);
      //mebot_soul.scale.set(.07, .07, .07);
      //mebot_bodies[mebot_name].add(mebot_soul)
      mebot_soul.scale.set(1.01, 1.01, 1.01);
      objects[mebot_name].model.add(mebot_soul);
  
//    mebot_bodies[mebot_name].needsUpdate = true;
//    mebot_bodies[mebot_name].material.needsUpdate = true;

      //material.color.setHex( 0xffffff );
      //material.opacity = 1;
      //material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
      //material.map = texture;

      /*
        //mebot_bodies[mebot_name].material.color.setHex( 0xffffff );
        mebot_bodies[mebot_name].material.opacity = 1;
        mebot_bodies[mebot_name].material.transparent = true; //TODO: pio, figure out how to set transparent to false with texture still working
        mebot_bodies[mebot_name].material.map = texture;
        mebot_bodies[mebot_name].material.side = THREE.DoubleSide;
        mebot_bodies[mebot_name].material.map.needsUpdate = true;
      */
        //mebot_bodies[mebot_name].rotation.y -= 1.2;
        //mebot_bodies[mebot_name].rotation.x -= 0;
        //mebot_bodies[mebot_name].rotation.z -= 0;
        //mebot_bodies[mebot_name].material.needsUpdate = true;

        //planet_obj.texture_loaded = true;

        //console.log(mebot_bodies[mebot_name].material)
        console.log('loaded mebot body texture')
      });

    }

    //console.log(obj.material)
    //obj.material.color.setHex( color );
    //console.log('now opacity ' + obj.material.opacity)
  };
}

function setColor(obj, color) {
  obj.children.forEach((child)=>{
    setColor(child, color);
  });
  if ( obj.material ) {
    //console.log('material color: ');
    //console.log(obj.material.color)
    //console.log(obj.material)
    obj.material.color.setHex( color );
    //console.log('now opacity ' + obj.material.opacity)
  };
}

function setName(obj, name) {
  obj.children.forEach((child)=>{
    setName(child, name);
  });
  obj.name = name
  return;
  if ( obj.material ) {
    //console.log(obj.material)
    obj.material.color.setHex( color );
    //console.log('now opacity ' + obj.material.opacity)
  };
}

async function locate_accessories(obj) {

  obj.children.forEach((child)=>{
    setName(child);
  });

  console.log('access: ' + obj.name);

//  glb_items['accessories'].scene.children.forEach((child)=>{
//    console.log('access: ' + child.name);
    //if ( obj.name == 'Zombie' && obj.material ) {
    //  console.log('zombie body: ' + obj.uuid)
    //}

//  });
}

async function load3d(map) {

  //const THREE = window.THREE;

  async function loadModels() {
    const loader = new GLTFLoader;

    //var loader = new GLTFLoader();

    //const gltf = await loader.loadAsync('https://maplibre.org/maplibre-gl-js/docs/assets/34M_17/34M_17.gltf');
    //const gltf = await loader.loadAsync('https://mebots.s3.amazonaws.com/mebot_model5.glb');
    //const gltf = await loader.loadAsync('https://mebots.s3.amazonaws.com/ghost.glb');

    //glb_items['mebot_body'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/mebot_body_1.glb');
    //glb_items['mebot_body'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/mebot_body_heart_left_7.glb');
    //glb_items['mebot_gloves'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/boxing_gloves_6.glb');

    if (is_crown) {
      glb_items['mebot_crown'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/crown_7.glb');
      //glb_items['mebot_crown'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/ether.glb');
      glb_items['mebot_crown'].scene.scale.set(.37, .37, .37);
    //glb_items['mebot_crown'].scene.position.set(0, 100, 0);

    }

    if (is_skateboard) {
      glb_items['accessories'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/accessories.glb');
      locate_accessories(glb_items['accessories'].scene);
    }


    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/blue_demon.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/golem.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/skeleton.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/sharky.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/animated_wizard.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/skeleton_mage.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/shiba_inu.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/mech.glb');
    //setName(glb_items['deamon1'].scene, 'Mecha Mebot');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/alpaca.glb');

    if (is_zombie) {

    glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/zombie.glb');
    //setName(glb_items['deamon1'].scene, 'Zombie');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/zombie_1.glb');
    //glb_items['deamon1'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/zombie_2.glb');
    glb_items['deamon1'].scene.scale.set(26, 26, 26);

    console.log('LOCATING zobmie body')
    setRGBEncoding(glb_items['deamon1'].scene);

    }

    //gltfs.push(await loader.loadAsync('https://mebots.s3.amazonaws.com/mebot_body_1.glb'));
    //gltfs.push(await loader.loadAsync('https://mebots.s3.amazonaws.com/boxing_gloves_3.glb'));
    //gltfs.push(await loader.loadAsync('https://mebots.s3.amazonaws.com/mebot_body_1.glb'));
    //gltfs.push(await loader.loadAsync('https://mebots.s3.amazonaws.com/soldier.glb'));
    //gltfs.push(await loader.loadAsync('https://mebots.s3.amazonaws.com/boxing_gloves_3.glb'));

    /*glb_items['apple'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/cup_of_coffee.glb');
    glb_items['apple'].scene.scale.set(180, 180, 180);
    glb_items['apple'].scene.position.set(0, 60, 0);
    setName(glb_items['apple'].scene, 'Coffee');*/


    //glb_items['apple'] = await loader.loadAsync();

    /*
    loader.load('https://mebots.s3.amazonaws.com/apple.glb', function ( model ) {
      console.log('loaded apple')
      glb_items['apple'] = model;
      glb_items['apple'].scene.scale.set(.18, .18, .18);
      glb_items['apple'].scene.position.set(10, 60, 0);
      setName(glb_items['apple'].scene, 'Apple');
    });*/

    //glb_items['hamburger'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/hamburger.glb');
    //glb_items['hamburger'].scene.scale.set(0.2, 0.2, 0.2);
    //glb_items['hamburger'].scene.position.set(10, 60, 0);
    /*
    glb_items['map_marker'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/map_marker.glb');
    glb_items['map_marker'].scene.scale.set(10, 10, 10);
    glb_items['map_marker'].scene.position.set(0, 160, 0);

    glb_items['steak'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/steak.glb');
    glb_items['steak'].scene.scale.set(3, 3, 3);
    glb_items['steak'].scene.position.set(0, 70, 0);
    setName(glb_items['steak'].scene, 'Steak 🥩');

    glb_items['lightning_bolt'] = await loader.loadAsync('https://mebots.s3.amazonaws.com/lightning_bolt.glb');
    glb_items['lightning_bolt'].scene.scale.set(40, 40, 40);
    glb_items['lightning_bolt'].scene.position.set(10, 80, 0);
    setName(glb_items['lightning_bolt'].scene, 'Energy 🔋');*/

    loader.load('https://mebots.s3.amazonaws.com/map_marker.glb', function ( model ) {
      console.log('loaded marker')
      glb_items['map_marker'] = model;
      glb_items['map_marker'].scene.scale.set(10, 10, 10);
      glb_items['map_marker'].scene.position.set(0, 60, 0);
      glb_items['map_marker'].scene.rotation.y = 4;
      setName(glb_items['map_marker'].scene, 'You are here');
    });
    /*loader.load('https://mebots.s3.amazonaws.com/steak.glb', function ( model ) {
      console.log('loaded steak')
      glb_items['steak'] = model;
      glb_items['steak'].scene.scale.set(3, 3, 3);
      glb_items['steak'].scene.position.set(0, 70, 0);
      setName(glb_items['steak'].scene, 'Steak 🥩');
    });*/
    loader.load('https://mebots.s3.amazonaws.com/lightning_bolt.glb', function ( model ) {
      console.log('loaded lb')
      glb_items['lightning_bolt'] = model;
      glb_items['lightning_bolt'].scene.scale.set(40, 40, 40);
      glb_items['lightning_bolt'].scene.position.set(10, 80, 0);
      setName(glb_items['lightning_bolt'].scene, 'Energy 🔋');
    });

    loader.load('https://mebots.s3.amazonaws.com/flag1.glb', function ( model ) {
      console.log('loaded flag')
      glb_items['artifact_flag'] = model;
      glb_items['artifact_flag'].scene.scale.set(30, 30, 30);
      glb_items['artifact_flag'].scene.position.set(0, 25, 0);
      setName(glb_items['artifact_flag'].scene, 'Artifact 🚩');
    });

  }

  async function deep_copy(model) {
    model.traverse(function(object) {
      if ( object.isMesh ) {
        object.material = object.material.clone();
      }
    });
  }

  function MebotEgg() {

    let mebot_egg = null;

        var radius = 100;
        //var hemiSphereGeom = new THREE.SphereBufferGeometry(radius, radialSegments, Math.round(radialSegments / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);
        var hemiSphereGeom = new THREE.SphereGeometry(radius, 32, 16);

        const points = [];
        for ( let deg = 0; deg <= 180; deg += 6 ) {
          const rad = Math.PI * deg / 180;
          //const point = new THREE.Vector2( ( 0.72 + .08 * Math.cos( rad ) ) * Math.sin( rad ),  -Math.cos( rad ) ); // the "egg equation"
          const point = new THREE.Vector2( ( 0.74 + .08 * Math.cos( rad ) ) * Math.sin( rad ), -Math.cos( Math.PI-rad ) ); // the "flipped egg equation"

          //console.log( point ); // x-coord should be greater than zero to avoid degenerate triangles; it is not in this formula.
          points.push( point );
        }
        const egg_geometry = new THREE.LatheGeometry( points, 32 );

    const material = new THREE.MeshBasicMaterial( {
        opacity: 0.5,
        color: 0xffffff,
        //overdraw: 0.5,
        transparent: true,
        side: THREE.DoubleSide
    } );

    mebot_egg = new THREE.Mesh( egg_geometry, material );
    mebot_egg.scale.set(20, 20, 20);
    //mebot_egg.visible = true;
    setName(mebot_egg, 'Sphere')
    //mebot_soul.scale.set(0.1, 0.1, 0.1);

    return mebot_egg;
  }

  async function bootstrapModel(is_owner = 1) {

    //const model = glb_items['mebot_body'].scene.clone();
    //deep_copy(model);

    //now it's an egg
    const model = MebotEgg().clone();
    deep_copy(model);

    //const model_a = glb_items['mebot_gloves'].scene.clone();
    //deep_copy(model_a);

/*    if (is_owner == 1) {
      console.log(gltfs[is_owner*2+1].animations);
      const mixer = new THREE.AnimationMixer( gltfs[is_owner*2+1] );

      function update () {
	      mixer.update( deltaSeconds );
      }

      const clip = THREE.AnimationClip.findByName( gltfs[is_owner*2+1].animations, 'Run' );
      const action = mixer.clipAction( clip );
      action.play();

      //gltfs[is_owner*2+1].animations.forEach( function ( clip ) {
      //  console.log(clip.name)
	    //  mixer.clipAction( clip ).play();
      //} );
    }*/

    //setColor(model_a, 0xff0000) //red
    //setColor(model_a, 0xff0428) //mebot red
    //setColor(model_a, 0xff66b4) //mebot pink

    //setColor(model_a, 0xfac200) //mebot mustard
    //setColor(model_a, 0x004eff) //mebot blue
    //setColor(model_a, 0xff1f69) //mebot pink/red
    //setColor(model_a, 0xa9c4d8) //mebot grey

    if (is_owner == 0) {
      //setInitialBodyColor(model, 0x222222 + (375*50))
      setColor(model, 0x004eff)
      //setColor(model_a, 0x004eff)
    } else {

      //setInitialBodyColor(model, 0xfac200)
      //setColor(model_a, 0x15ecff) //mebot light blue for gloves

      //ADD CROWN for owner
      if (is_crown) {

        const crown = glb_items['mebot_crown'].scene.clone();
        //setOpacity(crown, 0.6)

        //deep_copy(crown);
        model.add(crown);
        crown.position.y += 0.96;
        crown.position.z += 0.00;
        crown.position.x += 0.00;
      }

    }

    //glove color determines belt level (or mebots gain belts)

    //model1.materials[0].opacity = 0.5;

    //skip adding gloves for now
    //model.add(model_a);

    return model;
  }

  //const sceneOrigin = new maplibregl.LngLat(-74.0066, 40.7135);
  //const model1Location = new maplibregl.LngLat(-74.0066, 40.7135);
  const sceneOrigin = new maplibregl.LngLat(player_coords[0], player_coords[1]);
  let sceneTransform = null;

  //const model2Location = new maplibregl.LngLat(11.5249, 47.6676);

  // Configuration of the custom layer for a 3D model, implementing `CustomLayerInterface`.
  customLayer = {
    id: '3d-model',
    type: 'custom',
    renderingMode: '3d',

    onAdd(map, gl) {

      //camera = new THREE.Camera();
      camera = new THREE.PerspectiveCamera(0, 1, 1, 1);
      //camera = new THREE.PerspectiveCamera(28, window.innerWidth / window.innerHeight, 0.1, 1e6);

      map_scene = new THREE.Scene();
      //map_scene.fog = new THREE.Fog( 0xcccccc, 1, 2 );
      //this.scene.fog = new THREE.Fog(color, near, far);

      /**
         * Setting up three.js scene.
         * We're placing model1 and model2 in such a way that the whole scene fits over the terrain.
         */
      // In threejs, y points up - we're rotating the scene such that it's y points along maplibre's up.
      map_scene.rotateX(Math.PI / 2);
      // In threejs, z points toward the viewer - mirroring it such that z points along maplibre's north.
      map_scene.scale.multiply(new THREE.Vector3(1, 1, -1));
      // We now have a scene with (x=east, y=up, z=north)

      const light = new THREE.DirectionalLight(0xc9c9c9);
      // Making it just before noon - light coming from south-east.
      light.position.set(30, 200, -60).normalize();
      map_scene.add(light);

      if (rgb_encoding) {
        const a_light = new THREE.AmbientLight( 0x999999 ); // soft white light
        map_scene.add( a_light );
      } else {
        const a_light = new THREE.AmbientLight( 0xbbbbbb ); // soft white light
        map_scene.add( a_light );
      }

      // Axes helper to show how threejs scene is oriented.
      //const axesHelper = new THREE.AxesHelper(60);
      //this.scene.add(axesHelper);

      // Getting model elevations (in meters) relative to scene origin from maplibre's terrain.
      const model1Elevation = 0;
      const model1up = 33;

      // Getting model x and y (in meters) relative to scene origin.
      sceneOriginMercator = maplibregl.MercatorCoordinate.fromLngLat(sceneOrigin, 0);
      //sceneOriginMercator.z = -0.0000032959174527730767

      console.log(sceneOrigin)
      console.log('origin: ')
      console.log(sceneOriginMercator)

      //console.log(camera.position.toLngLat())
      //console.log(camera.calculateCameraOptionsFromTo(camera.toLngLat(), camera.toAltitude(), {lng: 1, lat: 1}));

      //const elevation = map42.getFreeCameraOptions();
      //console.log('map elevation: ' + elevation)

/*      const model1Location = new maplibregl.LngLat(player_coords[0], player_coords[1]);
      const model1Mercator = maplibregl.MercatorCoordinate.fromLngLat(model1Location);
      //console.log(model1Mercator)
      const {dEastMeter: model1east, dNorthMeter: model1north} = calculateDistanceMercatorToMeters(sceneOriginMercator, model1Mercator);
      model1.position.set(model1east, model1up, model1north);
      //console.log(model1)
      setOpacity(model1, 0.2)
      setColor(model1, 0xffffff)
//      model1.materials[0].opacity = 0.5; 
      this.scene.add(model1);*/

      setup_entities();
      setup_spheres();

      //habitat_globe.position.set(model1east, model1up-10, model1north+220);

      //add_habitats_to_scene(map_scene)

      //this.scene.add(habitat_globe);

      //const near = 0.1;
      //const far = 0.2;
      //const color = 'lightblue';
//      this.scene.background = new THREE.Color(color);
      //this.scene.fog = new THREE.Fog(color, near, far);
      //this.scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );

      // Use the MapLibre GL JS map canvas for three.js.
      renderer_42 = new THREE.WebGLRenderer({
        canvas: map.getCanvas(),
        context: gl,
        antialias: true
      });

      if (rgb_encoding) {
        renderer_42.outputEncoding = THREE.sRGBEncoding
      }
      //renderer_42.outputEncoding = THREE.LinearEncoding;

      /*
      sceneOriginMercator = maplibregl.MercatorCoordinate.fromLngLat(sceneOrigin, 0);

                    const sceneTransform = {
                        translateX: sceneOriginMercator.x,
                        translateY: sceneOriginMercator.y,
                        translateZ: sceneOriginMercator.z,
                        scale: sceneOriginMercator.meterInMercatorCoordinateUnits()
                    };

                    const m = new THREE.Matrix4().fromArray(mercatorMatrix);
                    const l = new THREE.Matrix4()
                        .makeTranslation(sceneTransform.translateX, sceneTransform.translateY, sceneTransform.translateZ)
                        .scale(new THREE.Vector3(sceneTransform.scale, -sceneTransform.scale, sceneTransform.scale));

                    this.camera.projectionMatrix = m.multiply(l);
        */

      sceneTransform = {
                        translateX: sceneOriginMercator.x,
                        translateY: sceneOriginMercator.y,
                        translateZ: sceneOriginMercator.z,
                        scale: sceneOriginMercator.meterInMercatorCoordinateUnits()
                    };

      console.log(sceneTransform)

      l_vector = new THREE.Matrix4()
                        .makeTranslation(sceneTransform.translateX, sceneTransform.translateY, sceneTransform.translateZ)
                        .scale(new THREE.Vector3(sceneTransform.scale, -sceneTransform.scale, sceneTransform.scale));

      //console.log(l)

      renderer_42.autoClear = false;

      //var selectedObject = this.scene.getObjectByName('https://d2b03905znwqs8.cloudfront.net/b8605248700f59822dfbfd22c7a7a2c2c17b1784.png');
      //this.scene.remove(selectedObject);

          }, //onAdd
                render(gl, mercatorMatrix) {

                    // `queryTerrainElevation` gives us the elevation of a point on the terrain
                    // **relative to the elevation of `center`**,
                    // where `center` is the point on the terrain that the middle of the camera points at.
                    // If we didn't account for that offset, and the scene lay on a point on the terrain that is
                    // below `center`, then the scene would appear to float in the air.
                    //const offsetFromCenterElevation = map.queryTerrainElevation(sceneOrigin) || 0;

                    //const offsetFromCenterElevation = 0;
                    //sceneOriginMercator = maplibregl.MercatorCoordinate.fromLngLat(sceneOrigin, offsetFromCenterElevation);

                    const m = new THREE.Matrix4().fromArray(mercatorMatrix);
                    //console.log(m[0])
                    camera.projectionMatrix = m.multiply(l_vector);

                    renderer_42.resetState(); //TODO? removed for now (pio)
                    renderer_42.render(map_scene, camera);

                    //camera.position.z -= 0.1;
                    //console.log(camera.position)

                    //console.log('triggering repaint')
                    //TURNED IT ON AGAIN!
                    //map.triggerRepaint();

                    //console.log(camera.projectionMatrix)
                    //onLoop()

                    if (display_stats) {
                      stats.update();
                    }
                }
            }; //customLayer

            //const results = await Promise.all([map.once('load'), loadModel()]);
            //const results = await loadModel();
            //const model1 = results[1];

            await loadModels();
            model2 = await bootstrapModel(0); //non-owner
            model2.scale.set(20, 20, 20);
            model1 = await bootstrapModel(1);
            console.log('model loaded')
            model1.scale.set(20, 20, 20);
            model1.rotation.y += Math.PI*0.9;
            //model1.rotation.x = 90;

            //await load_habitats_models();

            /*for (let i = 0; i < 10; i++) {
              habitat_globe = await load_habitat_globe(habitat_globes_scr[ i % 3 ])
              habitat_globe.scale.set(0.6, 0.6, 0.6);
              habitat_globes = [...habitat_globes, habitat_globe];
            }*/

            //habitat_globe = await load_habitat_globe('https://mebots.s3.amazonaws.com/5a6229361ef155b7e8bb5154b116565a39a2990a.png');

            map.addLayer(customLayer);

} //load3d

//new Start().launch("canvas-container");

function bounceMebot(bounce_distance = 2, interrupt = true) {

  if (interrupt || initial_speed <= 0.1) {
    time_counter = Math.sqrt(bounce_distance * 2 / acceleration);
    initial_speed = acceleration * time_counter;
    //console.log('bounced mebot')
  }
}

function rotateCamera(timestamp) {
        // clamp the rotation between 0 -360 degrees
        // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
        map42.rotateTo((timestamp / 100) % 360, {duration: 0});
        // Request the next frame of the animation.
        requestAnimationFrame(rotateCamera);
}

let camInverseProjection = null;
let world_cameraPosition = null;

function onLoop() {

  if (map42 != null) {

    //model1.position.add(forward_step);
    //model1.position.add(forward_step);
    //player_coords[0] += 0.0000001;
    //map42.setCenter(player_coords);

    // reset time_counter back to the start of the bouncing sequence when sphere hits through the bottom position

    //if (is_walking && bounce_mebot) {

    if (bounce_mebot) {

    if (model1.position.y < bottom_position_y) {
      time_counter = 0;
      //this.time_step *= 0.9;
      initial_speed *= 0.7;
    }

    // calculate sphere position with the s2 = s1 + ut + (1/2)gt*t formula
    // this formula assumes the ball to be bouncing off from the bottom position when time_counter is zero
    if (initial_speed > 0.1) {

      model1.position.y = bottom_position_y + initial_speed * time_counter - 0.5 * acceleration * time_counter * time_counter;

      for (let i = 0; i < mebot_models.length; i++) {
        if (i == me_object_n) {
          mebot_models[i].position.y = bottom_position_y + initial_speed * (time_counter + i/10) - 0.5 * acceleration * time_counter * (time_counter + i/10);
        } else {
          mebot_models[i].rotation.y += 0.001;
        }
        //break;
      }

    } else {
      if (is_walking) {
        bounceMebot(100);
      }
    }

    }

    time_counter += time_step;

    if (!zooming_in && !zooming_out) {
      current_pitch = map42.getPitch();
      current_zoom = map42.getZoom();
      //console.log(current_pitch)
    }

    if (zooming_in) {
      if (current_zoom < max_zoom) {
        current_zoom += zoom_step*frame_advance;
        if (current_zoom > max_zoom) {
          current_zoom = max_zoom;
        }
      }
      if (current_pitch < max_pitch) {
        current_pitch += pitch_step*frame_advance;
        if (current_pitch > max_pitch) {
          current_pitch = max_pitch;
        }
      }

      map42.setPitch(current_pitch);
      map42.setZoom(current_zoom);

      //console.log('zooming in: ' + current_pitch + ' : ' + current_zoom)
      if (current_pitch >= max_pitch && current_zoom >= max_zoom && Math.abs(target_orientation-spinner) < 2) {
        //zooming_in = false;

        //don's stop spinning 
        //prev_spin_dir = spinning_dir;
        //spinning_dir = 0;

      } else {
        //console.log(spinner)
      }
    }

    if (zooming_out) {
      if (current_zoom > min_zoom) {
        current_zoom -= zoom_step*frame_advance;
        if (current_zoom < min_zoom) {
          current_zoom = min_zoom;
        }
      }
      if (current_pitch > min_pitch) {
        current_pitch -= pitch_step*frame_advance;
        if (current_pitch < min_pitch) {
          current_pitch = min_pitch;
        }
      }

      map42.setPitch(current_pitch);
      map42.setZoom(current_zoom);

      //console.log('zooming out: ' + current_pitch + ' : ' + current_zoom)
      if (current_pitch <= min_pitch && current_zoom <= min_zoom) {
        zooming_out = false;
        prev_spin_dir = spinning_dir;
        spinning_dir = 0;
      }
    }

    if (spinning_dir != 0) {
      if (spinning_dir == 1) {
        spinner += 1;
      } else {
        spinner -= 1;
      }
      spinner = spinner % 360;
      map42.rotateTo( (spinner) % 360)
    }

    //console.log('here')

    if (spinning_dir == 0) {
      if (Math.abs(setting_north) > 0.1) {
        setting_north = setting_north * 0.9;
        spinner = setting_north;
        map42.setBearing( (spinner) % 360);
      } else {

        //if (frame == 10 && prev_spin_dir != 0) {
        //if (frame == 10) {
          spinner += 0.01*prev_spin_dir;
          //console.log('rotating to: ' + spinner)
          map42.rotateTo( (spinner) % 360 )
        //}

      }
    }

    if (Math.abs(swipe_rotation) > 0.1) {

      //camera.getWorldDirection(vector1);
      //vector1.applyQuaternion( camera.quaternion );
      //console.log(vector1)

      //zooming_out = false;
      //zooming_in = false;

      if (!is_battling) {
        prev_spin_dir = spinning_dir;
        spinning_dir = 0;
      }

      spinner = map42.getBearing();
      spinner += swipe_rotation/10;

      swipe_rotation *= 0.95;
      //swipe_rotation = 0;
      map42.setBearing( (spinner) % 360);

      //console.log('swipe_rotating');
      //map42.rotateTo( (spinner) % 360)
    }

    if (Math.abs(y_playerMoveAngleSpeed) > 0.1 ) {
      spinner = map42.getBearing();
      //map42.rotateTo(spinner)

      if (!is_battling) {
        zooming_out = false;
        zooming_in = false;
        prev_spin_dir = spinning_dir;
        spinning_dir = 0;
      }

      //console.log('pitching')
      current_pitch = map42.getPitch();
      current_pitch += y_playerMoveAngleSpeed;
      map42.setPitch(current_pitch);

      y_playerMoveAngleSpeed *= 0.9;
      //y_playerMoveAngleSpeed *= 0.5;
    }

    if (is_walking) {
/*
      Mebot moving...
      player_coords[0] += 0.00000009;
      player_coords[1] -= 0.00000008;
      mebot_pos[me_object_n][0] += 0.05;
      mebot_pos[me_object_n][2] -= 0.05;
      mebot_models[me_object_n].position.x = mebot_pos[me_object_n][0];
      mebot_models[me_object_n].position.z = mebot_pos[me_object_n][2];
      center_marker.position.x = mebot_pos[me_object_n][0];
      center_marker.position.z = mebot_pos[me_object_n][2];
*/

      if (zombie_object != null) {
        //zombie_object.model.position.x -= 0.05*(Math.PI/2 - zombie_object.model.rotation.y);
        //console.log( ( Math.PI - zombie_object.model.rotation.y) / Math.PI )

        //cameraPosition = new THREE.Vector3().applyMatrix4(camera.projectionMatrix.invert());
        //console.log('cam pos x: ' + Math.round(cameraPosition.x))

        //heading_x = ( ( Math.PI - zombie_object.model.rotation.y) / Math.PI )
        //console.log('heading_x: ' + heading_x)
        //zombie_object.model.position.x += 0.01 * heading_x

        //world_cameraPosition = new THREE.Vector3().applyMatrix4(camera.projectionMatrix.invert());
        //heading_x = world_cameraPosition.x;
        //heading_z = world_cameraPosition.y;

        //if (frame == 10) {
        if (is_zombie_walking) {
          zombie_object.model.position.x += (heading_x - zombie_object.model.position.x) * 0.0005;
          zombie_object.model.position.z += (heading_z - zombie_object.model.position.z) * 0.0005;

          if (Math.abs(heading_x-zombie_object.model.position.x) < 5
           && Math.abs(heading_z-zombie_object.model.position.z) < 5 ) {
            console.log('reached')
            is_zombie_walking = false;
            fadeToAction('Idle', 0.5)
          }
        }

//        zombie_object.model.position.x += (zombie_object.model.position.x - cameraPosition.x)*0.001;
//        zombie_object.model.position.z += (zombie_object.model.position.z - cameraPosition.y)*0.001;
        //*(zombie_object.model.rotation.y - Math.PI);
      }
    }

    if (is_zombie && zombie_mixer != null) {
      zombie_mixer.update( mixer_clock.getDelta() );
    }

    if (frame == 10) {

      if (is_battling) {
        if (enemy_mp <= 1) {
          enemy_mp = 0;

          if (!battle_ending) {
            //enemy dead
            startEndBattle();
          }
        }
        enemy_power.set(enemy_mp/100);
      }

        //console.log('fps: ' + fps)
          //console.log(player_coords)
          //console.log(mebot_pos[me_object_n])
          //map42.setCenter( player_coords );

//          map42.jumpTo({ center: player_coords });

          //map42.flyTo({ center: player_coords });
          //mebot_models[n].position.set(parseFloat(mebot.e), model1up, parseFloat(mebot.n));

      if ('Idle' in zombie_action && !is_battling && !battle_ending && !is_zombie_walking) {
        zombie_action['Idle'].play();
      }

      if ('Punch' in zombie_action && is_battling && is_battle_action) {
      if ((!zombie_action['Punch'].isRunning() && !zombie_action['HitReact'].isRunning() && !zombie_action['Death'].isRunning() && !zombie_action['Idle_Attack'].isRunning() && !zombie_action['Run_Arms'].isRunning()) || battle_ending) {
        //zombie_mixer.stopAllAction();
        //zombie_action['Walk'].stop();

        if (battle_ending && is_battle_action) {
          //zombie_action['Death'].stop();
          //zombie_action['HitReact'].stop();
          //zombie_action['Punch'].stop();
          //zombie_action['Idle_Attack'].stop();

          //zombie_action['Punch'].crossFadeTo(zombie_action['Run_Arms'], 1).play()
          zombie_mixer.stopAllAction();
          zombie_action['Death'].stop();
          zombie_action['Death'].clampWhenFinished = true;
          zombie_action['Death'].setLoop(THREE.LoopOnce);
          zombie_action['Death'].play();
          is_battle_action = false;
        } else {

        if (enemy_was_hit) {
          //console.log('hit reacting')
          //HitReact
          force_of_punch = Math.floor(Math.random() * 8 + 1);
          enemy_mp = enemy_mp - force_of_punch*3;
          if (enemy_mp < 0) {
            enemy_mp = 0;
          }

          if ((Math.floor(Math.random() * 2 + 1)) == 1) {

            //force of punch
            enemy_object.position.x -= force_of_punch/2;
            enemy_object.position.z -= force_of_punch/2;

            zombie_mixer.stopAllAction();
            //zombie_action['Punch'].crossFadeTo(zombie_action['Run_Arms'], 1).play()
            zombie_action['HitReact'].setLoop(THREE.LoopRepeat, 1);
            zombie_action['HitReact'].play();
          } else {
            force_of_punch = 0;
            zombie_mixer.stopAllAction();
            //zombie_action['Punch'].crossFadeTo(zombie_action['Run_Arms'], 1).play()
            zombie_action['Death'].setLoop(THREE.LoopRepeat, 1);
            zombie_action['Death'].play();
          }
          enemy_was_hit = false;
        }
        if ((Math.floor(Math.random() * 2 + 1)) == 1) {
          console.log('punching')
          zombie_action['Punch'].stop();
          zombie_action['Death'].stop();
          zombie_action['Punch'].setLoop(THREE.LoopRepeat, 1);
          zombie_action['Punch'].play();
          //zombie_action['Run_Arms'].crossFadeTo(zombie_action['Punch'], 1).play()
          setTimeout(function(){ zapBody(me_object, 0xFFAE05, 0x698362) }, 500);
          //mebot was punched by enemy
          setTimeout(function(){ bounceMebot(5) }, 250);
        } else {
          //console.log('hit reacting')
          //HitReact
          zombie_action['Idle_Attack'].stop();
          zombie_action['Death'].stop();
          //zombie_action['Punch'].crossFadeTo(zombie_action['Run_Arms'], 1).play()
          zombie_action['Idle_Attack'].setLoop(THREE.LoopRepeat, 1);
          zombie_action['Idle_Attack'].play();
          setTimeout(function(){ zapBody(me_object, 0xFFAE05, 0x698362) }, 200);

          //mebot getting eaten
          bounceMebot(3, false);
        }

        }
      }


      }

    }

    if (is_battling) {

        if (punched && is_battle_action && enemy_object.position.x > (my_old_pos.x-11.2)) {
          setZombieBodyColor(glb_items['deamon1'].scene, 0xffffff)

          punched_flash = true;
          setTimeout(function(){ punched_flash = false }, 100);

          if (rotation_dir == 0) {
            rotation_dir = 1;
          }

          smoothing[1] = 3;

          force_of_punch -= 2;
          //console.log('punched!! ' + force_of_punch)

          smoothing[0] = 1;
          punched = false;
          bounceMebot(8);
        }

        smoothing[1] *= 0.95;
        force_of_punch *= 0.75;
        if (force_of_punch > 1) {
          //console.log(force_of_punch)
        }

        if (rotation_dir != 0) {
          me_object.rotation.y += 0.05*rotation_dir*frame_advance*smoothing[1];
        }

        if (me_object.rotation.y > 7) {
          rotation_dir = -1;
          smoothing[1] = 3;
        } else if (me_object.rotation.y < me_starting_rotation) {
          rotation_dir = 0;
        }
        //if 

        if (me_object.position.x > (my_old_pos.x+9.5)) {
          me_object.position.x -= 1*smoothing[0];
          me_object.position.z -= 1*smoothing[0];
        }

        if (enemy_object.position.x < (my_old_pos.x-11.2)) {
          console.log('here')

          if (force_of_punch > 0.1) {
            enemy_object.position.x -= force_of_punch/2;
            enemy_object.position.z -= force_of_punch/2;
          } else {
            smoothing[0] *= 0.99;
            enemy_object.position.x += 1*smoothing[0];
            enemy_object.position.z += 1*smoothing[0];
          }

          if (enemy_object.position.x < (my_old_pos.x-15)) {
            //start running back
            //zombie_mixer.stopAllAction();
            zombie_action['Run_Arms'].play();
          }
        } else {
          if (zombie_action['Run_Arms'].isRunning()) {
            console.log('arms stopped')
            zombie_action['Run_Arms'].stop();
          }
        }
    }

    initial_opacity += 0.006*opacity_add;
    if (initial_opacity > 0.8 || initial_opacity < 0.005) {
      opacity_add = opacity_add*(-1);
    }

    if (frame == 6 || frame == 10) {

      if (marker != null) {
        setMarkerOpacity(initial_opacity)
        marker.scale.set(initial_opacity+0.5, initial_opacity+0.5, initial_opacity+0.5)
      }

      if (mebot_loc_id > 0) {
/* Turn off for now because new model doesn't have it
        heart_scale = (.8-initial_opacity)/5+0.4
        //mebot_hearts[0].material.opacity = initial_opacity;
        mebot_hearts[0].scale.set(heart_scale, heart_scale, heart_scale)
  */
      }

      //console.log(food_item.rotation.y)
      if (food_item != null) {
        //disable rotation for now
        //food_item.rotation.y += 0.1;
      }
      //food_item.rotation.x += 0.1;

      if (is_battling) {

        if ((Math.floor(Math.random() * 4 + 1)) == 2) {
          //zapBody(enemy_object, 0x4380B7)
        }
        if ((Math.floor(Math.random() * 4 + 1)) == 3) {
          //zapBody(me_object, 0xFFAE05)
        }

      }

      if (visited_disk != null) {
        //visited_disk_color.setHSL(visited_disk_color.h, visited_disk_color.s, (visited_disk_color.l+0.1));
        //var color = new THREE.Color("hsl(0, 100%, 50%)");
        //color.setHSL( {h: visited_disk_color.h, s: visited_disk_color.s, l: visited_disk_color.l} );

        //visited_disk_color = color;
        //visited_disk_color = visited_disk_color.offsetHSL ( 10, 10, 10 )
        //console.log(visited_disk_color.b)
        //visited_disk.material.color.setHSL(visited_disk_color)
        //console.log(visited_disk_color)
        //console.log(visited_disk.material.color.getHSL());
      }

      spheres.forEach( sphere => {
        if (sphere.is_projectile == false && sphere.glow != null && sphere.glow.visible) {
          sphere.glow.material.opacity = initial_opacity/3;
        }

        if (sphere.ether != null && sphere.ether.visible) {
          setOpacity(sphere.ether, (1.2 - initial_opacity ) )
          sphere.ether.rotation.y += 0.03;
          //sphere.ether.material.opacity = initial_opacity;
        }
      });

    }

    if (frame >= 10) {
      frame = 0;
    }
    frame += frame_advance;

    if (fps <= 70) {
      frame_advance = 2;
    } else {
      frame_advance = 1;
    }

    const deltaT = entity_clock.getDelta();

    //habitat_globe_models[0].rotation.y += 0.002;
    deltaTime = Math.min( 0.05, clock.getDelta() ) / STEPS_PER_FRAME;
    update_spheres( deltaT );

    zapBody();

    //changeCanvas();
    //texture_text.needsUpdate = true;

    update_frames();

    if (explosion != null) {
      //console.log(deltaTime)
      if (explosion.update(deltaT) == 0) {
        //console.log('explosion ended')
        explosion = null;
      }
    }

    if (throw_power_visible) {
      touch_end_ts = new Date().getTime();
      let dur = touch_end_ts-touch_start_ts;
      if (dur < 0) {
        dur = 0;
      }
      dur = dur/10;
      enemy_power.set( (dur)/100 );
      if (dur > 100) {
        throw_ball();
      }
    }

  }

}


let STEPS_PER_FRAME = 5;
let GRAVITY = 3000;
let clock = new THREE.Clock();
let entity_clock = new THREE.Clock();
let deltaTime = 0;
let NUM_SPHERES = 10;
let SPHERE_RADIUS = 7;
let sphereGeometry = new THREE.IcosahedronGeometry( SPHERE_RADIUS, 5 );
let sphereMaterial = new THREE.MeshLambertMaterial( { color: 0xdede8d } );

let playerDirection = new THREE.Vector3();
let spheres = [];
let sphereIdx = 0;
let ground_hit = 0;

let ethers = [];

let vector1 = new THREE.Vector3();
let vector2 = new THREE.Vector3();
let vector3 = new THREE.Vector3();

async function setup_entities() {

  if (is_zombie) {

  glb_items['deamon1'].scene.position.copy( new THREE.Vector3( -40, 2, -40 ) );
  glb_items['deamon1'].scene.rotation.y += 3;
  map_scene.add(glb_items['deamon1'].scene)

  console.log(glb_items['deamon1'].animations);
  zombie_mixer = new THREE.AnimationMixer( glb_items['deamon1'].scene );

  objects['Zombie'] = {
      type: 'enemy',
      model: glb_items['deamon1'].scene,
      name: 'Zombie',
      texture: 'https://mebots.s3.amazonaws.com/zombie_lg_500.png',
      reverse_texture: 'https://mebots.s3.amazonaws.com/zombie_lg_500.png',
      elevation: 45,
  }
  glb_items['deamon1'].animations.forEach( function ( clip ) {
    //console.log(clip.name)
    zombie_action[clip.name] = zombie_mixer.clipAction( clip )
  } );
  zombie_object = objects['Zombie'];

  }

      //gltfs[is_owner*2+1].animations.forEach( function ( clip ) {
      //  console.log(clip.name)
	    //  mixer.clipAction( clip ).play();
      //} );*/

  //glb_items['battle_stage'] = await glb_loader.loadAsync('https://mebots.s3.amazonaws.com/stage_2.glb');
  const stage_geo = new THREE.CylinderGeometry(60, 60, 2, 128);
  const stage_mat = new THREE.MeshPhongMaterial( {color: 0x7B96B8, opacity: 0.65, transparent: true} );

  glb_items['battle_stage'] = new THREE.Mesh(stage_geo, stage_mat);
  glb_items['battle_stage'].castShadow = true;
  glb_items['battle_stage'].receiveShadow = true;

  setName(glb_items['battle_stage'], 'Battle Stage')

  //glb_items['battle_stage'].scale.set(10, 10, 10);

}

async function setup_projectile(type_id) {

}

async function setup_sphere(type_id, e, n, elevation, em, entity_id = 0, ts_id, name = '', is_projectile = false) {

  if (!is_setup_spheres) {
    return;
  }

  //console.log('!!!HERE for: ' + name + ', type_id: ' + type_id + ' entity_id: ' + entity_id);

  if (!(mebot_spheres_existing.includes(entity_id))) {

    const sphere_model = await get3dmodel(type_id, em, ts_id);

    let glow_obj = null;
    let ether_obj = null;

    if (sphere_model != null) {

      //console.log('setting up: (' + type_id + ') ' + sphere_model.name)
      sphere_model.position.copy( new THREE.Vector3( parseFloat(e), elevation, parseFloat(n) ) );

      if (!is_projectile && elevation == 5) {
        //add globe glowing globe around the artifact
        //const glow_geo = new THREE.SphereGeometry( 10, 16, 16 );

        const glow_geo = new THREE.SphereBufferGeometry(18, 16, Math.round(16 / 4), 0, Math.PI * 2, 0, Math.PI * 0.5);  
        const glow_material = new THREE.MeshBasicMaterial( {
          //map: texture,
          opacity: 0.1,
          color: 0x990000,
          transparent: true,
          side: THREE.DoubleSide,
        } );
        //const material = new THREE.MeshBasicMaterial( { color: 0x0000ff } );
        const glow = new THREE.Mesh( glow_geo, glow_material );

        setName(glow, sphere_model.name);
        glow.position.copy( new THREE.Vector3( parseFloat(e), elevation-5, parseFloat(n) ) );
        map_scene.add(glow)
        glow_obj = glow;
        //sphere_model.add(glow)
      }

      map_scene.add(sphere_model)

      if (elevation == 130) {
        ether_obj = sphere_model;
        console.log('ADDED ETHER:')
      } else  {
        ether_obj = null;
      }

      if (elevation == 1) {
        //setOpacity(sphere_model, 0.6)
      }

      //let entity_type = 0;
      //if (elevation == 1) {
      //  entity_type = 1;
      //}

      spheres.push({
        mesh: sphere_model,
        collider: new THREE.Sphere( new THREE.Vector3( parseFloat(e), elevation, parseFloat(n) ), 0.2 ),
        velocity: new THREE.Vector3(0, 0, 0),
        type_id: type_id,
        is_projectile,
        glow: glow_obj,
        ether: ether_obj,
        name: sphere_model.name,
        state: 1,
        entity_type: elevation
      });

      if (!is_projectile) {
        objects[name].glow = glow_obj;
      }

      //console.log('ADDED SPHERE: type_id: ' + type_id)
      //console.log(spheres[spheres.length-1])

      mebot_spheres_existing.push(entity_id);
      artifact_objects[entity_id] = spheres[spheres.length-1];
    }

  } else {
      //update latest location of the artifact on the map

      //console.log('!!!updating type_id: ' + type_id + ' to elevation: ' + elevation)
      const artifact = artifact_objects[entity_id];
      artifact.mesh.position.copy( new THREE.Vector3( parseFloat(e), elevation, parseFloat(n) ) );
      artifact.collider.center.copy( artifact.mesh.position )

  }

  if (name != '') {
    //make sure spehere is visible again
    objects[name].model.visible = true;
  }

}

async function setup_spheres() {

  for (const sphere of mebot_spheres) {
    await setup_sphere(sphere.type_id, sphere.e, sphere.n, sphere.elev, sphere.em, sphere.id, sphere.ts_id, sphere.name);
  }

  //console.log(mebot_spheres_existing)
}

async function getMapArtifact(ts_id) {

  const res = await fetch(
    "https://api.forever.today/?method=get_map_artifact",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        id: ts_id //artifact id (from timestamp)
      }),
    }
  );

  const json = await res.json();

  console.log(json.data.item_found)
  item_found = json.data.item_found;
}

async function pickupMapArtifact() {

  if (artifact_clicked_object != '') {
    console.log('picking up artifact: ' + objects[artifact_clicked_object].ts_id)
    //objects[artifact_clicked_object].id

    item_found = null;
    startLoadingModal();
    await getMapArtifact(objects[artifact_clicked_object].ts_id)

    if (item_found != null && item_found.em != '') {

      console.log('item found: ')
      console.log(item_found)

      showFound(item_found, item_found.item_image, item_found.n, item_found.a, '', item_found.avp, item_found.energy);

      is_artifact_bg = true;
      //artifact collected

      //hide artifact on map
      objects[artifact_clicked_object].model.visible = false;
      //objects[habitat_name].artifact.visible = false;

      //center player
      CenterPlayer()

      //reset artifacts list
      artifacts = [];
      artifacts_n++;
      article_n = 0; //pagination
    } else {

      //display info that you already have this artifact
      closeModal();

    }

    objects[artifact_clicked_object].model.visible = false;
    if (objects[artifact_clicked_object].glow != null) {
      objects[artifact_clicked_object].glow.visible = false;
    }
    artifact_clicked_object = '';
  }
}

async function setup_artifact_model(type_id, em, name) {

  //FIX (it's not removing the right object)
  //if (map_projectile != null) {
  //  map_scene.remove(map_projectile)
  //}

  //check if throw type artifact (action_type = 1)
  if (type_id in a_action_type && a_action_type[type_id] == 1) {

  await setup_sphere(type_id, mebot_pos[me_object_n][0], mebot_pos[me_object_n][2], 5, em, type_id, 0, '', true)
  //console.log('HEREHERE')
  map_projectile = artifact_objects[type_id]

  projectile_n = type_id;

  }

  return;


  //const sphere = new THREE.Mesh( sphereGeometry, sphereMaterial );
  //const tennis_ball = await glb_loader.loadAsync('https://mebots.s3.amazonaws.com/tennis_ball.glb');
  //const tennis_ball = await glb_loader.loadAsync('https://mebots.s3.amazonaws.com/soccer_ball.glb');
  //const artifact_model = tennis_ball.scene;

  const artifact_model = await get3dmodel(id);

  //walk all spheres and see if there's already projectile sphere
  if (artifact_model != null) {

  }

  //console.log(model_def)
  //const tennis_ball = await glb_loader.loadAsync(model_def.url);
  //console.log('ball')

  spheres = [];

  if (artifact_model != null) {

  for ( let i = 0; i < NUM_SPHERES; i ++ ) {

    //sphere.castShadow = true;

    /* replaced with tennis ball
    sphere.receiveShadow = true;
    sphere.position.copy( new THREE.Vector3( parseFloat(mebot_spheres[0].e), 30, parseFloat(mebot_spheres[0].n) ) );
    //console.log(sphere.position)
    //sphere.name = ' 🎾 Tennis ball '
    //map_scene.add(sphere);*/

    artifact_model.position.copy( new THREE.Vector3( parseFloat(mebot_spheres[i].e), 1, parseFloat(mebot_spheres[i].n) ) );
    map_scene.add(artifact_model)

    console.log(mebot_spheres[i])
    spheres.push({
      mesh: artifact_model,
      collider: new THREE.Sphere( new THREE.Vector3( parseFloat(mebot_spheres[i].e), 1, parseFloat(mebot_spheres[i].n) ), 0.2 ),
      velocity: new THREE.Vector3(0, 0, 0),
    });

    //await sleep(1000)

    map_projectile = spheres[i];
    break;
  }

  console.log('LOADED map projectile: ')
  console.log(map_projectile)

  }
}



let explosion = null;

function throw_ball(dir_vector = null, distance = 0, strength = 1) {

  if (!is_throwing && distance > 0 && strength > 0) {

    //check if enough power to throw
    if (mebot_md.power_avail > 0) {
        mebot_md.power_avail -= 1;

        if (mebot_md.power_avail < 0) {
          mebot_md.power_avail = 0;
        }

        if (mebot_md.power_avail > 100) {
          power_avail.set(100/100);
        } else if (mebot_md.power_avail >= 0) {
          power_avail.set(mebot_md.power_avail/100);
        }
    } else {
      return;
      //unable to throw
    }

    console.log('throw_ball')
    touch_end_ts = new Date().getTime();

  //reset
  is_throwing = true;
  ground_hit = 0;

  draw_energy_colleted = 0;
  draw_em_collected = '';
  distance_bonus = 0;
  global_ener_collected = 0;
  //project_distance = 0;
  distance_thrown = 0;
  roll_advance = 0.0025*frame_advance;
  rotation_advance = 0.05;

  const bearingRad = (map42.getBearing() * Math.PI) / 180;
  // Create a direction vector in 3D space
  vector1.z = Math.cos(bearingRad);
  vector1.x = Math.sin(bearingRad);
  //console.log(vector1)

  //sphereIdx = projectile_n;
  //const sphere = spheres[ sphereIdx ];
  const sphere = artifact_objects[projectile_n]
  //make sure projectile is visible
  sphere.mesh.visible = true;

  //camera.getWorldDirection( playerDirection );

  current_pitch = map42.getPitch();
  //console.log(current_pitch)

  let inclination = 0.00005*current_pitch*current_pitch
  if (inclination < 0.01) {
    inclination =  0.01
  }

  if (dir_vector != null) {
    //inclination = 0.00005*70*70
    inclination = 0.008*(current_pitch+25);

    if (inclination == 0) {
      inclination = 0.09;
    }

    //console.log(vector1)
    //console.log('NOW')
    //vector1.addScaledVector(dir_vector, 1)
    //console.log(vector1)
    vector1 = dir_vector
  }

  //console.log(inclination)

  playerDirection = new THREE.Vector3(vector1.x, inclination/1.5, vector1.z);

  if (dir_vector != null) {
    console.log('dir vector')
    console.log(dir_vector)
  }
  //console.log( playerDirection )

  //sphere.collider.center.copy( this.playerCollider.end ).addScaledVector( this.playerDirection, this.playerCollider.radius * 1.5 );
  //sphere.collider.center.copy( playerCollider.center ).addScaledVector( playerDirection, playerCollider.radius * 1.5 );
  // throw the ball with more force if we hold the button longer, and if we move forward
  //const impulse = 15 + 30 * ( 1 - Math.exp( ( mouseTime - performance.now() ) * 0.001 ) );
  //const impulse = 15 * 10 * 4;

  //console.log(touch_end_ts - touch_start_ts);
/*
  let cur_delta_ts = touch_end_ts - touch_start_ts;
  if (cur_delta_ts > 1000) {
    cur_delta_ts = 1000;
  }
  if (cur_delta_ts < 50) {
    cur_delta_ts = 50;
  }
  const impulse = (1000 + (cur_delta_ts)*6 )*inclination;*/

  let impulse = 0;
  if (dir_vector == null) {
    impulse = (1000 + (touch_end_ts - touch_start_ts)*6 )*inclination;
  } else {
    impulse = (100 + (distance) )*inclination*strength*3;
    //impulse = (200 + (distance) ) + inclination*strength;
  }

  sphere.velocity.copy( playerDirection ).multiplyScalar( impulse );
  //sphere.velocity.addScaledVector( playerVelocity, 2 );

  console.log('impulse: ' + impulse + ' distance: ' + distance + ' inclination*strength: ' + inclination*strength)

  throw_start_x = mebot_pos[me_object_n][0]
  throw_start_z = mebot_pos[me_object_n][2]
  sphere.collider.center.copy(new THREE.Vector3(mebot_pos[me_object_n][0], 60, mebot_pos[me_object_n][2]));
  sphere.mesh.position.copy(sphere.collider.center);
  sphereIdx = ( sphereIdx + 1 ) % spheres.length;

  //orient projectile
  sphere.mesh.rotation.set(playerDirection.x, playerDirection.y, playerDirection.z)

  throw_power_visible = false;
  enemy_power.set(0);

  }

}

function set_sphere_bounding(x, y, z) {
  // Update bounding box
  //let width = 2 / 2;
  let width = 2;

  sphereBoundingBox = new BoundingBox(
    x - width,
    y - 1,
    z - width,
    x + width,
    y + 1,
    z + width
  );

  console.log('test')
}

function update_spheres( deltaTime ) {

  if (!is_throwing) {
    return;
  }

  spheres.forEach( sphere => {

    if (sphere.type_id == projectile_n) {

    if (sphere.velocity.y != 0 && sphere.mesh.position.y > 0 && ground_hit < 10) {
      //ORIGINAL
      //sphere.collider.center.addScaledVector(sphere.velocity, deltaTime);
      //sphere.velocity.y -= GRAVITY * deltaTime;
      //cur_velocity--;

      //console.log(deltaTime)

      if (ground_hit >= 8) {
        if (roll_advance > 0.001) {
          roll_advance *= 0.97
          //console.log(roll_advance)
        }
        rotation_advance *= 0.98;
        //&& touch_end_ts == 0) {
        //roll_stop_ts = new Date().getTime();
      }

      sphere.collider.center.addScaledVector(sphere.velocity, roll_advance * (cur_velocity/100));
      sphere.velocity.y -= GRAVITY * roll_advance * (cur_velocity/100);

      //TODO: (for now removed damping)
      //const damping = Math.exp( - 0.5 * deltaTime ) - 1;
      //sphere.velocity.addScaledVector(sphere.velocity, damping);
      //console.log(damping)

      sphere.mesh.rotation.x -= rotation_advance;
      //sphere.mesh.rotation.z -= 0.01;
      //playerSphereCollision( sphere );

      //console.log(deltaTime)

      //check collision mid air
      if (sphere.mesh.position.y < 30) {
        if (frame == 1) {
          //console.log('checking collision')
          check_collisions(sphere)
        }
      }

      if (false && sphere.mesh.position.y > 20 && sphere.mesh.position.y < 60) {

        let exp_size = 1;
        let exp_color = 0x80ffff;
        //if collided with habitat make the explosion bigger
        const col_mebot = has_mebot_collided(sphere.mesh.position);
        if (col_mebot != null) {
          exp_size = 1.5;
          habitat_globe_models[col_mebot].visible = false;
          explosion = new ExplosionEffect(new THREE.Vector3(sphere.mesh.position.x, 30, sphere.mesh.position.z), exp_size, exp_color);
          explosion.load().then(() => {
            map_scene.add(explosion.get_mesh());
          });
        }

      }

    } else {

      //save ball position
      //console.log(meterInMercatorCoordinateUnits())
      //console.log('sphere: ' + meterInMercatorCoordinateUnits()*sphere.mesh.position.x + '  :  ' + meterInMercatorCoordinateUnits()*sphere.mesh.position.z)
      //console.log('sphere: ' + sphere.mesh.position.x + '  |  ' + sphere.mesh.position.z)


      //is_throwing = false;
      ground_collision(sphere)
      if (is_throwing_mode) {
        clear_touchpad_canvas(true)
      }
    }

    }

  } );

  ///spheresCollisions();
  for ( const sphere of spheres ) {
    if (sphere.velocity.y != 0 && sphere.mesh.position.y > 0) {
      sphere.mesh.position.copy( sphere.collider.center );

      //see if collided
      //set_sphere_bounding(sphere.mesh.position.x, sphere.mesh.position.y, sphere.mesh.position.z)
      //console.log(this.sphereBoundingBox)
      //console.log('collided: ' + this.sphere_collide(sphere, sphere.mesh.position.x, sphere.mesh.position.y, sphere.mesh.position.z))
      //mebot_collision(sphere) //pio

      //ground_collision(sphere)

      //slow down the ball
      //sphere.velocity.multiplyScalar( 0.999 );
    }
  }
}

function explodito(location, size, color) {

  explosion = new ExplosionEffect(new THREE.Vector3(location.x, 2, location.z), size, color);
      explosion.load().then(() => {
        //console.log('explosion: ')
        //console.log(explosion.get_mesh())
        //console.log(explosion.get_mesh().position)
        //explosion.get_mesh().position.y += 10;
        map_scene.add(explosion.get_mesh());
  });

}

function check_collisions(sphere) {

  //if collided with habitat make the explosion bigger
  const col_habitat = has_habitat_collided(sphere.collider.center);
  const col_ent = has_entity_collided(sphere.collider.center);

  if (ground_hit >= 10 || col_habitat != null || col_ent != null) {

    is_throwing = false;

    distance_thrown = project_distance;
    //calculate actual distance
    distance_thrown = Math.sqrt( ((sphere.collider.center.x - throw_start_x)**2) + ((sphere.collider.center.z - throw_start_z)**2) )
    distance_thrown = Math.round( distance_thrown );

    //log throw
    log_throw(1, distance_thrown)

    if (col_habitat != null || col_ent != null) {

      lolipop = 0;

      let exp_size = 1 + aa_blast_radius/10;
      exp_size = 1.8 + aa_blast_radius/10;
      let exp_color = aa_blast_color;

      explodito(sphere.collider.center, exp_size, exp_color)

      clear_raycast();

      //hide projectile
      sphere.mesh.visible = false;
      clear_touchpad_canvas(true)

    }

    if (col_habitat != null) {
    }

    /*
    setTimeout(() => {
        draw_energy_colleted = 0;
        draw_em_collected = '';
        distance_bonus = 0;
        global_ener_collected = 0;
        project_distance = 0;
        distance_thrown = 0;
    }, 800);*/

    fetch(
			"https://api.forever.today/?method=save_sphere_loc",
			{
				method: "POST",
				body: JSON.stringify({
          dash_token,
          e: meterInMercatorCoordinateUnits()*sphere.mesh.position.x,
          n: meterInMercatorCoordinateUnits()*sphere.mesh.position.z,
          mx: sceneOriginMercator.x,
          my: sceneOriginMercator.y,
          mebot_id,
          type_id: aa_id
				}),
			}
	  );

  }
}

function ground_collision(sphere) {

  //HACK for now ***
  ground_hit++;

  const sphere_center = sphere.collider.center;
  const mebot_point = new THREE.Vector3(sphere.collider.center.x, 1, sphere.collider.center.z);
  //const mebot_point = this.mebot_model.position;

  const stationary = new THREE.Vector3(0, 0, 0);

  //const r = 1.2 + sphere.collider.radius;
  //const r = 1.2 + sphere.collider.radius;
  //const r2 = r*r;
  const r = 1.7;
  const r2 = 6.9;

  //const d2 = mebot_point.distanceToSquared( sphere_center );
  const d2 = mebot_point.distanceTo( sphere_center );
  //console.log('d2: ' + d2)

  if (d2 < r2) {

    const normal = vector1.subVectors( mebot_point, sphere_center ).normalize();
    const v1 = vector2.copy( normal ).multiplyScalar( normal.dot( stationary ) );
    const v2 = vector3.copy( normal ).multiplyScalar( normal.dot( sphere.velocity ) );

    //playerVelocity.add( v2 ).sub( v1 );
    sphere.velocity.add( v1 ).sub( v2 );

    sphere.velocity.y = 300 * (cur_bounce/100) / (ground_hit);
    //sphere.velocity.multiplyScalar( 10 );

    //const d = ( r - Math.sqrt( d2 ) ) / 2;
    //console.log(sphere.velocity)
    //sphere_center.addScaledVector( normal, -d );
    //sphere.collider.center.addScaledVector( normal, -d );

    sphere.collider.center.copy( mebot_point );
    sphere.mesh.position.copy( mebot_point );
    //console.log(sphere.mesh.position)

    //sphere.mesh.position.copy( new THREE.Vector3(targetX, targetY, targetZ) );
    //this.bounceMebot();

    //console.log('ground hit')
  }

  //ground_hit++;
  //console.log('ground hit: ' + ground_hit)

  if (ground_hit >= 1 && explosion == null) {
    check_collisions(sphere)
  }

}


function requestNextFrame() {
        requestAnimationFrame(() => {
            if (is_running == 1) {
              onLoop();
            }
            requestNextFrame();
        });
}

/*
map.on('load', () => {

});
*/


let map_loading = true;
content_loading.update(n => true);
draw_map();

async function switchMebot(i) {
		console.log(i)

		mebots_loading = true;
		content_loading.update(n => true);
		if (i >= 0 && i in mebots) {
			//console.log(mebots[i].is_active)

      await activateMebot(mebots[i].id);
      await doPost();

			//await fetchMapHabitats();
			//zoomMap(0);

      spinner = 0;
      article_n = 0;
      saveMapState()
			replace('/go/2/map42/' + mebots[i].id);
			//#/map/2/1/0_59

      //restart swiping on main screen
      offsets = document.getElementById('canvas-container').getBoundingClientRect();
      map_bottom = offsets.bottom;

			show_mebots = false;
			//doPost();
			//getMyMebots();
		}

		if (i == -1) {
      saveMapState()
			replace("/go/2/map42/0");
		}
		content_loading.update(n => false);
		mebots_loading = false;

}


async function sendChat(offset = 0, msg = '') {

        const allSpacesRemoved = msg.replaceAll(' ', '');
        if (allSpacesRemoved == '') {
            return;
        }

		fetching = true;
		loading.update(n => fetching);

    mebot_chats_tmp = [];
    mebot_chats_tmp.push({img: '🎧', msg: msg, time_ago: 1, is_system: 0});
		mebot_chats = mebot_chats.concat(mebot_chats_tmp);

		const res = await fetch(
			"https://api.forever.today/?method=send_chat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
                    thread_id,
                    mebot_id,
                    msg,
					offset
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.chats;

		mebot_attr = json.data.attr;
		mebot_chats_tmp = [];

		for (const runner of runners) {
			mebot_chats_tmp.push({
				img: runner.mebot_img_url,
				msg: runner.msg,
				time_ago: runner.time_ago,
                is_system: runner.is_system
			});
		}

		if (offset == 0) {
			mebot_chats = mebot_chats_tmp;
		} else {
			//append
			mebot_chats = mebot_chats.concat(mebot_chats_tmp);
		}
		page_size = json.data.page_size;

		fetching = false;
		loading.update(n => fetching);
	}

  async function getChatActions() {

    let tmp_actions = [];

    const res = await fetch(
			"https://api.forever.today/?method=get_chat_actions",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          mebot_id
				}),
			}
		);

    const json = await res.json();
		let runners = json.data.actions;

    for (const runner of runners) {
			tmp_actions.push(runner)
		}
    actions = tmp_actions;
    //console.log(actions)
  }

  async function get3dmodel(model_id = 0, artifact_em, ts_id) {

    if (! (model_id in existing_models) ) {

    //await sleep(1000);
    const res = await fetch(
			"https://api.forever.today/?method=get_3dmodel",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          model_id
				}),
			}
	  );

      const json = await res.json();
      const model_def = json.data;

      if (model_def.id == 0) {
        return null;
      }

      existing_models[model_id] = model_def;
    }

    if (! (model_id in existing_models) ) {
      return null;
    }

    let model_def = existing_models[model_id];
    let asset = model_def.asset;

    if (! (asset in glb_items) ) {

      //const model = 
        glb_items[asset] = await glb_loader.loadAsync(model_def.url);
        glb_items[asset].scene.scale.set(model_def.size, model_def.size, model_def.size);
        setName(glb_items[asset].scene, model_def.name);

        //console.log('ADDING MODEL: ' + model_def.name)

        if (model_def.color != null) {
          //console.log('setting color: ' + model_def.color)
          setColor(glb_items[asset].scene, model_def.color)
        }
    }

    if (asset in glb_items) {
      //const model = 
      //deep copy

      const model = glb_items[asset].scene.clone();

      objects[model_def.name] = {
          type: 'artifact',
          model: model,
          name: model_def.name,
          texture: '',
          em: artifact_em,
          id: model_id,
          ts_id,
          glow: null, //glow object that's later setup
      }

      return model;
    }

    return null;
  }

  async function getChats(offset = 0) {

		fetching = true;
		loading.update(n => fetching);

    let mid = mebot_loc_id;
    if (mid == 0) {
      mid = mebot_id;
    }
		const res = await fetch(
			"https://api.forever.today/?method=get_chat_thread",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          thread_id,
          mebot_id: mid,
					offset
				}),
			}
		);

    const json = await res.json();
    let runners = json.data.chats;

		mebot_attr = json.data.attr;
		mebot_chats_tmp = [];

		for (const runner of runners) {
			mebot_chats_tmp.push({
				img: runner.mebot_img_url,
				msg: runner.msg,
				time_ago: runner.time_ago,
                is_system: runner.is_system,
                msg_id: runner.msg_id,
			});
		}

		if (offset == 0) {
			mebot_chats = mebot_chats_tmp;
		} else {
			//append
			mebot_chats = mebot_chats.concat(mebot_chats_tmp);
		}
		page_size = json.data.page_size;
    thread_id = json.data.thread_id;
    console.log('thread id: ' + thread_id);

		fetching = false;
		loading.update(n => fetching);

        //if (mebot_chats.length > 2 ) {
            await sleep(100);
            let chats = document.querySelector('.main1')
            //console.log(chats.scrollHeight)
            //chats.scrollTop = 2000;
            chats.scrollTo({
                top: 2000,
                left: 0,
                behavior: "smooth",
            });
        //}
	}


async function chatMebot(open = true) {

  if (open) {
    show_chat = true;
    getChatActions();
    getChats(0);
  } else {
    show_chat = false;
  }
}

async function sendChatCmd(cmd_id = 0) {

	if (cmd_id > 0 && mebot_id > 0) {

		const res = await fetch(
			"https://api.forever.today/?method=send_chat_cmd",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          mebot_id,
					cmd_id
				}),
			}
		);

	}
}

//send command and don't refresh
async function sendCmd(cmd_id) {

		is_loadings[cmd_id] = true;

		if (cmd_id == 2) {
			journey['n_items'] = 0;
			just_collected = true;
			just_collected_visted = journey['visited'];
			journey['visited'] = '';

      setTimeout(() => {
        just_collected_visted = '';
      }, 800);
		}

		await sendChatCmd(cmd_id);
		const res = await fetch(
				"https://api.forever.today/?method=get_mebot_modes",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token: dash_token,
						mebot_id: mebot_id,
            is_abbrev: 1
					}),
				}
			);
		const json = await res.json();
		mebot_md = json.data.mebot_md;
		power_avail.set(mebot_md.dp/100);

		if (cmd_id == 2) {
			await getMyMebots();
      await collectAllVisited();
			//refresh map after items have been collected
			//await fetchMapHabitats();
		}

    if (cmd_id == 3) {
      setTimeout(() => {
        closeModesMenu();
      }, 500);
    }

		is_loadings[cmd_id] = false;
}

async function collectAllVisited() {

  //cycle over all visited and hide items
  for (const visited in habitat_globe_models_visited) {
    if (visited in habitat_globe_models_has_item) {

      //console.log(visited);
      //console.log(objects[habitat_globe_models_visited[visited]].item);
      if (objects[habitat_globe_models_visited[visited]].item != null) {
        objects[habitat_globe_models_visited[visited]].item.visible = false;
      }
    }
  }
}

async function closeModesMenu() {
  open_modes_menu = false;
  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
}

async function closeExtraMenu() {
  open_extra_menu = false;
  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
}

async function closeModal() {
  is_modal_open = false;
  stopLoadingModal();
  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
}


async function getHabitat(h_id) {

  let h_tags = [];
  let mayor_mebot_img_url = '';

  const res = await fetch(
    "https://api.forever.today/?method=get_habitat",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        habitat_id: h_id
      }),
    }
  );

  const json = await res.json();
  item_found = json.data.habitat.item_found;
  habitat_alert = json.data.habitat.alert;
}

function startLoadingModal() {
  modal_msg = '';
  modal_action_msg = '';
  content_loading.update(n => true);
  is_modal_open = true;
}

function stopLoadingModal() {
  content_loading.update(n => false);
}

function displayModalMessage(msg, timeout, action_msg) {
  stopLoadingModal();

  map_bottom = 0;
  modal_msg = msg;
  modal_action_msg = action_msg;
  is_modal_open = true;
}

function showAlert(msg) {

  displayModalMessage(`
		<center>
			<br>
			` + msg + `
		  <br><br>

		</center>`, 10, 'OK');

}

function showFound(item, image, name, action, base, avp, energy) {

		let action_msg = 'Nice!';

    if (item_found.t_id == 10) {

      displayModalMessage(`
		<center>
			<br>
      ` + item.at + `
			` + image + `
  		<br>
	  	` + action + `
		  ` + energy + `
		  <br><br>

		</center>`, 20000, action_msg);

    } else {

		if (item_found.t_id == 2) {
			//item_display = item_found.em;
			//show_item_action = true;
			action_msg = item_found.av + ' it... ' + item.em;

			//power.set(0.1);
			avp = 'Found';
		}

		let emo = '🌟';
		if (item_found.em != '') {
			emo = item_found.em;
		}

		displayModalMessage(`
		<center>
			<br>
			` + avp + ` ` + name + `<br> at <b>` + base + `</b> <br><br>

			` + image + `
  		<br>
	  	` + action + `
		  ` + energy + `
		  <br><br>

		</center>`, 20000, action_msg);

		if (item_found.t_id == 2) {
			//show_item_action = true;
		}

    }
}

//this is wrong
const removeItem = (arr, value) => arr.filter(item => item !== value);

function _increase_power(p) {
  if (p > 0) {
        mebot_md.power_avail += p;
        if (mebot_md.power_avail > 100) {
          power_avail.set(100/100);
        } else if (mebot_md.power_avail >= 0) {
          power_avail.set(mebot_md.power_avail/100);
        }
  }
}

function remove_item(items, item_to_remove) {
  let items_new = []

  for (let key in items) {
    if (item_to_remove == key) {
      console.log('removing: ' + key + ': ' + items[key]);
    } else {
      items_new[key] = items[key];
    }
  }
  return items_new;
}

async function pickup_artitifact(habitat_id, habitat_name, confirmation = true) {

  if (!(habitat_id > 0)) {
    return;
  }

  let planet_src = '';
  if (habitat_name in objects) {
    planet_src = objects[habitat_name].planet_src;
  }

  if (planet_src == '') {
    return;
  }

  is_energy_bg = false;
  is_artifact_bg = false;

  if (planet_src in habitat_globe_models_has_item) {

    console.log('check what item is available here.. (or other action) ')
    item_found = null;

    if (confirmation) {
      startLoadingModal();
    }
    await getHabitat(habitat_id)

    if (item_found != null && item_found.em != '') {

      console.log('item found: ')
      console.log(item_found)

      if (confirmation) {
        showFound(item_found, item_found.item_image, item_found.n, item_found.a, habitat_name, item_found.avp, item_found.energy);
      }

      //depending if artifact or item, hide those
      if (item_found.t_id != 10) {

        is_energy_bg = true;
        //item collected
        if (objects[habitat_name].item != null) {
          objects[habitat_name].item.visible = false;
          console.log('hiding item ' + objects[habitat_name].item.name + ' ' + objects[habitat_name].item.visible)

          console.log(habitat_globe_models_has_item)
          habitat_globe_models_has_item = remove_item(habitat_globe_models_has_item, planet_src);
          console.log(habitat_globe_models_has_item)
        }
        console.log(item_found.em + 'item collected')

        //if (confirmation) {
          _increase_power(item_found.e)
        //}
      } else {

        is_artifact_bg = true;
        //artifact collected
        if (objects[habitat_name].artifact != null) {
          objects[habitat_name].artifact.visible = false;
          console.log('hiding artifact ' + objects[habitat_name].artifact.name + ' ' + objects[habitat_name].artifact.visible)

          //remove
          console.log(habitat_globe_models_has_item)
          habitat_globe_models_has_item = remove_item(habitat_globe_models_has_item, planet_src);
          console.log(habitat_globe_models_has_item)
        }
        console.log(item_found.em + 'artifact collected')

        //reset artifacts list
        artifacts = [];
        artifacts_n++;
        article_n = 0;
      }

      await get_habitats();
      await load_habitats_models();

      console.log('show items again: ')
      console.log(habitat_globe_models_has_item)

		} else {

      //clear up remnant artifacts/items models
      habitat_globe_models_has_item = remove_item(habitat_globe_models_has_item, planet_src);
      if (objects[habitat_name].item != null) {
        objects[habitat_name].item.visible = false;
      }
      if (objects[habitat_name].artifact != null) {
        objects[habitat_name].artifact.visible = false;
      }

      if (confirmation) {
        closeModal();
      }
    }

    //refresh items
    //await get_habitats();
  } else {

    //if no item to pick up, see if this mebot is Rebuilding
    if (aa_id == '4' && (objects[habitat_name].state >= 2)) {

      console.log('trying to repair: ' + habitat_name + ' (' + objects[habitat_name].state + ') + with: ' + planet_src)
      habitat_alert = null;
      await getHabitat(habitat_id)
      if (habitat_alert != null && habitat_alert.msg != '' && habitat_alert.repaired == 1 ) {

        //repair
        update_habitat_texture(planet_src, planet_src, 1)
        //showAlert(habitat_alert.msg);

        refreshSparkles(); //rebuilding costs 100 duds
      }

      habitat_alert = null;
    }

  }
}

async function embarkOnJourney() {

  const res = await fetch(
    "https://api.forever.today/?method=embark_on_journey",
    {
      method: "POST",
      body: JSON.stringify({
        dash_token: dash_token,
        mebot_id,
        habitat_id
      }),
    }
  );

  await get_habitats();
  display_clicked_object_extra = '';
}

async function getHabitatDirections() {
		const res = await fetch(
			"https://api.forever.today/?method=get_habitat_direction",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					habitat_id,
          mebot_id
				}),
			}
		);

		const json = await res.json();
    embark = json.data.habitat.embark;
}

async function openExtraMenu(habitat_id) {

  if (habitat_id > 0) {
    embark['info'] = '';
    open_extra_menu = true;
    map_bottom = 0;
    content_loading.update(n => true);
    await getHabitatDirections()
    content_loading.update(n => false);
  }
}

async function changeMode(mode_id = -1) {

		show_mebots = false;
		just_collected = false;
		just_collected_visted = '';

		if (mode_id == -1) {

			open_modes_menu = !open_modes_menu;
			content_loading.update(n => true);

      if (open_modes_menu) {
        map_bottom = 0;
      } else {
        //restart swiping on main screen
        offsets = document.getElementById('canvas-container').getBoundingClientRect();
        map_bottom = offsets.bottom;
      }

      if (open_modes_menu) {

			const res = await fetch(
				"https://api.forever.today/?method=get_mebot_modes",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token: dash_token,
						mebot_id: mebot_id,
            is_abbrev: 1
					}),
				}
			);

			const json = await res.json();
			content_loading.update(n => false);

			mebot_md = json.data.mebot_md;
			modes = json.data.modes;

			if (mebot_md.dp > 0) {
				power_avail.set(mebot_md.dp/100);
			}

      }

		}

		if (mode_id >= 1) {
			console.log('changing state with cmd_id: ' + mode_id)

			modes = [];
			content_loading.update(n => true);
			await sendChatCmd(mode_id);

      //reload habitats (because it has journey info) instead of reloading the map
      await get_habitats();

			//await fetchMapHabitats();
			//zoomMap(0);
			content_loading.update(n => false);
      closeModesMenu();

      //save curent map state
      saveMapState()

			//replace('/go/2/map42/' + mebot_id);
			//replace('/go/2/map/0_' + mebot_id);
		}

		if (mode_id == 0) {
      saveMapState()
      replace('/go/2/map42/' + mebot_id);
			//replace('/go/2/map/0_' + mebot_id);
		}

}

function saveMapState(reset = false) {
  if (reset) {
    //clear out
    setCookie("map_spinner", '', 30);
    setCookie("map_pitch", '', 30);
    setCookie("map_zoom", '', 30);
  } else {
    setCookie("map_spinner", spinner, 1);
    setCookie("map_pitch", current_pitch, 1);
    setCookie("map_zoom", current_zoom, 1);
  }
}

async function showMebots() {

show_mebots = !show_mebots;
//map_menu = false;
//open_modes_menu = false;

if (show_mebots) {

  //stop from swiping on the main screen
  map_bottom = 0;

  //refresh
  await getMyMebots();
} else {
  //restart swiping on main screen
  offsets = document.getElementById('canvas-container').getBoundingClientRect();
  map_bottom = offsets.bottom;
}

}

async function getMyMebots() {

		mebots_loading = true;
		content_loading.update(n => true);

		let res = await fetch(
			"https://api.forever.today/?method=get_mebots",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
				}),
			}
		);

		let json = await res.json();
		let runners = json.data.mebots;
		let ii = 0;

		let mebots_tmp = [];
		for (const runner of runners) {
			if (runner.md.is_hatched == 1 || runner.m_id > 10000) {
				mebots_tmp.push({
					id: runner.m_id,
					img: runner.mebot_img_url,
					is_hatched: runner.md.is_hatched,
					chain_id: runner.md.chain_id,
					mtype: runner.md.mtype,
					is_hatching: runner.md.is_hatching,
					is_active: runner.md.is_active,
					minted: runner.md.minted,
					hatched: runner.md.hatched,
					watt_level: runner.md.watt_level,
					autopilot_level: runner.md.autopilot_level,
					trips: runner.md.trips,
					auto_walk: runner.md.auto_walk,
					byline: runner.md.byline,
					extra: runner.md.extra,
					badges: runner.md.badges,
					n_items: runner.md.n_items,
					hs: runner.md.hs,
				});
				ii++;
			}
		}
		mebots = mebots_tmp;

		mebots_loading = false;
		content_loading.update(n => false);
}

const loadOnMebotScroll = (elem) => {
    return;

		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - x) ) {
			return;
			if (artifact_fetching == false) {
				//article_n += artifact_page_size;
				//getArtifacts(article_n);
				//console.log('article_n: ' + article_n);
			}
		}
}

async function activateMebot(m_id) {
		const res = await fetch(
			"https://api.forever.today/?method=activate_mebot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id
				}),
			}
		);

		mebot_id = m_id;
		const json = await res.json();
}

async function refreshSparkles() {

	let client_width = document.documentElement.clientWidth;

		const res = await fetch(
			"https://api.forever.today/?method=get_dash_user",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					client_width
				}),
			}
		);
	const json = await res.json();
	sparkles = json.data.md.sparkles;
}

async function doPost() {

    //TODO: simply, call function that gets just what's needed (get_dash_user is heavy)
		const res = await fetch(
			"https://api.forever.today/?method=get_dash_user",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token
				}),
			}
		);

		const json = await res.json();
		my_mebot_img_url = json.data.mebot_img_url;
    sparkles = json.data.md.sparkles;
    console.log('sparkle balance: ' + sparkles)

		setCookie("mebot_img_url", my_mebot_img_url, 30);
		setCookie("m_id", mebot_id, 30);

		const stat_type = 1;
    const res1 = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
        mebot_id,
        stat_type
      })
		});

    const json1 = await res1.json()
		if (json1.data.mebot.badges.length > 0) {
			//mebot_badges = json1.data.mebot.badges[0].em

      for (const badge of json1.data.mebot.badges) {
        mebot_badges += badge.em;
      }
    }
}

const displayArtifactDetails = async (e) => {
	var i = Number(e.target.dataset.cardId)

	if (i >= 0) {
		show_artifact_detail = i;
    console.log('show artifact: ' + artifacts[show_artifact_detail].id)

    setActiveArtifact(show_artifact_detail)
	}
}

async function setActiveArtifact(id) {

  aa_id = artifacts[show_artifact_detail].id;
  aa_em = artifacts[show_artifact_detail].em;
  aa_name = artifacts[show_artifact_detail].name;

  is_throwing_mode = false;
  show_artifacts_menu = false;
  ToggleThrow()

  //set_selected_ar
  if (aa_id > 0) {
    fetch('https://api.forever.today/?method=set_selected_artifact', {
      method: 'POST',
      body: JSON.stringify({
        dash_token,
        mebot_id,
        aa_id
      })
    });
  }

}

let scroll_x = 800 // the value returned by getX() function
let article_n = 0; // number of items that load on the page initially

async function resetArtifacts() {

  //reset
}

async function showArtifacts() {

  show_artifacts_menu = !show_artifacts_menu;
  //map_menu = false;
  //open_modes_menu = false;

  if (show_artifacts_menu) {

    //stop from swiping on the main screen
    map_bottom = 0;

    //refresh
    await getArtifacts(article_n);
  } else {
    //restart swiping on main screen
    offsets = document.getElementById('canvas-container').getBoundingClientRect();
    map_bottom = offsets.bottom;
  }
}

const loadOnArtifactScroll = (elem) => {
		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - scroll_x) ) {

			if (artifact_fetching == false) {
				article_n += artifact_page_size;
				getArtifacts(article_n);
				//console.log('article_n: ' + article_n);
			}
		}
}

async function getArtifacts(offset = -1) {

	if (offset > 0 && artifacts_uc <= artifacts.length) {
		//reached end of all available artifacts
		return;
	}

	if (mebot_id > 0) {

		console.log('getting artifacts, offset: ' + offset)
		artifact_fetching = true;
		content_loading.update(n => artifact_fetching);

		let res = await fetch(
			"https://api.forever.today/?method=get_artifacts",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
          mebot_id,
					offset,
				}),
			}
		);

		let json = await res.json();
		let runners = json.data.artifacts;
		let ii = 0;
		artifacts_tmp = [];
		for (const runner of runners) {
      artifacts_tmp.push({
        id: runner.id,
        em: runner.em,
        n: runner.n,
        title: runner.name,
        desc: runner.desc,
        v: runner.v,
        sell: runner.sell,
        has_asset: runner.has_asset,
        action_type: runner.a_type,
        name: runner.name
			});

      a_action_type[runner.id] = runner.a_type;
      a_weight[runner.id] = runner.weight;
      a_blast[runner.id] = runner.blast;
      if (runner.b_color > 0) {
        a_blast_color[runner.id] = runner.b_color;
      }
      if (runner.vel > 0) {
        a_velocity[runner.id] = runner.vel;
      }

			//ii = ii + runner.n;
		}

		if (offset == -1 || article_n == 0) {
			artifacts = artifacts_tmp;
			article_n = 0;

		} else {
			//append
			artifacts = artifacts.concat(artifacts_tmp);
		}

		artifacts_n = json.data.n;
		artifacts_uc = json.data.uc;
		//artifacts.push({em: '🎧', n: 1});
		//artifacts.push({em: '🥄', n: 7});
		//artifacts.push({em: '🥊', n: 3});
		//artifacts.push({em: '〇', n: 3});
		//artifacts.push({em: '🛸', n: 1});
		//artifacts.push({em: '🚀', n: 2});

    artifact_fetching = false;
    content_loading.update(n => artifact_fetching);
  }
}

//unused (from: https://discourse.threejs.org/t/when-to-dispose-how-to-completely-clean-up-a-three-js-scene/1549/15)
async function scene_cleanup(gltf_obj) {
        let texture_maps = [ 'map', 'aoMap', 'alphaMap', 'bumpMap', 'displacementMap', 'envMap', 'lightMap', 'emissiveMap', 'normalMap',
          'metalnessMap', 'roughnessMap', 'anisotropyMap', 'clearcoatMap', 'clearcoatNormalMap', 'clearcoatRoughnessMap',
          'iridescenceMap', 'iridescenceThicknessMap', 'sheenColorMap', 'sheenRoughnessMap', 'specularMap',
          'specularColorMap', 'specularIntensityMap', 'thicknessMap', 'transmissionMap'
        ];

        // Remove GLTF model from the scene
        map_scene.remove( gltf_obj );

        renderer_42.clear();

        // If animation_mixer was declared and created uncomment the following lines
        //if (animation_mixer) {
        //  animation_mixer.stopAllAction();

        //  for ( let i = 0; i < animations.length; i++ ) {
        //    animation_mixer.uncacheAction( animations[ i ] );
        //    animation_mixer.uncacheClip( animations[ i ] );
        //  }

        //  animation_mixer.uncacheRoot( animation_mixer.getRoot() );
        //}

        if (gltf_obj.skeleton && gltf_obj.skeleton.boneTexture)
          gltf_obj.skeleton.boneTexture.dispose();

        gltf_obj.traverse( function( child ) {
          if (child.isMesh || child.isPoints || child.isLine) {
            if (child.skeleton && child.skeleton.boneTexture)
                child.skeleton.boneTexture.dispose();

            if (child.material) {
              if (Array.isArray( child.material )) {
                child.material.forEach( mtl => {
                  if (mtl.uniforms) {
                    Object.keys( mtl.uniforms ).forEach( ( key ) => {
                      if (mtl.uniforms[ key ].value) {
                        let kv = mtl.uniforms[ key ].value;

                        if (Array.isArray( kv ) && kv.length > 0) {
                          kv.forEach( val => {
                            if (val.type && val.type === 1009) val.dispose();
                          });
                        } else {
                          if (kv.type && kv.type === 1009) kv.dispose();
                        }
                      }
                    });
                  } else {
                    for (const prop in mtl) {
                      texture_maps.forEach( tex_map => {
                        if (prop === tex_map) {
                          if (mtl[ prop ]) mtl[ prop ].dispose();
                        }
                      });
                    };
                  }

                  mtl.dispose();
                });
              } else {
                if (child.material.uniforms) {
                  Object.keys( child.material.uniforms ).forEach( ( key ) => {
                    if (child.material.uniforms[ key ].value) {
                      let kv = child.material.uniforms[ key ].value;

                      if (Array.isArray( kv ) && kv.length > 0) {
                        kv.forEach( val => {
                          if (val.type && val.type === 1009) val.dispose();
                        });
                      } else {
                        if (kv.type && kv.type === 1009) kv.dispose();
                      }
                    }
                  });
                } else {
                  for (const prop in child.material) {
                    texture_maps.forEach( tex_map => {
                      if (prop === tex_map) {
                        if (child.material[ prop ]) child.material[ prop ].dispose();
                      }
                    });
                  };
                }

                child.material.dispose();
              }
            }

            child.geometry.dispose();
          }
        });

        // If cleaning the whole scene uncomment the following lines
        //renderer.dispose();

        //while (scene.children.length > 0) {
        //  scene.remove( scene.children[ 0 ] );
        //}
}

const cleanMaterial = material => {
	//console.log('dispose material!')
	material.dispose()

	// dispose textures
	for (const key of Object.keys(material)) {
		const value = material[key]
		if (value && typeof value === 'object' && 'minFilter' in value) {
			//console.log('dispose texture!')
			value.dispose()
		}
	}
}

function scene_cleanup1() {

map_scene.traverse(object => {
	if (!object.isMesh) return;

	//console.log('dispose geometry!')
	object.geometry.dispose()

	if (object.material.isMaterial) {
		cleanMaterial(object.material)
	} else {
		// an array of materials
		for (const material of object.material) cleanMaterial(material)
	}
})

map_scene.clear()
renderer_42.dispose()
renderer_42.forceContextLoss()

console.log( 'Memory2: ', renderer_42.info.memory );
console.log( 'Render2: ', renderer_42.info.render );

}

function destroy() {

  try {
    console.log('world being destroyed...')

  //game.stop();
  //game = null;

  console.log( 'Memory1: ', renderer_42.info.memory );
  console.log( 'Render1: ', renderer_42.info.render );

  is_running = 0;
  map42.remove();
  camera = null;
  customLayer = null;

	//for (const item of glb_items) {
    //await scene_cleanup(item)
  //}
  //glb_items.forEach(function(item){
  //  await scene_cleanup(item)
  //});
  scene_cleanup1();

  map_scene = null;
  map_projectile = null;
  objects = [];
  raycaster = null;
  renderer_42 = null;

  cancel_touch();
  console.log('destroyed');

  } catch (error) {
    console.error("Error:", error);
  }

}

onDestroy(() => {
  destroy();
});

let fetching = false;
let thread_id = 0;
let page_size = 28;
let mebot_chats = [];
let mebot_chats_tmp = [];
let mebot_attr = [];
let actions = [];

  let value = '';
	let onChange = () => {};

	let onCancel = () => {};
	let onOkay = () => {
        console.log (value)
        sendChat(1, value)
        value = '';
    };

	function _onCancel() {
		onCancel();
		close();
	}

	function _onOkay() {
		onOkay(value);
		close();
	}

    function displayMenu(id) {
        console.log('id: ' + id);
    }

    function keyPressed(key) {

        //e.which === 13 && _onOkay()
        //console.log(key)
        if (key == 13) {
            _onOkay()
        }
        if (key == 191 && value.length == 0) {

            document.getElementById("chat_input").attributes["type"].value = "search";

            //var mycars = ['/Available items', '/Collect items', '/Help'];
            var list = document.getElementById('mebot_actions');

            actions.forEach(function(item){
                var option = document.createElement('option');
                option.value = item;
                option.id = item;
                //make sure it doesn't exist yet
                //console.log( document.getElementById(item) )
                if ( document.getElementById(item) == null ) {
                    list.appendChild(option);
                }
            });

            //check if this was first letter in input box
            //modify input box
            //add commands
            //console.log(Array.from(value)[0])
            //console.log('key: ' + key);
            //console.log('first key: ' + value.charAt(0));
        }
    }

	$: onChange(value)

/*TUNNEL

const w = window.innerWidth;
const h = window.innerHeight;
const scene = new THREE.Scene();
scene.fog = new THREE.FogExp2(0x000000, 0.4);
const tcamera = new THREE.PerspectiveCamera(75, w / h, 0.1, 1000);
tcamera.position.z = 5;
let trenderer = null
let tcanvas = null;

//const renderScene = new RenderPass(scene, camera);
//const bloomPass = new UnrealBloomPass(new THREE.Vector2(w, h), 1.5, 0.4, 100);
//bloomPass.threshold = 0.002;
//bloomPass.strength = 2.0;
//bloomPass.radius = 0;
//const composer = new EffectComposer(renderer);
//composer.addPass(renderScene);
//composer.addPass(bloomPass);

const curvePath = [
        10.136184463414924, -1.374508746897471, 10.384881573913269,
        9.1152593889854714, -1.374508746897471, 8.5846792797570011,
        9.0669355709754882, -1.0665123466336568, 5.8937771631608156,
        10.151040177840205, -0.65913653144937956, 3.4340491740541346,
        10.806779203170416, 1.8859391007298545, 0.46855774212986023,
        10.761433540147586, 2.8724172201359197, -1.2811838605587311,
        9.6195923104445065, 2.8724172201359197, -3.2833099941904766,
        6.9763020889151646, 2.7659257976905427, -4.7591958908830172,
        6.0461277891353697, 1.0727045302089879, -6.6638740164090482,
        7.3472235778544794, -1.8228856326635698, -9.0685043046185623,
        7.226367212900791, -1.8228856326635698, -10.499536640855691,
        5.8354566696263914, -1.8228856326635698, -12.039219379199908,
        3.6532357452141353, -0.20463983570573391, -13.87695442281038,
        -0.30169589630131455, 1.5965000671484342, -14.879986418947327,
        -2.8925694230502157, 2.2971364614427481, -13.892095587598131,
        -4.537672295357936, 4.5863515759659208, -12.140831652074551,
        -6.1287913464117594, 5.9653814634119815, -8.9776527318875896,
        -6.0120301606452813, 4.4081161943855998, -6.712084358394045,
        -5.2138252159038974, 2.820894808418279, -4.4532820412085607,
        -2.3424712835109611, 2.2032065005086259, -3.0788773693500198,
        -0.0076956453915433265, 1.8931797788880202, -1.6577070662471063,
        -0.24767503988481437, 2.8845808465856684, 0.073915859214221724,
        -2.2174044353598896, 4.2415524507318576, 2.215992718290742,
        -3.4526531678364756, 3.0615192023340851, 4.7922404932096558,
        -3.7356278971556445, 1.4054080369354316, 7.8432021841434629,
        -3.4003734463804118, 1.1924069108769393, 9.2464090886227073,
        -1.8851803760476225, 1.5269331003449989, 10.306083896408374,
        0.01071077144031829, 2.1101821577522295, 10.490880699847727,
        0.42562058195647001, 2.2759939598834387, 11.613129436580291,
        0.096405262182225115, 0.032317784084054391, 16.223455375061565,
        2.3458797884520433, 0.38907275257695584, 19.91188266079584,
        5.7018400098488771, 1.73337964747396, 20.615481586999959,
        7.9720939736751824, 1.73337964747396, 19.303399329816457,
        9.8672362721095652, 0.090083018057025177, 16.893338541618121,
        11.225959519544134, -1.374508746897471, 14.279002555560753,
        11.288646925965876, -1.374508746897471, 11.926359497447137,
        10.136184463414924, -1.374508746897471, 10.384881573913269
];

// construct tunnel track
let points = [];
const len = curvePath.length;
for (let p = 0; p < len; p += 3) {
  points.push(new THREE.Vector3(
    curvePath[p],
    curvePath[p + 1],
    curvePath[p + 2])
  );
}
const spline = new THREE.CatmullRomCurve3(points);

//import spline from "https://mebots.xyz/exper/wormhole/splinetest.js";
points = spline.getPoints(100);
const geometry = new THREE.BufferGeometry().setFromPoints(points);
const material = new THREE.LineBasicMaterial({ color: 0xff0000 });
const line = new THREE.Line(geometry, material);

const tubeGeo = new THREE.TubeGeometry(spline, 222, 0.7, 16, true);

// create edges geometry from the spline
const edges = new THREE.EdgesGeometry(tubeGeo, 0.5);
//const lineMat = new THREE.LineBasicMaterial({ color: 0xff0000 });
const lineMat = new THREE.LineBasicMaterial({ color: 0x1bffe8 });
const tubeLines = new THREE.LineSegments(edges, lineMat);
scene.add(tubeLines);

const numBoxes = 20;
var dir = new THREE.Vector3();
var screen_plane = new THREE.Vector3(0, 0, 1);

const size = 0.075;
const boxGeo = new THREE.BoxGeometry(size, size, size);
for (let i = 0; i < numBoxes; i += 1) {
  const boxMat = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    wireframe: true
  });
  const box = new THREE.Mesh(boxGeo, boxMat);
  const p = (i / numBoxes + Math.random() * 0.1) % 1;
  const pos = tubeGeo.parameters.path.getPointAt(p);
  pos.x += Math.random() - 0.4;
  pos.z += Math.random() - 0.4;
  box.position.copy(pos);
  const rote = new THREE.Vector3(
    Math.random() * Math.PI,
    Math.random() * Math.PI,
    Math.random() * Math.PI
  );
  box.rotation.set(rote.x, rote.y, rote.z);
  const edges = new THREE.EdgesGeometry(boxGeo, 0.5);
  const color = new THREE.Color().setHSL(0.7 - p, 1, 0.5);
  const lineMat = new THREE.LineBasicMaterial({ color });
  const boxLines = new THREE.LineSegments(edges, lineMat);
  boxLines.position.copy(pos);
  boxLines.rotation.set(rote.x, rote.y, rote.z);
  // scene.add(box);
  if (i % 2 == 1) {
    scene.add(boxLines);
  } else {
  }
}
const light = new THREE.AmbientLight( 0xc0c0c0 ); // soft white light
scene.add( light );

let looptime = 10 * 1000;
frames = 0;

let o_y = 0;
let o_x = 0;
var player_pos = new THREE.Vector3();
var player_offset = new THREE.Vector3(0, 0, 0);
var current_offset = new THREE.Vector3(0, 0, 0);
var move = new THREE.Vector3(0, 0, 0);
var empty = new THREE.Vector3(0, 0, 0);

var x = new THREE.Vector3(1, 0, 0);
var y = new THREE.Vector3(0, 1, 0);
var z = new THREE.Vector3(0, 0, 1);

var x_right = new THREE.Vector3(0.1, 0, 0);
var x_left = new THREE.Vector3(-0.1, 0, 0);
var y_up = new THREE.Vector3(0, 0.1, 0);
var y_down = new THREE.Vector3(0, -0.1, 0);
var dir_tmp = new THREE.Vector3(0, 0, 0);
//move.x = 0.2;

var world = new THREE.Vector3(0, 0, 0);
var quaternion = new THREE.Quaternion();

x_playerMoveAngleSpeed = 0.2;
//move.copy(x_right);

var time = null;
var p = null;
var lookAt = null;
*/

function updateCamera(t) {

if (looptime > 3700) {
  looptime = looptime*0.9995;
}

frames++;
if (frames == 200) {
  //window.location.replace('https://play.mebots.xyz/#/map/2/1/1_f1f4f95ae52b262f172e177d06272ba6f8c540c8');
  //return;
}

time = t * 0.3;
p = (time % looptime) / looptime;
player_pos = tubeGeo.parameters.path.getPointAt(p);
lookAt = tubeGeo.parameters.path.getPointAt((p + 0.03) % 1);

/*
x_playerMoveAngleSpeed = x_playerMoveAngleSpeed * 0.8;
o_x = o_x + x_playerMoveAngleSpeed;
y_playerMoveAngleSpeed = y_playerMoveAngleSpeed * 0.8;
o_y = o_y + y_playerMoveAngleSpeed;
if (o_x > 0.4) o_x = 0.4;
if (o_x < -0.4) o_x = -0.4;
//console.log(o_x);
if (o_y > 0.4) o_y = 0.4;
if (o_y < -0.4) o_y = -0.4;
//camera.getWorldDirection(world);
*/

if (move.length < 0.001) {

  move.copy(empty);

} else {

  //console.log(player_offset.length());
  //if too far from center slow down much more
  if (player_offset.length() > 0.7 && player_offset.clone().add(move).length() > player_offset.length()) {
    move.multiplyScalar(0.001);
  } else {
    move.multiplyScalar(0.976);
  }

  player_offset.add(move);

  current_offset.copy(player_offset);
    //dir.subVectors( player_pos, lookAt ).normalize();
    //dir.subVectors( lookAt, player_pos ).normalize();
    current_offset.applyQuaternion( tcamera.quaternion );

    player_pos.add(current_offset);
    lookAt.add(current_offset);
  }

  //console.log('offset: x:' + current_offset.x.toFixed(3) + ' y:' + current_offset.y.toFixed(3));
  //console.log('player_pos: ' + player_pos.x.toFixed(3) + ' y:' + player_pos.y.toFixed(3));

//console.log(model1.quaternion.rotateTowards(0.1));
//console.log(model1.quaternion);
  model1.rotateY(0.01);
//  model2.rotateY(0.005);

  tcamera.position.copy(player_pos);
  tcamera.lookAt(lookAt);
}

function animate(t = 0) {
  requestAnimationFrame(animate);
  updateCamera(t);
  //return;
  trenderer.render(scene, tcamera);
  //controls.update();
  //update_frames(); //fps
}

function showTunnel() {

  console.log('show tunnel 1')
  //var tcanvas = document.getElementById('tunnel_canvas');
  tcanvas = document.createElement('canvas');

  const w = window.innerWidth
  const h = window.innerHeight

  tcanvas.style.width = w + "px";
  tcanvas.style.height = h + "px";
  tcanvas.style.position = 'absolute'
  tcanvas.style.top = '0px';
  tcanvas.style['z-index'] = "20001";

  //tcanvas.width = 40;
  //tcanvas.height = 40;
//  var ctx = tcanvas.getContext('2d');

  console.log('show tunnel start')

  let gl = tcanvas.getContext("webgl2");
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      console.log( gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) );

  //trenderer = new THREE.WebGLRenderer();
  trenderer = new THREE.WebGLRenderer({
        canvas: tcanvas,
        antialias: true,
        alpha: true
      });

  /*
        // Create web renderer
        this.webRenderer = new THREE.WebGLRenderer({
            canvas: this.window.canvasWorld,
            antialias: false,
            //antialias: true,
            alpha: true
        });
  */

  trenderer.setSize(w, h);
  trenderer.toneMapping = THREE.ACESFilmicToneMapping;
  trenderer.outputColorSpace = THREE.SRGBColorSpace;

  console.log('show tunnel')

  document.body.appendChild(trenderer.domElement);

  animate();
}


</script>

{#if !is_fullsize }
<Header header_mebot_id={mebot_id} header_dash_token={dash_token} mebot_url={my_mebot_img_url} news_badge_n={news_badge_n} />
{/if}

<div class:square-world={ !is_fullsize } class:full_screen-world={ is_fullsize } style="position: relative; margin-left: auto; margin-right: auto;">
  <div class:grayed_out={map_loading} class:square-world={ !is_fullsize } class:full_screen-world={ is_fullsize } id="canvas-container" class="main1-square"></div>

  {#if map_loading }
  <center>
  <span style="position: absolute; top: 200px; margin-left: auto; margin-right: auto; z-index: 10001;"><div class="loader" use:loader={content_loading}><br><br></div></span>
  </center>
  {/if}

  <!--<span on:click={ () => ( pop() ) } style="position: absolute; top: 0px; left: 0px; z-index: 10001;">
    <img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
  </span>-->

  {#if is_fullsize }
  <a href="/#/dash/{dash_token}/{mebot_id}">
    <div class="button" style="position: absolute; top: 10px; left: 10px; z-index: 10001; opacity: 0.7;">
      <button id=1 class="menu_btn_home" >
        {#if mebot_url}
        <img style="user-select: none;" src={mebot_url} width="34px" height="34px" alt="My Mebot" />
        {:else }
        <img style="user-select: none;" src='https://app.mebots.xyz/img/egg-ai_500.png' width="30px" height="30px" alt="My Mebot" />
        {/if}
      </button>
    </div>
  </a>

  {#if is_city == 1 }
    <a href="https://app.mebots.xyz/invite.html?"><button id=2 class="menu_btn_join join-active" style="position: absolute; top: 10px; right: 60px; z-index: 10001;" >&nbsp;Sign up!&nbsp;</button>&nbsp;&nbsp;</a>
  {/if}

  {/if}

  {#if is_battling }

  {#if enemy_clicked_url != '' }

    <div style="width: 86px; align: left; margin-top: 8px;" class="outer_daily_power_enemy">
      <div class="progress_inner_daily_power_enemy" style="width: {$enemy_power * 100}%; margin-top: 5px;" ></div>
    </div>

  <span class="menu_btn enemy_mebot_battle" class:menu_extra-full={ is_fullsize }  on:click={() => attackEnemy() }>
    &nbsp; <span class="text-electric" style="color: black; width: 54px; height: 54px;">

      <img src={ enemy_clicked_url } width=54 height=54 alt='Mebot'>

    </span> &nbsp;
  </span>
  {/if}
  {#if mebot_clicked_url != '' }
  <span class="menu_btn my_mebot_battle" class:menu_extra-full={ is_fullsize } class:menu_btn_active2={ punched_flash } on:click={() => attackEnemy() }>
    <!--&nbsp; <span class="text-electric" style="color: black;">
      <img src={ mebot_clicked_url } width=54 height=54 alt='Mebot'>
    </span> &nbsp;-->
    <!--<div class="text-electric" style="color: black; width: 58px; height: 58px; text-align:center; vertical-align: middle; display: flex; justify-content: center; align-items: center;">
      <span style="font-size: 30px; margin:auto; vertical-align: middle;">🥊</span>
    </div>-->
      &nbsp; <span class="text-electric" style="color: black;">
      <img src='https://mebots.s3.amazonaws.com/hand_05.png' width=54 height=54 alt='Mebot'>
    </span> &nbsp;
  </span>
  {/if}

  {:else }

  <span on:click={ () => ( toggleFullSize() ) } style="position: absolute; top: 0px; right: 0px; z-index: 10001;">
    <img src="https://app.mebots.xyz/img/land_full_screen-500.png" style="margin: 14px;" alt="close" width="20px" height="20px">
  </span>

  <span class="menu_btn menu_stats" id="game_stats">
  </span>

  {#if is_city == 0 }

  {#if mebot_loc_id > 0 }
  <button class="menu_btn menu_cmd_center" class:menu_btn_active={ (open_modes_menu) } on:click={() => changeMode() } style="z-index: 10001;">
      &nbsp; <span class="text-electric"> 🎛️ </span> &nbsp;
    {#if journey['n_items'] > 0 }
      <span class="energy_items__badge">{ journey['n_items'] }</span>
    {/if}
  </button>
  {/if}

  {#if is_artifacts && mebot_loc_id > 0 }

  <span class="menu_btn menu_btn_artifacts" class:menu_btn_active={ (show_artifacts_menu) } class:menu_mebots={ (!show_artifacts_menu) } on:click={showArtifacts} style="z-index: 10001;">
    &nbsp; <span class="text-electric" style="color: white;"> 🚩 </span> &nbsp;
    {#if artifacts_n > 1 }
      <span class="mebots__badge">{ artifacts_n }</span>
    {/if}
  </span>

  {#if aa_id > 0 && aa_em != '' && mebot_loc_id > 0}
  <span class="menu_btn menu_throw_old" class:menu_btn_active={ is_throwing_mode } on:click={() => ToggleThrow() } >
    &nbsp; <span class="text-electric"> { aa_em } </span> &nbsp;
  </span>
  {/if}

  {/if}


  <span class="menu_btn menu_btn_mebots" class:menu_btn_active={ (show_mebots) } class:menu_mebots={ (!show_mebots) } on:click={showMebots} style="z-index: 10001;">
    &nbsp; <span class="text-electric"> ⬜ </span> &nbsp;
    {#if mebots.length > 1 }
    <span class="mebots__badge">{ mebots.length }</span>
    {/if}
  </span>

  {#if !show_challenge && !is_throwing_mode && display_clicked_object_extra == '' && journey['map42_info'] != '' && journey['can_build'] == 0 && mebot_loc_id > 0 && journey['iup'] == 0 }
  <div class=" text-electric menu_journey" class:menu_extra-full={ is_fullsize }  >
    {@html journey['map42_info'] }
  </div>
  {/if}

  {#if !is_throwing_mode && mebot_loc_id > 0 }
  <div class="text-electric menu_power" class:menu_extra-full={ is_fullsize } on:click={ () => ToggleThrow() } >

    {#if !show_challenge && mebot_md.power_avail !== undefined }

    <div class="text-green" style="margin-top: 4px; font-size: 12px; padding-top: 6px; padding-left: 10px; padding-right: 6px; ">
      <!--<span style="color: white;"> ⚡ </span> { mebot_md.power_avail }-->
      <span style="font-size: 12px; color: white;"> ⚡ Power <span class="steps-electric" class:no_power={ (mebot_md.power_avail <= 0) }><b>{ mebot_md.power_avail }</b> </span> </span>

		<table border=0><tr><td width=80px>
			<div style="width: 80px; align: left; margin-top: 2px;">
				{#if ($power_avail >= 0) }
					<div class="outer_daily_power">
						<div class="progress_inner_daily_power" style="width: {$power_avail * 100}%; margin-top: 4px; margin-bottom: 5px;" ></div>
					</div>
				{/if}
				</div>
		</td></tr></table>

    </div>
    {/if}

  </div>
  {/if}

  {#if !show_challenge && display_clicked_object_extra == '' && journey['can_build'] == 1 }
  <span class="menu_btn menu_extra claim_active" class:menu_extra-full={ is_fullsize } class:claim_active={ is_building == 0 } class:menu_btn_active={ is_building == 1 } on:click={() => buildOn() } style="z-index: 10001;">
   <!-- <span class="text-electric"> 🏗️ </span> -->
   <span style="letter-spacing: -em; padding-left: 8px; padding-right: 8px;"> Build ⊹ </span>
  </span>
  {/if}

  {/if}

  {#if display_clicked_object != '' }
  <span class="menu_btn menu_mouse" class:menu_extra-full={ is_fullsize } class:menu_btn_active={ is_moving } >
    &nbsp; <span class="text-electric"> { display_clicked_object } </span> &nbsp;
  </span>
  {/if}

  {#if mebot_clicked_url != '' }
  <span class="menu_btn menu_mebot" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span class="text-electric" style="color: black;">
      <img src={ mebot_clicked_url } width=54 height=54 alt='Mebot'>
    </span> &nbsp;
  </span>
  {/if}

  {#if habitat_clicked_url != '' && habitat_id > 0 }
    <img class="menu_mebot habitat_lg" class:menu_extra-full={ is_fullsize } src={habitat_clicked_url} alt="Habitat" on:click={() => openExtraMenu(habitat_id) }/>
  {/if}

  {#if artifact_clicked_object != '' }
  <span class="menu_btn menu_mebot" class:menu_extra-full={ is_fullsize } on:click={() => pickupMapArtifact() }>
    <div class="text-electric" style="color: black; width: 58px; height: 58px; text-align:center; vertical-align: middle; display: flex; justify-content: center; align-items: center;">
      <span style="font-size: 30px; margin:auto; vertical-align: middle;">{ objects[artifact_clicked_object].em }</span>
    </div>
  </span>
  {/if}

  {#if !show_challenge && display_clicked_object_extra != '' }
  <span class="menu_btn menu_extra" class:menu_extra-full={ is_fullsize } class:menu_btn_active1={ show_challenge } on:click={() => NewBattle() }>
    &nbsp; <span class="text-electric" style="color: black;"> {@html display_clicked_object_extra }</span> &nbsp;
  </span>
  {/if}

  {/if}

  {#if !is_throwing_mode }
  <span class="menu_background" class:menu_extra-full={ is_fullsize }>
    &nbsp;
  </span>
  {/if}

  {#if is_throwing_mode }
  <!--<span on:click={ () => ToggleThrow() } class="touchpad_close_cl" class:menu_extra-full={ is_fullsize } >
    <img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
  </span>
  -->

  <div class="text-electric menu_power_big" class:menu_extra-full={ is_fullsize } on:click={ () => ToggleThrow() } >
    {#if mebot_md.power_avail !== undefined }
    <div class="text-green" style="margin-top: 4px; font-size: 12px; padding-top: 6px; padding-left: 10px; padding-right: 6px; ">
      <!--<span style="color: white;"> ⚡ </span> { mebot_md.power_avail }-->
      <span style="font-size: 12px; color: white;"> ⚡ Power <span class="steps-electric" class:no_power={ (mebot_md.power_avail <= 0) }><b>{ mebot_md.power_avail }</b> </span> </span>

		<table border=0><tr><td width=80px>
			<div style="width: 80px; align: left; margin-top: 2px;">
				{#if ($power_avail >= 0) }
					<div class="outer_daily_power">
						<div class="progress_inner_daily_power" style="width: {$power_avail * 100}%; margin-top: 4px; margin-bottom: 5px;" ></div>
					</div>
				{/if}
				</div>
		</td></tr></table>

    </div>
    {/if}
  </div>

  {/if}

  <span class="touchpad_cl" class:is_hidden={ !is_throwing_mode } class:menu_extra-full={ is_fullsize } >

    {#if is_throwing_mode && map_projectile == null }
    <div class="loader" use:loader={content_loading}><br><br></div>
    {/if}

  </span>
  <canvas class="touchpad_canvas_cl" class:is_hidden={ !is_throwing_mode } class:menu_extra-full={ is_fullsize } id="touchpad_cvs" on:touchstart={ startedThrowing } on:mousedown={ startedThrowing }> </canvas>

  <!--<video id="video" playsinline webkit-playsinline muted loop autoplay width="1440" height="1440" src="video_texture1.mp4" style="display: none;"></video>-->

  
  {#if show_challenge && mebot_loc_id > 0 }
    {#if !is_battling }
    <span class="menu_btn menu_challenge" class:menu_extra-full={ is_fullsize } class:menu_btn_active1={ show_challenge } on:click={() => toggleBattle(true) }>
      &nbsp; <span class="text-electric" style="color: black;"> Fight 🧟</span> &nbsp; 
    </span>
    <span class="menu_btn menu_talk_to" class:menu_extra-full={ is_fullsize } class:menu_btn_active1={ show_challenge } on:click={() => chatMebot() }>
      &nbsp; <span class="text-electric" style="color: black;"> Talk to 🗣️</span> &nbsp; 
    </span>
    {:else }
      <img class="menu_btn menu_challenge" src="https://app.mebots.xyz/img/close-btn-500-white.png" class:menu_extra-full={ is_fullsize } class:menu_btn_active1={ show_challenge } on:click={() => toggleBattle(false) } 
       alt="close" width="20px" height="20px">
    {/if}
  {/if}

  {#if !is_throwing_mode && is_city == 0 && journey['steps_left'] != 'no data' }

  <span class="steps_left sparks_energy" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span style="font-size: 12px;"> ✨ <span class="steps-electric"><b>{ numberWithCommas(sparkles) }</b> </span> </span> &nbsp;
  </span>

  {#if mebot_md.power_bank !== undefined }
  <span class="steps_left battery_energy" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span style="font-size: 12px;"> 🔋 <span class="steps-electric"><b>{ mebot_md.power_bank }</b> </span> </span> &nbsp;
  </span>
  {/if}

  <span class="steps_left steps_left1" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span style="font-size: 12px;"> 👟 <span class="steps-electric"><b>{ numberWithCommas(journey['steps_left']) }</b> </span> </span> &nbsp;
  </span>

  {#if is_stats }
    <span style="font-size: 12px; color: #fff;" class="steps_left current_fps" > ◻️{fps}</span>
    <span style="font-size: 12px; color: #fff;" class="steps_left swipe_angle" > ◻️{initial_swipe_rotation.toFixed(2)}</span>
  {/if}

  {/if}

  {#if is_city == 1 && city_info['name'] != '' }

  {#if display_clicked_object == '' }
    <span class="menu_btn menu_mouse" class:menu_extra-full={ is_fullsize } class:menu_btn_active={ is_moving } >
      &nbsp; <span class="text-electric"> { city_info['name'] } </span> &nbsp;
    </span>
  {/if}

  <span class="steps_left battery_energy" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span style="font-size: 12px;">  <span class="steps-electric"><b>{ city_info['n'] } 🏃</b> </span> </span> &nbsp;
  </span>

  <span class="steps_left steps_left1" class:menu_extra-full={ is_fullsize } >
    &nbsp; <span style="font-size: 12px;"> <span class="steps-electric"><b> { city_info['steps'] }</b> </span> </span> &nbsp;
  </span>

  {/if}

  <!--
  <span class="menu_btn menu_throw" class:menu_btn_active={ is_throwing == 1 } on:touchend={ throw_ball } on:touchstart= { ThrowStart }>
    <div class="text-electric" style="color: black; width: 58px; height: 58px; text-align:center; vertical-align: middle; display: flex; justify-content: center; align-items: center;">
      <span style="font-size: 30px; margin:auto; vertical-align: middle;"> 🎾</span>
    </div>
  </span>-->

<!--  <span class="menu_btn menu_throw_old" class:menu_btn_active={ is_throwing_mode } on:click={() => ToggleThrow() } >
    &nbsp; <span class="text-electric"> 🎾 </span> &nbsp;
  </span>-->

  {#if throw_power_visible && map_projectile == null }
  <div style="width: 86px; align: left; margin-top: 8px; position: absolute; z-index: 10002; margin-left: 12px; top: 0px; left 10px; margin-top: 402px;" >
    <div  class="progress_inner_daily_power_enemy" style="width: {$enemy_power * 100}%; margin-top: 5px;" ></div>
  </div>
  {/if}

  {#if !is_battling }

  <span class="menu_btn menu_move" on:click={() => SetNorth() }>
    &nbsp; <span class="text-electric"> 🧭 </span> &nbsp;
  </span>

  <span class="menu_btn menu_jump" class:menu_btn_active={ zooming_in } on:click={() => ZoomIn() }>
    &nbsp; <span class="text-electric"> ➕️ </span> &nbsp;
  </span>

  <span class="menu_btn menu_mine" class:menu_btn_active={ zooming_out } on:click={() => ZoomOut() }>
    &nbsp; <span class="text-electric"> ➖️ </span> &nbsp;
  </span>

  <!--<span class="menu_btn menu_build" class:menu_btn_active={ spinning_dir != 0 } on:click={() => Battle() }>
    &nbsp; <span class="text-electric"> ⚔️ </span> &nbsp;
  </span>-->

  <span class="menu_btn menu_center" class:menu_btn_active={ is_centering } on:click={() => CenterPlayer() }>
    &nbsp; <span class="text-electric"> 🔵 </span> &nbsp;
  </span>

  {/if}

<!--
  <span class="menu_btn menu_throw" class:menu_btn_active={ game != null && is_throwing == 1 } on:click={() => throwBall() }>
    &nbsp; <span class="text-electric"> 🎾 </span> &nbsp;
  </span>
-->
<!--
  <span class="menu_btn menu_pov" class:menu_mebots_state_active_active={ 0 } on:click={() => changePov() }>
    &nbsp; <span class="text-electric"> 🎛️ </span> &nbsp;
  </span>-->

  <canvas class="terrain_map" id="terrain_map"> </canvas>

  {#if is_modal_open }

  <div style="position: absolute; width: 94%; height: 70%; vertical-align: top; justify-content: center; align-items: center; margin-left: 3%;
  margin-right: 3%; margin-top: 15%; margin-bottom: 15%; " class:green_bg={is_energy_bg} class:pink_bg={is_artifact_bg}>
  <center>
  <div class="modal-main1" class:green_bg={is_energy_bg} class:pink_bg={is_artifact_bg}>
    <center>
    <div style="width: 86%;">
		<div style="height: 16px;"></div>

    <span on:click={ () => closeModal() } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

		<div>
		<center>
      <!--
			<br>
			<div class="text-electric" style="font-size: 16px;"> { display_clicked_object } </div>
			<br>

		  <img on:click={ () => replace('/go/2/map42/' + mebot_id) }
			src="{habitat_clicked_url}" width=80 height=80 alt='Mebot' class="text-electric-location1" style="border-radius: 10px;"><br>
			{@html journey['distance'] }-->
		</center>
		</div>


    {#if modal_msg == '' }
    <div class="loader" use:loader={content_loading}><br><br></div>
    {:else }

    <br>
    <div class="text-electric-white-clock">
      {@html modal_msg }
    </div>
    <br>
    {#if modal_action_msg != '' }
      <button class="menu_btn_mebots_rounded menu_mebots_mode_active" on:click={ () => closeModal() }> {@html modal_action_msg } </button>
    {/if}

    {/if}


    </div>
    </center>

	</div>
  </center>
  </div>
  {/if}


  {#if open_extra_menu }

  <div class="modes-main1-square">
    <center>
		<div style="height: 16px;"></div>

		<span on:click={ () => closeExtraMenu() } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

    <div style="width: 100%;">

		<div>
		<center>
			<br>
			<div class="text-electric" style="font-size: 16px;"> { display_clicked_object } </div>
			<br>

		  <!--<img on:click={ () => replace('/go/2/map42/' + mebot_id) }-->
      <img src="{habitat_clicked_url}" width=130 height=130 alt='Mebot' class="text-electric-location1" style="border-radius: 10px;">
      <br>
			<!--{@html journey['distance'] }-->
		</center>
		</div>

    {#if (habitat_id > 0 && journey['to_hid'] == habitat_id) }

    <div>
    <center>
      <br><br><br>
      {@html journey['distance'] }
      <br><button class="menu_btn_mebots_rounded menu_mebots_mode_active" on:click={ () => closeExtraMenu() }> Okay </button>
		</center>
    </div>

    {:else if embark['info'] != ''}
		  <br><br>

      <div class="snake_row">
        <center>
          <div class="text-electric" style="font-size: 12px;"> {@html embark['info'] } </div>

          <br><br>

          {#if (embark['steps_away'] > 0) }
          <div>
          {#if (habitat_id > 0 && journey['to_hid'] == habitat_id) }
            {@html journey['distance'] }
            <br><button class="menu_btn_mebots_rounded menu_mebots_mode_active" on:click={ () => closeExtraMenu() }> Okay </button>
          {:else }
            <button class="menu_btn_mebots_rounded menu_mebots_mode_active" on:click={ () => embarkOnJourney() }> Send your Mebot here ➡️ </button>
          {/if}
          </div>
          {/if}

        </center>
      </div>
		{/if}

		{#if embark['info'] == '' }
      <div class="loader" use:loader={content_loading}><br><br></div>
		{/if}

    </div>
    </center>
	</div>
	{/if}

  {#if show_artifacts_menu }

	<div class="main1 gray_bg" on:scroll="{ () => loadOnArtifactScroll(document.querySelector('.main1')) }">

    <center>
		<div style="height: 16px;"></div>

		<span on:click={ () => ( showArtifacts() ) } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

    <center>
			<table width=230px border=0 height=30px>
				<tr>
					<td width="30px" valign=top allign=center> <div class="text-electric"> &nbsp; </div> </td>
					<td width=200px align=center>
						<br><div class="text-electric" style="font-size: 16px;"> Artifacts 🚩 </div><br><br>
					</td>
					<td width="30px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;"> &nbsp; </div> </td>
				</tr>
			</table>
      <br>

			<div class="snake_row">
			{#each artifacts as artifact, i}

      <div class="artifact-flip-box">
				<div class="flip-box-inner">
				<div class="flip-box-front artifact-card">
					<div class="vertical-center" style="position: relative;" on:click={ displayArtifactDetails }>
						<div class="text-electric" style="border-radius: 8px; padding: 6px; margin: 4px; font-size: 28px;" 
            class:artifact_active={ show_artifact_detail in artifacts && artifacts[show_artifact_detail].id == artifact.id }
            class:artifact_has_asset_throw={ artifact.has_asset && artifact.action_type == 1 }
              transition:fade|local={{duration: 300}}> <div data-card-id={i}>{ artifact.em }</div> </div>
						{#if artifact.n > 1 }
  						<span class="artifact__badge"> {artifact.n} </span>
						{/if}
					</div>
				</div>
				</div>
			</div>

			{/each}
			</div>

      {#if artifact_fetching }
      <br><br><div class="loader" use:loader={content_loading}><br><br></div>
      {/if}

			<br><br><br><br><br><br>
			<br><br><br><br><br><br>
			<br><br><br><br><br><br>

		</center>

    </center>
	</div>
  {/if}

	{#if open_modes_menu }
	<div class="modes-main1-square green_bg">
    <center>
		<div style="height: 16px;"></div>

		<span on:click={ () => changeMode() } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

		<div>
		<center>
			<br>
			<div class="text-electric" style="font-size: 16px;"> Command Center </div>
			<br>

		  <img on:click={ () => replace('/go/2/map42/' + mebot_id) }
			src="{mebot_url}" width=80 height=80 alt='Mebot' class="text-electric-location1" style="border-radius: 10px;"><br>
			{@html journey['distance'] }
		</center>
		</div>

		<div class="snake_row">

			{#each modes as state, i}
      {#if state.group_id == 2 }
			<div class="modes-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => changeMode( (
					(state.is_state_on == 0 && state.group_id == 1) ||
					(state.is_mode_on == 0 && state.group_id == 2)
				) ? state.cmd_id : 0 ) }>
						<div class="message question" >
							<button data-card-id={i} class="menu_btn_mebots_rounded"
							class:menu_mebots_state_active={ state.is_state_on == 0 && state.group_id == 1 }
							class:menu_mebots_mode_active={ state.is_mode_on == 0 && state.group_id == 2 }
							style="margin-top: 4px; width: 78px; height: 35px; white-space: nowrap; font-size: 10px;">
							{#if state.is_state_on == 1 || state.is_mode_on == 1 }
								{@html state.name_active }
							{:else}
								{@html state.name }
							{/if}
							</button>
						</div>
				</div>
			</div>
			</div>
			</div>
      {/if}
			{/each}

		</div>

		{#if modes.length > 0 }

		<center>

		{#if journey['map42_info'] != '' }
		<div class="text-electric" style="margin-top: 6px; margin-bottom: 0px;" >
		{@html journey['map42_info'] }
		</div>
		{/if}

		{#if (journey['chat_cmd_id'] != '' || just_collected) }

		{#if (journey['visited'] != '') }
			<div class="text-electric-white-clock" style="margin-top: 10px;">
			{@html journey['visited'] }
			</div>
		{:else}
			<div class="text-electric-collected-grad" style="margin-top: 10px;">
			{@html just_collected_visted }
			</div>
		{/if}

		<div class="snake_row">

			<div class="energy-collect-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (journey['n_items'] > 0 ? sendCmd(journey['chat_cmd_id']) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ journey['n_items'] > 0 }
						style="margin-top: 0px; width: 130px; height: 35px; white-space: nowrap; font-size: 12px;">

						{#if !(2 in is_loadings) || is_loadings[2] == false }

						{#if journey['n_items'] > 0 }
							Collect { journey['n_items'] } item{ (journey['n_items'] > 1) ? 's' : '' } ✔️
						{:else}
							<span class="text-electric-collected-grad">Collected!</span>
						{/if}

						{:else}
						<span class="level_pulsing text-electric-white-clock" ><b>....</b> </span>
						{/if}

						</button>
					</div>

				</div>
			</div>
			</div>
			</div>
		</div>

		{:else}
		<br>
		{/if}

		<table border=0><tr><td width=110px>
			<div style="width: 110px; align: left; margin-top: 2px;">
				{#if ($power_avail >= 0) }
					<div class="outer_daily_power">
						<div class="progress_inner_daily_power" style="width: {$power_avail * 100}%; margin-top: 4px; margin-bottom: 5px;" ></div>
					</div>
				{/if}
				</div>
		</td></tr></table>

		<div class="text-green" style="margin-top: 4px; font-size: 12px;" class:no_power={ (mebot_md.power_avail <= 0) }>
			<span style="color: white;"> ⚡ Power available:</span> { mebot_md.power_avail }
		</div>

    <!--<td width=80px align=center>
      <div class="text-electric info" style="white-space: nowrap; margin-top: 14px; font-size: 12px;" >Auto replenish from 🔋</div>
      <div class="text-electric info" style="white-space: nowrap;" >
          <Switch bind:checked={auto_replenish}></Switch>
      </div>
    </td>-->

    </center>

		<div class="snake_row">

			<div class="energy-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (mebot_md.power_bank != 0 ? sendCmd(4) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ mebot_md.power_bank != 0 }
						style="margin-top: 4px; width: 90px; height: 35px; white-space: nowrap; font-size: 12px;">
						{#if !(4 in is_loadings) || is_loadings[4] == false }
						⬆️ Restore
						{:else}
						<span class="level_pulsing"><b>....</b><br> </span>
						{/if}
						</button>
					</div>

				</div>
			</div>
			</div>
			</div>

			<div class="energy-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (mebot_md.power_avail > 0 ? sendCmd(3) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ mebot_md.power_avail > 0 }
						style="margin-top: 4px; width: 90px; height: 35px; white-space: nowrap; font-size: 12px;">
						{#if !(3 in is_loadings) || is_loadings[3] == false }
						Store ⬇️ 
						{:else}
						<span class="level_pulsing"><b>....</b><br> </span>
						{/if}
						</button>
					</div>

				</div>
			</div>
			</div>
			</div>
		</div>

		<center>
		<div class="text-green" style="margin-top: 10px; font-size: 12px;">
			<span style="color: white;">🔋 Power bank:</span>
			{#if ( (3 in is_loadings && is_loadings[3] == true) || (4 in is_loadings && is_loadings[4] == true) ) }
				<span class="level_pulsing1">{ mebot_md.power_bank }</span>
			{:else}
				{ mebot_md.power_bank }
			{/if}
		</div>
		</center>

		<br><br>

		{/if}

		{#if modes.length == 0 }
		<div class="loader" use:loader={content_loading}><br><br></div>
		{/if}

    </center>
	</div>
	{/if}


  {#if show_mebots }
	<div class="main1 gray_bg" on:scroll="{ () => loadOnMebotScroll(document.querySelector('.main1')) }">

    <center>
		<div style="height: 16px;"></div>

		<span on:click={ () => ( showMebots() ) } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

    {#if mebots_loading }
      <br><br><div class="loader" use:loader={content_loading}><br><br></div>
    {/if}

    {#if !mebots_loading }

		<div class="snake_row">

			<div class="mebots-flip-box" >
				<div class="flip-box-inner">
				<div class="m-flip-box-front card">
					<div class="vertical-center" on:click={ () => switchMebot(-1) }>
							<div class="message question" transition:fade|local={{duration: 300}}>
								<img src="https://app.mebots.xyz/img/your_loc_400.png" width=70px height=70px alt="mebot" style="border-radius: 10px;">
								<div class="mebot-byline text-glow-blueish">
									Your current<br>
									location 📍
								</div>
								<!--<button style="width: 36px;" class="menu_btn_home menu_btn_home_inactive menu_btn_center" class:live_pulsing_bg={ show_is_live }>
									<span class:live_pulsing={ show_is_live } class="text-electric" > ⊚ </span>
								</button>-->
								<!--<div data-card-id={i} class="mebot-byline-small text-glow-blueish">
									{#if mebot.badges != null}
										{@html mebot.badges }
									{/if}
								</div>-->
							</div>
							<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
					</div>
				</div>
				</div>
			</div>

			{#each mebots as mebot, i}
			<div class="mebots-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => switchMebot(i) }>
						<div class="message question" transition:fade|local={{duration: 300}} >
							<img data-card-id={i} src="{mebot.img}"
							style=" { ( mebot.hs != '' && mebot.id != mebot_id) ? 'border-radius: 10px; background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url( ' + mebot.hs + '); background-size: cover;' : 'border-radius: 10px;' } "
							class:text-electric-location1={ mebot.id == mebot_id } width=70px height=70px alt="mebot" >
							<div data-card-id={i} class="mebot-byline text-glow-blueish">
								<!--{@html mebot.byline }-->
								{@html mebot.extra }
							</div>
							<!--<div data-card-id={i} class="mebot-byline-small text-glow-blueish">
							{#if mebot.badges != null}
								{@html mebot.badges }
							{/if}
							</div>-->

							{#if mebot.n_items > 0 }
								<span class="energy_items__badge">{ mebot.n_items }</span>
							{/if}

						</div>
						<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
				</div>
			</div>
			</div>
			</div>
			{/each}

		</div>
		{/if}

    </center>
	</div>
	{/if}

</div>

{#if show_chat }
<div class="main1 green_bg" style="background-color: #065c54d1;" on:scroll="{ () => loadOnMebotScroll(document.querySelector('.main1')) }">

  <center>
		<div style="height: 16px;"></div>

		<span on:click={ () => ( chatMebot(false) ) } style="position: absolute; top: 0px; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

    <center>

    <table width=300px cellspacing=0 border=0>

            {#each mebot_chats as mebot, i}
    
            {#if mebot.is_system == 1}
            <tr>
                <td width=20px valign=bottom>
                    <img src="{mebot_url}" width=30px height=30px alt="mebot" style="padding-bottom: 8px;">
                </td>
                <td>
    <!--            <span style="position: relative;">
                    <span class="mebot__badge"> <img src="{mebot_url}" width=30px height=30px alt="mebot"> </span>-->
    
                <table border=0 width=260px on:click={ displayMenu( mebot.msg_id ) }>
                <tr><td>
                    <span class="text-glow-green chat_bubble">
                        {@html mebot.msg }
                    </span>
                </td></tr>
                </table>
    
    <!--            </span>-->
            </td></tr>
            {:else}
            <tr><td align=right colspan=2>
                <table border=0 width=200px><tr><td align=right>
                    <span class="text-glow-green chat_bubble chat_bubble_mine">
                        {@html mebot.msg }
                    </span>
                </td></tr></table>
            </td></tr>
            {/if}

            {/each}
    
    <tr><td align=right colspan=2>
    
    <div class="loader" use:loader={loading}>
    </div>
    
    <br>
    </td></tr>
    
    <tr><td align=right width=280px colspan=2>
    
    <table width=280px border=0>
        <tr>
            <td width=230px>
                <input id="chat_input" class="chat_input" type="text" list="mebot_actions"
                bind:value
                on:keydown={e => keyPressed(e.which)} /> 
    
                <datalist id="mebot_actions">
                <!--            
                    <option value="/Available items">
                    <option value="/Collect items">
                    <option value="/Help">
                    <option value="/Attack">
                 -->
                </datalist>
            </td>
            <td width=50px>
                <div class="buttons">
                    <!--<button on:click={_onCancel}>
                    Clear
                    </button>
                    &nbsp;-->
                    <button class="chat_button" on:click={_onOkay}>
                        &nbsp; ▶ &nbsp;
                    </button> 
                    <!---&nbsp;&nbsp;-->
                </div>
            </td>
        </tr>
    </table>
    </td></tr>
    </table>
    </center>
        <br><br>
    </center>
		<span on:click={ () => ( chatMebot(false) ) } style="position: absolute; right: 0px; z-index: 10003;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>
</div>
{/if}

<!--<table id="listing-group" class="listing-group" style="visibility: hidden;">
  <tr><td><label for="sky-enabled">enabled</label></td><td><input type="checkbox" id="sky-enabled" checked/></td></tr>
  <tr><td><label for="sky-color-picker">sky-color</label></td><td><input type="color" id="sky-color-picker" value="#0000ff" style="width: 100%"/></td></tr>
  <tr><td><label for="horizon-color-picker">horizon-color</label></td><td><input type="color" id="horizon-color-picker" value="#00ff00" style="width: 100%"/></td></tr>
  <tr><td><label for="fog-color-picker">fog-color</label></td><td><input type="color" id="fog-color-picker" value="#ff0000" style="width: 100%"/></td></tr>
  <tr><td><label for="sky-horizon-blend-slider">sky-horizon-blend</label></td><td><input type="range" id="sky-horizon-blend-slider" min="0" max="1" step="0.01" value="0.5" /></td></tr>
  <tr><td><label for="horizon-fog-blend-slider">horizon-fog-blend</label></td><td><input type="range" id="horizon-fog-blend-slider" min="0" max="1" step="0.01" value="0.5" /></td></tr>
  <tr><td><label for="fog-ground-blend-slider">fog-ground-blend</label></td><td><input type="range" id="fog-ground-blend-slider" min="0" max="1" step="0.01" value="0.1" /></td></tr>
</table>-->

<style>

.text-electric {
    text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
      0 0 32px hsla(178, 100%, 63%, 0.98);
    font-family: arial;
    color: hsl(185, 97%, 75%);
}

.menu_btn {
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    color: rgba(255, 255, 255, 1);
    padding: 6px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    z-index: 200;
    font-size: 14px;
}

.menu_btn_home {
    font-size: 24px;
    border-radius: 15px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: rgba(255, 255, 255, 1);
    padding: 9px 6px 3px 6px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    z-index: 200;
}

.terrain_map {
    position: absolute;
    background-color: #88888800;
    top: 100px;
    right: 10px;
    width: 40px;
    height: 40px;
    z-index: 1000;
}

.tunnel_canvas {
    position: absolute;
    background-color: #88888800;
    top: 10px;
    left: 10px;
    width: 50px;
    height: 50px;
    z-index: 10000;
}

.menu_stats {
    position: absolute;
    border: 0px;
    font-size: 10px;
    background-color: #88888800;
    top: 60px;
    right: 10px;
}

.menu_move {
    position: absolute;
    background-color: #88888800;
    top: 200px;
    right: 10px;
    z-index: 200;
}

.menu_jump {
    position: absolute;
    background-color: #018779a1;
    top: 244px;
    right: 10px;
    z-index: 200;
}

.menu_mine {
    position: absolute;
    background-color: #018779a1;
    top: 292px;
    right: 10px;
    z-index: 200;
}

.menu_center {
    position: absolute;
    background-color: #018779a1;
    top: 342px;
    right: 10px;
    z-index: 200;
}

.menu_build {
    position: absolute;
    background-color: #018779a1;
    top: 120px;
    right: 10px;
    z-index: 200;
}

.menu_mouse {
    position: absolute;
    background-color: #888888;
    bottom: 0px;
    left: 0px;
    z-index: 200;
    margin-left: 14px;
    margin-bottom: 18px;
}

.touchpad_close_cl {
  position: absolute; 
  bottom: 0px; 
  left: 0px; 
  margin-bottom: 196px; 
  z-index: 11201;
}

.touchpad_cl {
  background-color: rgba(14, 63, 54, 0.525);
  position: absolute;
  bottom: 0px;
  margin-bottom: 0px;
  z-index: 11198;
  width: 100%;
  height: 250px;
  margin-left: 0%;
  margin-right: 0%;
  border-radius: 10px;
}

.touchpad_canvas_cl {
  position: absolute;
  bottom: 0px;
  margin-bottom: 0px;
  z-index: 11199;
  width: 100%;
  height: 250px;
  margin-left: 0%;
  margin-right: 0%;
  border-radius: 10px;
}

.is_hidden {
  visibility: hidden;
}

.menu_background {
  background-color: rgb(0, 0, 0, 0.4);
  position: absolute;
  bottom: 0px;
  z-index: 100;
  width: 100%;
  height: 60px;
  left: 0px;
  border-radius: 0 0 10px 10px;
}

.menu_mebot {
    position: absolute;
    background-color: #00ead3c5;
    color: black;
    bottom: 0px;
    left: 0px;
    z-index: 200;
    margin-left: 14px;
    margin-bottom: 120px;
}

.enemy_mebot_battle {
    position: absolute;
    background-color: #00ead3c5;
    color: black;
    bottom: 0px;
    left: 50px;
    z-index: 200;
    margin-right: 14px;
    margin-bottom: 100px;
}
.my_mebot_battle {
    position: absolute;
    background-color: #00ead3c5;
    color: black;
    bottom: 0px;
    right: 40px;
    z-index: 200;
    margin-right: 14px;
    margin-bottom: 100px;
}

.menu_extra {
    position: absolute;
    background-color: #00ead3c5;
    color: black;
    bottom: 0px;
    left: 0px;
    z-index: 200;
    margin-left: 14px;
    margin-bottom: 70px;
}

.menu_challenge {
    position: absolute;
    background-color: #00ead3c5;
    bottom: 0px;
    z-index: 200;
    margin-left: 45%;
    margin-right: auto;
    margin-bottom: 70px;
}
.menu_talk_to {
    position: absolute;
    background-color: #00ead3c5;
    bottom: 0px;
    z-index: 200;
    margin-left: 14px;
    margin-right: auto;
    margin-bottom: 70px;
}

.menu_journey {
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 200;
    margin-left: 14px;
    margin-bottom: 70px;
}

.menu_power {
    background-color: rgb(0, 0, 0, 0.4);
    border-radius: 10px 10px 0 0;
    position: absolute;
    bottom: 0px;
    right: 0px;
    margin-right: 0px;
    margin-bottom: 60px;
    z-index: 200;
}

.menu_power_big {
    border-radius: 10px 10px 0 0;
    position: absolute;
    bottom: 0px;
    right: 0px;
    margin-right: 0px;
    margin-bottom: 210px;
    z-index: 20000;
}

.steps-electric {
  text-shadow: 0 0 10px rgb(11, 14, 14),
      0 10 32px rgb(2, 8, 8);
  font-family: arial;
  color: hsl(169, 100%, 82%);
}

.steps_left {
    position: absolute;
    color: #2a7367c5;
    bottom: 0px;
    left: 77%;
    z-index: 200;
    margin-left: 14px;
    margin-bottom: 24px;
    white-space: nowrap;
}
.current_fps {
      left: 84%;
      bottom: 7%;
      white-space: nowrap;
}
.swipe_angle {
      left: 62%;
      bottom: 7%;
      white-space: nowrap;
}
.battery_energy {
  left: 61%;
}
.sparks_energy {
  left: 41%;
}

.menu_extra-full {
    bottom: 10%;
}

.mebots__badge {
		background-color: rgb(20, 20, 20);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
}

.menu_cmd_center {
  position: absolute;
  background-color: #00ead3c5;
  top: 150px;
  right: 10px;
  z-index: 200;
}

.menu_btn_mebots {
  position: absolute;
  background-color: #00ead3c5;
  top: 100px;
  right: 10px;
  z-index: 200;
}

.menu_btn_artifacts {
  position: absolute;
  background-color: #00ead3c5;
  top: 100px;
  left: 12px;
  z-index: 200;
}

.menu_throw_old {
    position: absolute;
    background-color: #018779a1;
    top: 150px;
    left: 12px;
    z-index: 200;
}

.menu_throw {
  position: absolute;
  background-color: #018779a1;
  color: black;
  top: 0px;
  left: 12px;
  z-index: 200;
  margin-right: 14px;
  margin-top: 414px;
}

.menu_pov {
    position: absolute;
    background-color: #018779;
    bottom: 12px;
    right: 10px;
    z-index: 200;
}

.menu_btn_active {
		background-color: #00ead3;
}

.menu_btn_active2 {
		background-color: #ffffff;
}

canvas {
    position: absolute;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -webkit-crisp-edges; /* Webkit (Safari) */
    image-rendering: pixelated; /* Chrome */
}

.square-world {
  height: 450px;
	width: 340px;
}

.full_screen-world {
  height: 90%;
  width: 100%;
}

.grayed_out {
  opacity: 0.3;
}

.main1-square {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		display: inline;
		border-radius: 10px;
		background-color: #2382cff5;
    background-image: url("/img/clouds.png");
		overflow-x: hidden;
		overflow-y: hidden;
		text-align: left;
		padding: 0px;
		overscroll-behavior: none;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 100;
	}

.main1-square::-webkit-scrollbar {
		display: none;
}

.modes-main1-square {
    position: absolute;
		margin-left: auto;
		margin-right: auto;
		display: inline;
		border-radius: 10px;
		background-color: #051420c9;
    height: 90%;
		width: 100%;
    top: 0px;
    right: 0px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 20002;
}

.modes-main1-square::-webkit-scrollbar {
		display: none;
}

.modal-main1 {
    position: absolute;
		border-radius: 10px;
		background-color: #051420c9;
    margin-top: 0px;
    height: 100%;
		width: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 20002;
}

.modal-main1::-webkit-scrollbar {
		display: none;
}


.blue_bg {
  background-color: #0b2d49f5;
}

.gray_bg {
  background-color: #26333ef5;
}

.green_bg {
  background-color: #065c53e5;
}

.pink_bg {
  background-color: #7f3b7fe6;
}

.main1 {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		display: inline;
		border-radius: 10px;
    height: 90%;
		width: 100%;
    top: 0px;
    right: 0px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 20002;
}

.main1::-webkit-scrollbar {
		display: none;
}

.fullscreen {
    position: absolute;
    float: left;
    display: block;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    z-index: 1000;
}

h1 {
  font-size: 3em;
}

#info {
  position: absolute;
  font-family: sans-serif;
  font-size: 24px;
  right: 0;
  bottom: 0;
  color: white;
  margin: 8px;
}

#toolbar-container {
  position: fixed;
  bottom: 8px;
  width: 100%;

  display: flex;
  justify-content: center;
}

#toolbar {
  background-color: rgb(109, 109, 109);
  border: 4px solid rgb(147, 147, 147);
  padding: 8px;
  display: flex;
  justify-content: space-between;
  column-gap: 12px;
}

.toolbar-icon {
  width: 64px;
  height: 64px;
  outline: 4px solid rgb(58, 58, 58);;
}

.toolbar-icon.selected {
  outline: 4px solid white;
}

#overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #00000080;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 2em;
  color: white;
  text-align: center;
}

#status {
  position: fixed;
  bottom: 8px;
  left: 8px;
  font-size: 2em;
  color: white;
}

.snake_row {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		justify-content: center;
		margin-bottom: 10px;
		background-size: contain;
		overscroll-behavior: none;
}

.mebots-flip-box {
		background-color: transparent;
		width: 95px;
		height: 130px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
}

.card {
		border-radius: 4px;
		color: rgb(216, 79, 0);
		box-shadow: 0 4px 8px 0 rgba(189, 140, 104, 0.2);
}

.mebot-byline {
		font-size: 10px;
}

.text-glow-blueish {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: hsl(185, 97%, 75%);
}

.message {
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
}

.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9),
			0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
}

.energy_items__badge {
		background-color: #03f34f;
		border-radius: 5px;
		border: 0px solid white;
		color: rgb(0, 0, 0);
		box-shadow: 0 0 8px rgb(220, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
}

.text-electric-location1 {
	background-color: #00d9ff;
}

.artifact_has_asset_throw {
	background-color: #00d9ff66;
}

.artifact_active {
	background-color: #00d9fff8;
}

.text-electric-collected-grad {
		text-shadow: 0 0 5px rgb(0, 97, 81),
			0 0 8px rgb(0, 97, 81);
		font-family: arial;
		-webkit-animation: color_chage 2s normal forwards ease-in-out;
		-moz-animation: color_chage 2s normal forwards ease-in-out;
		-o-animation: color_chage 2s normal forwards ease-in-out;
		animation: color_chage 2s normal forwards ease-in-out;
}
@keyframes color_chage {
		0% {color: #e6e6db;}
		100% {color: #1bffe8c9;}
}

.menu_btn_mebots_rounded {
		font-size: 14px;
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.vertical-center {
		margin: 0;
		position: absolute;
		top: 56%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
}

.mebots-flip-box {
		background-color: transparent;
		width: 95px;
		height: 130px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
}
.mebot-byline {
		font-size: 10px;
}
.text-glow-blueish {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: hsl(185, 97%, 75%);
}

.modes-flip-box {
		background-color: transparent;
		width: 90px;
		height: 76px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
}

.energy-flip-box {
		background-color: transparent;
		width: 102px;
		height: 90px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
}

.energy-collect-flip-box {
		background-color: transparent;
		width: 130px;
		height: 90px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
}

.outer_daily_power {
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
}

.menu_btn_join {
    margin-top: 2px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: rgba(255, 255, 255, 1);
    padding: 8px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    z-index: 30000;
}
.join-active {
  background: linear-gradient(114deg, #42fff91e, #42e3ff, #42e3ffff);
	background-size: 800% 800%;

	-webkit-animation: AnimationName 4s ease infinite;
	-moz-animation: AnimationName 4s ease infinite;
	-o-animation: AnimationName 4s ease infinite;
	animation: AnimationName 4s ease infinite;

	@-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
}
@-moz-keyframes AnimationName {
	0%{background-position:0% 71%}
	50%{background-position:100% 30%}
	100%{background-position:0% 71%}
}
@-o-keyframes AnimationName {
	0%{background-position:0% 71%}
	50%{background-position:100% 30%}
	100%{background-position:0% 71%}
}
	@keyframes AnimationName {
	0%{background-position:0% 71%}
	50%{background-position:100% 30%}
	100%{background-position:0% 71%}
}

.progress_inner_daily_power {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(255, 255, 0), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
}

.menu_mebots_mode_active {
		background-color: #028dff;
}

.menu_mebots_state_active {
		background-color: #03b9a6;
}

.menu_mebots_energy_active {
		background-color: #03f34fd3;
}

.level_pulsing1 {
		animation: zombie-fight1 0.4s infinite;
}
@keyframes zombie-fight1 {
	0% {
		color: hsl(185, 97%, 75%);
	}

	10% {
		color: hsla(167, 97%, 75%, 0);
	}

	100% {
		color: hsl(185, 97%, 75%);
	}
}

.text-green {
		color: #1bffe8ee;
}

.no_power {
  color: hsl(3, 81%, 46%);
  text-shadow: 0 0 10px rgb(116, 60, 60),
      0 10 32px rgb(241, 95, 58);
}

.text-electric-white-clock {
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 20px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: rgb(230, 230, 219);
}

.claim_active {

background: linear-gradient(114deg, #42e3ffee, rgb(109, 34, 0), #42e3ffee);
background-size: 800% 800%;
}

.claim_active1 {

-webkit-animation: AnimationName 2s  ;
-moz-animation: AnimationName 2s  ;
-o-animation: AnimationName 2s  ;
animation: AnimationName 2s ;
}
@-webkit-keyframes AnimationName {
0%{background-position:0% 71%}
50%{background-position:100% 30%}
100%{background-position:0% 71%}
}
@-moz-keyframes AnimationName {
0%{background-position:0% 71%}
50%{background-position:100% 30%}
100%{background-position:0% 71%}
}
@-o-keyframes AnimationName {
0%{background-position:0% 71%}
50%{background-position:100% 30%}
100%{background-position:0% 71%}
}
@keyframes AnimationName {
0%{background-position:0% 71%}
50%{background-position:100% 30%}
100%{background-position:0% 71%}
}

.outer_daily_power_enemy{
    position: absolute;
    z-index: 10002;
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(255, 0, 0), 0 0 12px rgb(255, 191, 191);
		height: 2px;
		border-radius: 0px;
    bottom: 0px;
    left: 50px;
    z-index: 200;
    margin-right: 14px;
    margin-bottom: 150px;
}

.progress_inner_daily_power_enemy {
    bottom: 0px;
    left: 50px;
    z-index: 200;
    margin-right: 14px;
    margin-bottom: 150px;
		background-color: #ff0000;
    box-shadow: 0 0 8px rgb(208, 69, 69), 0 0 20px rgba(130, 132, 132, 0.819);
		display: block;
		height: 2px;
		border-radius: 0px;
}

.habitat_lg {
  border: 1px solid rgb(83, 83, 83);
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
  z-index: 200;
  width: 82px;
  height: 82px;
  touch-action: manipulation;
  user-select: none;
}

input {
    width: 100%;
}

.buttons {
    display: flex;
    justify-content: space-between;
}

.chat_button {
    color: white;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.501);
    background-color: #016c8a;
    white-space: nowrap;
    height: 38px;
}

.text-glow-green {
	text-shadow: 0 0 10px rgb(0, 255, 255), 0 0 32px rgba(0, 117, 117, 0.819);
	font-family: arial;
	color: #1bffe8ee;
}

.chat_input {
    border-radius: 10px;
    border: 1px solid #1bffe880;
    color: white;
    background-color: rgba(0, 70, 114, 0.39);
    width: 230px;
    height: 38px;
}

.chat_bubble {
    background-color: rgba(0, 24, 39, 0.6);
    border-radius: 10px;
    border: 1px solid rgb(83, 83, 83);
    box-shadow: 0 1px 10px rgba(50, 255, 241, 0.504);
    padding: 10px;
    margin-bottom: 6px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
}

.chat_bubble_mine {
    background-color: rgba(0, 70, 114, 0.6);
    box-shadow: 0 1px 10px rgba(50, 187, 255, 0.504);
    justify-content: flex-end;
}

.artifact-flip-box {
		background-color: transparent;
		width: 58px;
		height: 80px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
}
.artifact-card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
}
.artifact__badge {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 6px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: 0;
		right: 2px;
}
.artifact__badge_lg {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -2px;
		right: 0px;
}

</style>